(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired558"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired558"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c3IU8", function(module, exports) {

$parcel$export(module.exports, "hasHouseNumber", function () { return $07cb4332db5da4e8$export$6f0742d901b3bc44; });
/**
 * Whether a street address carries a house number — one rule for the inline
 * check (houseNumber.ts) and for when an address search may start on its own
 * (addressAutocomplete.ts).
 *
 * A house number is a run of digits, optionally with a letter ("12", "96a",
 * "12 High Street"), that is not followed by a full stop and a word: Slovenian
 * street names carry ordinals — "Ulica 1. maja", "Cesta 24. junija", "Cesta 9.
 * korpusa" — and those are part of the name. A stray full stop after the house
 * number itself ("Stara Vrhnika 9.") still counts. Slovenia also registers houses
 * without a number as "b. š." (brez številke), accepted as one.
 */ function $07cb4332db5da4e8$export$6f0742d901b3bc44(value) {
    return /(^|\D)\d+(?!\d)(?!\s*\.\s*\p{L})/u.test(value) || /(^|[\s,(])b\.?\s*š\.?(?=[\s,)]|$)/iu.test(value);
}

});

parcelRegister("5cDU9", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !!timeScale; // as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, reverseEase = vars.easeReverse || yoyoEase, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._rEase = reverseEase && (_parseEase(reverseEase) || tween._ease);
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (tween._from) tween.ratio = 1;
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) // from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset. Try splitting into individual properties") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            var easeReverse = vars.easeReverse || vars.yoyoEase;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    easeReverse && (copy.easeReverse = easeReverse);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) time = dur - time;
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) //repeatRefresh functionality
                {
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            if (this._rEase) {
                var inv = time < prevTime;
                if (inv !== this._inv) {
                    var segDur = inv ? prevTime : dur - prevTime;
                    this._inv = inv;
                    if (this._from) this.ratio = 1 - this.ratio;
                    this._invRatio = this.ratio;
                    this._invTime = prevTime;
                    this._invRecip = segDur ? (inv ? -1 : 1) / segDur : 0;
                    this._invScale = inv ? -this.ratio : 1 - this.ratio;
                    this._invEase = inv ? this._rEase : this._ease;
                }
                this.ratio = ratio = this._invRatio + this._invScale * this._invEase((time - this._invTime) * this._invRecip);
            } else this.ratio = ratio = this._ease(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.15.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

function $45b36222076a8936$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $45b36222076a8936$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $45b36222076a8936$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $45b36222076a8936$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $45b36222076a8936$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $45b36222076a8936$var$CREATED = 1;
var $45b36222076a8936$var$MOUNTED = 2;
var $45b36222076a8936$var$IDLE = 3;
var $45b36222076a8936$var$MOVING = 4;
var $45b36222076a8936$var$SCROLLING = 5;
var $45b36222076a8936$var$DRAGGING = 6;
var $45b36222076a8936$var$DESTROYED = 7;
var $45b36222076a8936$var$STATES = {
    CREATED: $45b36222076a8936$var$CREATED,
    MOUNTED: $45b36222076a8936$var$MOUNTED,
    IDLE: $45b36222076a8936$var$IDLE,
    MOVING: $45b36222076a8936$var$MOVING,
    SCROLLING: $45b36222076a8936$var$SCROLLING,
    DRAGGING: $45b36222076a8936$var$DRAGGING,
    DESTROYED: $45b36222076a8936$var$DESTROYED
};
function $45b36222076a8936$var$empty(array) {
    array.length = 0;
}
function $45b36222076a8936$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $45b36222076a8936$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($45b36222076a8936$var$slice(arguments, 1)));
}
var $45b36222076a8936$var$nextTick = setTimeout;
var $45b36222076a8936$var$noop = function noop() {};
function $45b36222076a8936$var$raf(func) {
    return requestAnimationFrame(func);
}
function $45b36222076a8936$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $45b36222076a8936$var$isObject(subject) {
    return !$45b36222076a8936$var$isNull(subject) && $45b36222076a8936$var$typeOf("object", subject);
}
var $45b36222076a8936$var$isArray = Array.isArray;
var $45b36222076a8936$var$isFunction = $45b36222076a8936$var$apply($45b36222076a8936$var$typeOf, "function");
var $45b36222076a8936$var$isString = $45b36222076a8936$var$apply($45b36222076a8936$var$typeOf, "string");
var $45b36222076a8936$var$isUndefined = $45b36222076a8936$var$apply($45b36222076a8936$var$typeOf, "undefined");
function $45b36222076a8936$var$isNull(subject) {
    return subject === null;
}
function $45b36222076a8936$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $45b36222076a8936$var$toArray(value) {
    return $45b36222076a8936$var$isArray(value) ? value : [
        value
    ];
}
function $45b36222076a8936$var$forEach(values, iteratee) {
    $45b36222076a8936$var$toArray(values).forEach(iteratee);
}
function $45b36222076a8936$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $45b36222076a8936$var$push(array, items) {
    array.push.apply(array, $45b36222076a8936$var$toArray(items));
    return array;
}
function $45b36222076a8936$var$toggleClass(elm, classes, add) {
    if (elm) $45b36222076a8936$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $45b36222076a8936$var$addClass(elm, classes) {
    $45b36222076a8936$var$toggleClass(elm, $45b36222076a8936$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $45b36222076a8936$var$append(parent, children) {
    $45b36222076a8936$var$forEach(children, parent.appendChild.bind(parent));
}
function $45b36222076a8936$var$before(nodes, ref) {
    $45b36222076a8936$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $45b36222076a8936$var$matches(elm, selector) {
    return $45b36222076a8936$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $45b36222076a8936$var$children(parent, selector) {
    var children2 = parent ? $45b36222076a8936$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $45b36222076a8936$var$matches(child, selector);
    }) : children2;
}
function $45b36222076a8936$var$child(parent, selector) {
    return selector ? $45b36222076a8936$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $45b36222076a8936$var$ownKeys = Object.keys;
function $45b36222076a8936$var$forOwn(object, iteratee, right) {
    if (object) (right ? $45b36222076a8936$var$ownKeys(object).reverse() : $45b36222076a8936$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $45b36222076a8936$var$assign(object) {
    $45b36222076a8936$var$slice(arguments, 1).forEach(function(source) {
        $45b36222076a8936$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $45b36222076a8936$var$merge(object) {
    $45b36222076a8936$var$slice(arguments, 1).forEach(function(source) {
        $45b36222076a8936$var$forOwn(source, function(value, key) {
            if ($45b36222076a8936$var$isArray(value)) object[key] = value.slice();
            else if ($45b36222076a8936$var$isObject(value)) object[key] = $45b36222076a8936$var$merge({}, $45b36222076a8936$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $45b36222076a8936$var$omit(object, keys) {
    $45b36222076a8936$var$forEach(keys || $45b36222076a8936$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $45b36222076a8936$var$removeAttribute(elms, attrs) {
    $45b36222076a8936$var$forEach(elms, function(elm) {
        $45b36222076a8936$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $45b36222076a8936$var$setAttribute(elms, attrs, value) {
    if ($45b36222076a8936$var$isObject(attrs)) $45b36222076a8936$var$forOwn(attrs, function(value2, name) {
        $45b36222076a8936$var$setAttribute(elms, name, value2);
    });
    else $45b36222076a8936$var$forEach(elms, function(elm) {
        $45b36222076a8936$var$isNull(value) || value === "" ? $45b36222076a8936$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $45b36222076a8936$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $45b36222076a8936$var$isString(attrs) ? $45b36222076a8936$var$addClass(elm, attrs) : $45b36222076a8936$var$setAttribute(elm, attrs);
    parent && $45b36222076a8936$var$append(parent, elm);
    return elm;
}
function $45b36222076a8936$var$style(elm, prop, value) {
    if ($45b36222076a8936$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$45b36222076a8936$var$isNull(value)) elm.style[prop] = "" + value;
}
function $45b36222076a8936$var$display(elm, display2) {
    $45b36222076a8936$var$style(elm, "display", display2);
}
function $45b36222076a8936$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $45b36222076a8936$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $45b36222076a8936$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $45b36222076a8936$var$rect(target) {
    return target.getBoundingClientRect();
}
function $45b36222076a8936$var$remove(nodes) {
    $45b36222076a8936$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $45b36222076a8936$var$parseHtml(html) {
    return $45b36222076a8936$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $45b36222076a8936$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $45b36222076a8936$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $45b36222076a8936$var$queryAll(parent, selector) {
    return selector ? $45b36222076a8936$var$slice(parent.querySelectorAll(selector)) : [];
}
function $45b36222076a8936$var$removeClass(elm, classes) {
    $45b36222076a8936$var$toggleClass(elm, classes, false);
}
function $45b36222076a8936$var$timeOf(e) {
    return e.timeStamp;
}
function $45b36222076a8936$var$unit(value) {
    return $45b36222076a8936$var$isString(value) ? value : value ? value + "px" : "";
}
var $45b36222076a8936$var$PROJECT_CODE = "splide";
var $45b36222076a8936$var$DATA_ATTRIBUTE = "data-" + $45b36222076a8936$var$PROJECT_CODE;
function $45b36222076a8936$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $45b36222076a8936$var$PROJECT_CODE + "] " + (message || ""));
}
var $45b36222076a8936$var$min = Math.min, $45b36222076a8936$var$max = Math.max, $45b36222076a8936$var$floor = Math.floor, $45b36222076a8936$var$ceil = Math.ceil, $45b36222076a8936$var$abs = Math.abs;
function $45b36222076a8936$var$approximatelyEqual(x, y, epsilon) {
    return $45b36222076a8936$var$abs(x - y) < epsilon;
}
function $45b36222076a8936$var$between(number, x, y, exclusive) {
    var minimum = $45b36222076a8936$var$min(x, y);
    var maximum = $45b36222076a8936$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $45b36222076a8936$var$clamp(number, x, y) {
    var minimum = $45b36222076a8936$var$min(x, y);
    var maximum = $45b36222076a8936$var$max(x, y);
    return $45b36222076a8936$var$min($45b36222076a8936$var$max(minimum, number), maximum);
}
function $45b36222076a8936$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $45b36222076a8936$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $45b36222076a8936$var$format(string, replacements) {
    $45b36222076a8936$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $45b36222076a8936$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $45b36222076a8936$var$ids = {};
function $45b36222076a8936$var$uniqueId(prefix) {
    return "" + prefix + $45b36222076a8936$var$pad($45b36222076a8936$var$ids[prefix] = ($45b36222076a8936$var$ids[prefix] || 0) + 1);
}
function $45b36222076a8936$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $45b36222076a8936$var$forEach(targets, function(target) {
            target && $45b36222076a8936$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $45b36222076a8936$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $45b36222076a8936$export$d300dc1a2634364b = "mounted";
var $45b36222076a8936$export$d8dac49b4532735a = "ready";
var $45b36222076a8936$export$2aa493d7c3275167 = "move";
var $45b36222076a8936$export$fe5802204b967f0d = "moved";
var $45b36222076a8936$export$5adb665701eda1ce = "click";
var $45b36222076a8936$export$92e3eae133acac4c = "active";
var $45b36222076a8936$export$6bcbb81035c12cea = "inactive";
var $45b36222076a8936$export$6a5b3445e4066a53 = "visible";
var $45b36222076a8936$export$8c5c7a21d54563e9 = "hidden";
var $45b36222076a8936$export$7f4701ac5e05e39f = "refresh";
var $45b36222076a8936$export$db40ab7c0855fa5c = "updated";
var $45b36222076a8936$export$7e019dae5103a285 = "resize";
var $45b36222076a8936$export$d637eba1e9e28482 = "resized";
var $45b36222076a8936$export$e84bf5065c9087ac = "drag";
var $45b36222076a8936$export$8e9f636d2c722196 = "dragging";
var $45b36222076a8936$export$90ea576bd3fdeb60 = "dragged";
var $45b36222076a8936$export$49801896908b5e33 = "scroll";
var $45b36222076a8936$export$ff8164bff3202b9 = "scrolled";
var $45b36222076a8936$export$6cbac5b662a31e1b = "overflow";
var $45b36222076a8936$export$88c4cf7419e470cd = "destroy";
var $45b36222076a8936$export$8647f6b043e04e9d = "arrows:mounted";
var $45b36222076a8936$export$d467f9343b961f75 = "arrows:updated";
var $45b36222076a8936$export$bf89a4e4349c9778 = "pagination:mounted";
var $45b36222076a8936$export$eb2019082ed6de0b = "pagination:updated";
var $45b36222076a8936$export$84015c33508f94ec = "navigation:mounted";
var $45b36222076a8936$export$23663268a31b79e2 = "autoplay:play";
var $45b36222076a8936$export$185723258309b608 = "autoplay:playing";
var $45b36222076a8936$export$16a1e4f3d0368265 = "autoplay:pause";
var $45b36222076a8936$export$9f64346e17f0ec8e = "lazyload:loaded";
var $45b36222076a8936$export$6d5af59619d10e6a = "sk";
var $45b36222076a8936$export$f0af896383d5adff = "sh";
var $45b36222076a8936$export$28dea85f216954dc = "ei";
function $45b36222076a8936$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $45b36222076a8936$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $45b36222076a8936$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $45b36222076a8936$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $45b36222076a8936$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($45b36222076a8936$export$88c4cf7419e470cd, binder.destroy);
    return $45b36222076a8936$var$assign(binder, {
        bus: bus,
        on: on,
        off: $45b36222076a8936$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $45b36222076a8936$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $45b36222076a8936$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $45b36222076a8936$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $45b36222076a8936$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $45b36222076a8936$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $45b36222076a8936$var$includes($45b36222076a8936$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $45b36222076a8936$export$efff0f5979573c99(func, duration) {
    var interval = $45b36222076a8936$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $45b36222076a8936$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $45b36222076a8936$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $45b36222076a8936$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $45b36222076a8936$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($45b36222076a8936$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $45b36222076a8936$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $45b36222076a8936$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($45b36222076a8936$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $45b36222076a8936$var$merge(options, reducedMotion) : $45b36222076a8936$var$omit(options, $45b36222076a8936$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $45b36222076a8936$var$merge(options, opts);
        base && $45b36222076a8936$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($45b36222076a8936$var$CREATED)) Splide2.emit($45b36222076a8936$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $45b36222076a8936$var$ARROW = "Arrow";
var $45b36222076a8936$var$ARROW_LEFT = $45b36222076a8936$var$ARROW + "Left";
var $45b36222076a8936$var$ARROW_RIGHT = $45b36222076a8936$var$ARROW + "Right";
var $45b36222076a8936$var$ARROW_UP = $45b36222076a8936$var$ARROW + "Up";
var $45b36222076a8936$var$ARROW_DOWN = $45b36222076a8936$var$ARROW + "Down";
var $45b36222076a8936$export$373e92e0788ff06e = "ltr";
var $45b36222076a8936$export$850f7749a2909601 = "rtl";
var $45b36222076a8936$export$97170d9824b89709 = "ttb";
var $45b36222076a8936$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $45b36222076a8936$var$ARROW_UP,
        $45b36222076a8936$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $45b36222076a8936$var$ARROW_DOWN,
        $45b36222076a8936$var$ARROW_LEFT
    ]
};
function $45b36222076a8936$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $45b36222076a8936$export$850f7749a2909601 && !axisOnly ? 1 : direction === $45b36222076a8936$export$97170d9824b89709 ? 0 : -1;
        return $45b36222076a8936$var$ORIENTATION_MAP[prop] && $45b36222076a8936$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $45b36222076a8936$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $45b36222076a8936$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $45b36222076a8936$var$ROLE = "role";
var $45b36222076a8936$var$TAB_INDEX = "tabindex";
var $45b36222076a8936$var$DISABLED = "disabled";
var $45b36222076a8936$var$ARIA_PREFIX = "aria-";
var $45b36222076a8936$var$ARIA_CONTROLS = $45b36222076a8936$var$ARIA_PREFIX + "controls";
var $45b36222076a8936$var$ARIA_CURRENT = $45b36222076a8936$var$ARIA_PREFIX + "current";
var $45b36222076a8936$var$ARIA_SELECTED = $45b36222076a8936$var$ARIA_PREFIX + "selected";
var $45b36222076a8936$var$ARIA_LABEL = $45b36222076a8936$var$ARIA_PREFIX + "label";
var $45b36222076a8936$var$ARIA_LABELLEDBY = $45b36222076a8936$var$ARIA_PREFIX + "labelledby";
var $45b36222076a8936$var$ARIA_HIDDEN = $45b36222076a8936$var$ARIA_PREFIX + "hidden";
var $45b36222076a8936$var$ARIA_ORIENTATION = $45b36222076a8936$var$ARIA_PREFIX + "orientation";
var $45b36222076a8936$var$ARIA_ROLEDESCRIPTION = $45b36222076a8936$var$ARIA_PREFIX + "roledescription";
var $45b36222076a8936$var$ARIA_LIVE = $45b36222076a8936$var$ARIA_PREFIX + "live";
var $45b36222076a8936$var$ARIA_BUSY = $45b36222076a8936$var$ARIA_PREFIX + "busy";
var $45b36222076a8936$var$ARIA_ATOMIC = $45b36222076a8936$var$ARIA_PREFIX + "atomic";
var $45b36222076a8936$var$ALL_ATTRIBUTES = [
    $45b36222076a8936$var$ROLE,
    $45b36222076a8936$var$TAB_INDEX,
    $45b36222076a8936$var$DISABLED,
    $45b36222076a8936$var$ARIA_CONTROLS,
    $45b36222076a8936$var$ARIA_CURRENT,
    $45b36222076a8936$var$ARIA_LABEL,
    $45b36222076a8936$var$ARIA_LABELLEDBY,
    $45b36222076a8936$var$ARIA_HIDDEN,
    $45b36222076a8936$var$ARIA_ORIENTATION,
    $45b36222076a8936$var$ARIA_ROLEDESCRIPTION
];
var $45b36222076a8936$var$CLASS_PREFIX = $45b36222076a8936$var$PROJECT_CODE + "__";
var $45b36222076a8936$var$STATUS_CLASS_PREFIX = "is-";
var $45b36222076a8936$export$93b21159ad85c843 = $45b36222076a8936$var$PROJECT_CODE;
var $45b36222076a8936$export$7738b09ac0a98952 = $45b36222076a8936$var$CLASS_PREFIX + "track";
var $45b36222076a8936$export$19cc2a5451235cae = $45b36222076a8936$var$CLASS_PREFIX + "list";
var $45b36222076a8936$export$8d922915837a38d3 = $45b36222076a8936$var$CLASS_PREFIX + "slide";
var $45b36222076a8936$export$2c1ba4a4f1aa4947 = $45b36222076a8936$export$8d922915837a38d3 + "--clone";
var $45b36222076a8936$export$e9ba7e444ba60a12 = $45b36222076a8936$export$8d922915837a38d3 + "__container";
var $45b36222076a8936$export$a26cbd955fecf11e = $45b36222076a8936$var$CLASS_PREFIX + "arrows";
var $45b36222076a8936$export$516e7d18e13a2dca = $45b36222076a8936$var$CLASS_PREFIX + "arrow";
var $45b36222076a8936$export$58ea3db24c33b76 = $45b36222076a8936$export$516e7d18e13a2dca + "--prev";
var $45b36222076a8936$export$4885afd7098a65c2 = $45b36222076a8936$export$516e7d18e13a2dca + "--next";
var $45b36222076a8936$export$cbf8e5a0ab95eda3 = $45b36222076a8936$var$CLASS_PREFIX + "pagination";
var $45b36222076a8936$export$52f2cca6a5eee805 = $45b36222076a8936$export$cbf8e5a0ab95eda3 + "__page";
var $45b36222076a8936$export$4c82dc32b1c4ace5 = $45b36222076a8936$var$CLASS_PREFIX + "progress";
var $45b36222076a8936$export$2c9b091c749f4409 = $45b36222076a8936$export$4c82dc32b1c4ace5 + "__bar";
var $45b36222076a8936$export$a29701deef84b825 = $45b36222076a8936$var$CLASS_PREFIX + "toggle";
var $45b36222076a8936$export$d9d247d51b430dbb = $45b36222076a8936$export$a29701deef84b825 + "__play";
var $45b36222076a8936$export$3529f201a419925b = $45b36222076a8936$export$a29701deef84b825 + "__pause";
var $45b36222076a8936$export$3e5381ee3fab8374 = $45b36222076a8936$var$CLASS_PREFIX + "spinner";
var $45b36222076a8936$export$bb78d7c200da8960 = $45b36222076a8936$var$CLASS_PREFIX + "sr";
var $45b36222076a8936$export$7761661e2d5b9388 = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "initialized";
var $45b36222076a8936$export$72d36ecf3758cb4b = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "active";
var $45b36222076a8936$export$e423ac4972f5e196 = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "prev";
var $45b36222076a8936$export$457a2d20827a2779 = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "next";
var $45b36222076a8936$export$53ca4621bbab9a = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "visible";
var $45b36222076a8936$export$d22ec4ccb7996ba2 = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "loading";
var $45b36222076a8936$export$b6f202a162a09100 = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "focus-in";
var $45b36222076a8936$export$cd908cd1dd625e29 = $45b36222076a8936$var$STATUS_CLASS_PREFIX + "overflow";
var $45b36222076a8936$export$49f9eaea10ebf193 = [
    $45b36222076a8936$export$72d36ecf3758cb4b,
    $45b36222076a8936$export$53ca4621bbab9a,
    $45b36222076a8936$export$e423ac4972f5e196,
    $45b36222076a8936$export$457a2d20827a2779,
    $45b36222076a8936$export$d22ec4ccb7996ba2,
    $45b36222076a8936$export$b6f202a162a09100,
    $45b36222076a8936$export$cd908cd1dd625e29
];
var $45b36222076a8936$export$ba41d43e4a419565 = {
    slide: $45b36222076a8936$export$8d922915837a38d3,
    clone: $45b36222076a8936$export$2c1ba4a4f1aa4947,
    arrows: $45b36222076a8936$export$a26cbd955fecf11e,
    arrow: $45b36222076a8936$export$516e7d18e13a2dca,
    prev: $45b36222076a8936$export$58ea3db24c33b76,
    next: $45b36222076a8936$export$4885afd7098a65c2,
    pagination: $45b36222076a8936$export$cbf8e5a0ab95eda3,
    page: $45b36222076a8936$export$52f2cca6a5eee805,
    spinner: $45b36222076a8936$export$3e5381ee3fab8374
};
function $45b36222076a8936$var$closest(from, selector) {
    if ($45b36222076a8936$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($45b36222076a8936$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $45b36222076a8936$var$FRICTION = 5;
var $45b36222076a8936$var$LOG_INTERVAL = 200;
var $45b36222076a8936$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $45b36222076a8936$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $45b36222076a8936$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $45b36222076a8936$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($45b36222076a8936$export$7f4701ac5e05e39f, destroy);
        on($45b36222076a8936$export$7f4701ac5e05e39f, setup);
        on($45b36222076a8936$export$db40ab7c0855fa5c, update);
        bind(document, $45b36222076a8936$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $45b36222076a8936$var$toggleClass(root, $45b36222076a8936$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $45b36222076a8936$var$ALL_ATTRIBUTES.concat("style");
        $45b36222076a8936$var$empty(slides);
        $45b36222076a8936$var$removeClass(root, rootClasses);
        $45b36222076a8936$var$removeClass(track, trackClasses);
        $45b36222076a8936$var$removeAttribute([
            track,
            list
        ], attrs);
        $45b36222076a8936$var$removeAttribute(root, completely ? attrs : [
            "style",
            $45b36222076a8936$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $45b36222076a8936$var$removeClass(root, rootClasses);
        $45b36222076a8936$var$removeClass(track, trackClasses);
        rootClasses = getClasses($45b36222076a8936$export$93b21159ad85c843);
        trackClasses = getClasses($45b36222076a8936$export$7738b09ac0a98952);
        $45b36222076a8936$var$addClass(root, rootClasses);
        $45b36222076a8936$var$addClass(track, trackClasses);
        $45b36222076a8936$var$setAttribute(root, $45b36222076a8936$var$ARIA_LABEL, options.label);
        $45b36222076a8936$var$setAttribute(root, $45b36222076a8936$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $45b36222076a8936$export$7738b09ac0a98952);
        list = $45b36222076a8936$var$child(track, "." + $45b36222076a8936$export$19cc2a5451235cae);
        $45b36222076a8936$var$assert(track && list, "A track/list element is missing.");
        $45b36222076a8936$var$push(slides, $45b36222076a8936$var$children(list, "." + $45b36222076a8936$export$8d922915837a38d3 + ":not(." + $45b36222076a8936$export$2c1ba4a4f1aa4947 + ")"));
        $45b36222076a8936$var$forOwn({
            arrows: $45b36222076a8936$export$a26cbd955fecf11e,
            pagination: $45b36222076a8936$export$cbf8e5a0ab95eda3,
            prev: $45b36222076a8936$export$58ea3db24c33b76,
            next: $45b36222076a8936$export$4885afd7098a65c2,
            bar: $45b36222076a8936$export$2c9b091c749f4409,
            toggle: $45b36222076a8936$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $45b36222076a8936$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $45b36222076a8936$var$uniqueId($45b36222076a8936$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$45b36222076a8936$var$getAttribute(root, $45b36222076a8936$var$ROLE) && root.tagName !== "SECTION" && role) $45b36222076a8936$var$setAttribute(root, $45b36222076a8936$var$ROLE, role);
        $45b36222076a8936$var$setAttribute(root, $45b36222076a8936$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $45b36222076a8936$var$setAttribute(list, $45b36222076a8936$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $45b36222076a8936$var$query(root, selector);
        return elm && $45b36222076a8936$var$closest(elm, "." + $45b36222076a8936$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $45b36222076a8936$export$93b21159ad85c843 && $45b36222076a8936$export$72d36ecf3758cb4b
        ];
    }
    return $45b36222076a8936$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $45b36222076a8936$export$e5a58a5ee5b54c22 = "slide";
var $45b36222076a8936$export$f42383286ed1223d = "loop";
var $45b36222076a8936$export$742b62a5690c060 = "fade";
function $45b36222076a8936$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $45b36222076a8936$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $45b36222076a8936$var$getAttribute(slide, "style");
    var label = $45b36222076a8936$var$getAttribute(slide, $45b36222076a8936$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $45b36222076a8936$var$child(slide, "." + $45b36222076a8936$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $45b36222076a8936$var$pad(index + 1);
            $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ROLE, pagination ? "tabpanel" : "group");
            $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_LABEL, label || $45b36222076a8936$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $45b36222076a8936$var$apply(emit, $45b36222076a8936$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $45b36222076a8936$var$apply(emit, $45b36222076a8936$export$6d5af59619d10e6a, self));
        on([
            $45b36222076a8936$export$fe5802204b967f0d,
            $45b36222076a8936$export$f0af896383d5adff,
            $45b36222076a8936$export$ff8164bff3202b9
        ], update);
        on($45b36222076a8936$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($45b36222076a8936$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $45b36222076a8936$var$removeClass(slide, $45b36222076a8936$export$49f9eaea10ebf193);
        $45b36222076a8936$var$removeAttribute(slide, $45b36222076a8936$var$ALL_ATTRIBUTES);
        $45b36222076a8936$var$setAttribute(slide, "style", styles);
        $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_LABEL, $45b36222076a8936$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_CONTROLS, controls);
        $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $45b36222076a8936$var$removeAttribute(slide, $45b36222076a8936$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $45b36222076a8936$var$toggleClass(slide, $45b36222076a8936$export$e423ac4972f5e196, index === curr - 1);
            $45b36222076a8936$var$toggleClass(slide, $45b36222076a8936$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $45b36222076a8936$var$hasClass(slide, $45b36222076a8936$export$72d36ecf3758cb4b)) {
            $45b36222076a8936$var$toggleClass(slide, $45b36222076a8936$export$72d36ecf3758cb4b, active);
            $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $45b36222076a8936$export$92e3eae133acac4c : $45b36222076a8936$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $45b36222076a8936$var$MOVING,
            $45b36222076a8936$var$SCROLLING
        ])) $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$ARIA_HIDDEN, hidden || "");
        $45b36222076a8936$var$setAttribute($45b36222076a8936$var$queryAll(slide, options.focusableNodes || ""), $45b36222076a8936$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $45b36222076a8936$var$setAttribute(slide, $45b36222076a8936$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $45b36222076a8936$var$hasClass(slide, $45b36222076a8936$export$53ca4621bbab9a)) {
            $45b36222076a8936$var$toggleClass(slide, $45b36222076a8936$export$53ca4621bbab9a, visible);
            emit(visible ? $45b36222076a8936$export$6a5b3445e4066a53 : $45b36222076a8936$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $45b36222076a8936$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $45b36222076a8936$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($45b36222076a8936$export$742b62a5690c060)) return isActive();
        var trackRect = $45b36222076a8936$var$rect(Components.Elements.track);
        var slideRect = $45b36222076a8936$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $45b36222076a8936$var$floor(trackRect[left]) <= $45b36222076a8936$var$ceil(slideRect[left]) && $45b36222076a8936$var$floor(slideRect[right]) <= $45b36222076a8936$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $45b36222076a8936$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($45b36222076a8936$export$f42383286ed1223d))) diff = $45b36222076a8936$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $45b36222076a8936$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($45b36222076a8936$export$7f4701ac5e05e39f, destroy);
        on($45b36222076a8936$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $45b36222076a8936$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $45b36222076a8936$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $45b36222076a8936$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $45b36222076a8936$var$forEach(items, function(slide) {
            if ($45b36222076a8936$var$isString(slide)) slide = $45b36222076a8936$var$parseHtml(slide);
            if ($45b36222076a8936$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $45b36222076a8936$var$before(slide, ref) : $45b36222076a8936$var$append(list, slide);
                $45b36222076a8936$var$addClass(slide, options.classes.slide);
                observeImages(slide, $45b36222076a8936$var$apply(emit, $45b36222076a8936$export$7e019dae5103a285));
            }
        });
        emit($45b36222076a8936$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $45b36222076a8936$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($45b36222076a8936$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($45b36222076a8936$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $45b36222076a8936$var$isString(matcher) ? $45b36222076a8936$var$matches(Slide2.slide, matcher) : $45b36222076a8936$var$includes($45b36222076a8936$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $45b36222076a8936$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $45b36222076a8936$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $45b36222076a8936$export$efff0f5979573c99($45b36222076a8936$var$apply(emit, $45b36222076a8936$export$7e019dae5103a285)));
        on([
            $45b36222076a8936$export$db40ab7c0855fa5c,
            $45b36222076a8936$export$7f4701ac5e05e39f
        ], init);
        on($45b36222076a8936$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $45b36222076a8936$export$97170d9824b89709;
        $45b36222076a8936$var$style(root, "maxWidth", $45b36222076a8936$var$unit(options.width));
        $45b36222076a8936$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $45b36222076a8936$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $45b36222076a8936$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $45b36222076a8936$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $45b36222076a8936$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($45b36222076a8936$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $45b36222076a8936$var$toggleClass(root, $45b36222076a8936$export$cd908cd1dd625e29, overflow);
                emit($45b36222076a8936$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $45b36222076a8936$var$unit(padding[prop] || ($45b36222076a8936$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $45b36222076a8936$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $45b36222076a8936$var$unit(options.height || $45b36222076a8936$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $45b36222076a8936$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $45b36222076a8936$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $45b36222076a8936$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $45b36222076a8936$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $45b36222076a8936$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $45b36222076a8936$var$rect(Slide.slide)[resolve("right")];
            var left = $45b36222076a8936$var$rect(list)[resolve("left")];
            return $45b36222076a8936$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($45b36222076a8936$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($45b36222076a8936$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($45b36222076a8936$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $45b36222076a8936$var$MULTIPLIER = 2;
function $45b36222076a8936$var$Clones(Splide2, Components2, options) {
    var event = $45b36222076a8936$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($45b36222076a8936$export$7f4701ac5e05e39f, remount);
        on([
            $45b36222076a8936$export$db40ab7c0855fa5c,
            $45b36222076a8936$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $45b36222076a8936$var$remove(clones);
        $45b36222076a8936$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($45b36222076a8936$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$45b36222076a8936$var$push(slides, slides);
            $45b36222076a8936$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $45b36222076a8936$var$before(clone, slides[0].slide) : $45b36222076a8936$var$append(Elements.list, clone);
                $45b36222076a8936$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $45b36222076a8936$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $45b36222076a8936$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($45b36222076a8936$export$f42383286ed1223d)) clones2 = 0;
        else if ($45b36222076a8936$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $45b36222076a8936$var$ceil($45b36222076a8936$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $45b36222076a8936$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $45b36222076a8936$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $45b36222076a8936$export$d300dc1a2634364b,
            $45b36222076a8936$export$d637eba1e9e28482,
            $45b36222076a8936$export$db40ab7c0855fa5c,
            $45b36222076a8936$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($45b36222076a8936$var$MOVING);
        emit($45b36222076a8936$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($45b36222076a8936$var$IDLE);
            emit($45b36222076a8936$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($45b36222076a8936$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $45b36222076a8936$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($45b36222076a8936$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($45b36222076a8936$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($45b36222076a8936$var$ceil($45b36222076a8936$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $45b36222076a8936$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $45b36222076a8936$var$rect(list)[left] - $45b36222076a8936$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($45b36222076a8936$export$e5a58a5ee5b54c22)) position = $45b36222076a8936$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $45b36222076a8936$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $45b36222076a8936$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $45b36222076a8936$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($45b36222076a8936$export$f42383286ed1223d);
    var isSlide = Splide2.is($45b36222076a8936$export$e5a58a5ee5b54c22);
    var getNext = $45b36222076a8936$var$apply(getAdjacent, false);
    var getPrev = $45b36222076a8936$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $45b36222076a8936$export$db40ab7c0855fa5c,
            $45b36222076a8936$export$7f4701ac5e05e39f,
            $45b36222076a8936$export$28dea85f216954dc
        ], init);
        on($45b36222076a8936$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $45b36222076a8936$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($45b36222076a8936$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $45b36222076a8936$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($45b36222076a8936$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $45b36222076a8936$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$45b36222076a8936$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($45b36222076a8936$var$between(0, dest, from, true) || $45b36222076a8936$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $45b36222076a8936$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $45b36222076a8936$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $45b36222076a8936$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $45b36222076a8936$var$min(index, endIndex) : $45b36222076a8936$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $45b36222076a8936$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$45b36222076a8936$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $45b36222076a8936$var$MOVING,
            $45b36222076a8936$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $45b36222076a8936$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $45b36222076a8936$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $45b36222076a8936$var$SIZE = 40;
function $45b36222076a8936$var$Arrows(Splide2, Components2, options) {
    var event = $45b36222076a8936$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($45b36222076a8936$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $45b36222076a8936$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $45b36222076a8936$var$display(wrapper, enabled ? "" : "none");
            $45b36222076a8936$var$addClass(wrapper, wrapperClasses = $45b36222076a8936$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $45b36222076a8936$var$setAttribute([
                    prev,
                    next
                ], $45b36222076a8936$var$ARIA_CONTROLS, track.id);
                emit($45b36222076a8936$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $45b36222076a8936$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $45b36222076a8936$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $45b36222076a8936$var$removeAttribute([
            prev,
            next
        ], $45b36222076a8936$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $45b36222076a8936$export$d300dc1a2634364b,
            $45b36222076a8936$export$fe5802204b967f0d,
            $45b36222076a8936$export$7f4701ac5e05e39f,
            $45b36222076a8936$export$ff8164bff3202b9,
            $45b36222076a8936$export$28dea85f216954dc
        ], update);
        bind(next, "click", $45b36222076a8936$var$apply(go, ">"));
        bind(prev, "click", $45b36222076a8936$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $45b36222076a8936$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $45b36222076a8936$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $45b36222076a8936$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $45b36222076a8936$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $45b36222076a8936$var$SIZE + " " + $45b36222076a8936$var$SIZE + "\" width=\"" + $45b36222076a8936$var$SIZE + "\" height=\"" + $45b36222076a8936$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $45b36222076a8936$var$PATH) + "\" />";
        return $45b36222076a8936$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $45b36222076a8936$var$setAttribute(prev, $45b36222076a8936$var$ARIA_LABEL, prevLabel);
            $45b36222076a8936$var$setAttribute(next, $45b36222076a8936$var$ARIA_LABEL, nextLabel);
            emit($45b36222076a8936$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $45b36222076a8936$var$INTERVAL_DATA_ATTRIBUTE = $45b36222076a8936$var$DATA_ATTRIBUTE + "-interval";
function $45b36222076a8936$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $45b36222076a8936$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $45b36222076a8936$var$setAttribute(toggle, $45b36222076a8936$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $45b36222076a8936$export$2aa493d7c3275167,
            $45b36222076a8936$export$49801896908b5e33,
            $45b36222076a8936$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($45b36222076a8936$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($45b36222076a8936$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($45b36222076a8936$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $45b36222076a8936$var$toggleClass(toggle, $45b36222076a8936$export$72d36ecf3758cb4b, !stopped);
            $45b36222076a8936$var$setAttribute(toggle, $45b36222076a8936$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $45b36222076a8936$var$style(bar, "width", rate * 100 + "%");
        emit($45b36222076a8936$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$45b36222076a8936$var$getAttribute(Slide.slide, $45b36222076a8936$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $45b36222076a8936$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($45b36222076a8936$export$9f64346e17f0ec8e, $45b36222076a8936$var$apply(toggle, true));
            on([
                $45b36222076a8936$export$d300dc1a2634364b,
                $45b36222076a8936$export$db40ab7c0855fa5c,
                $45b36222076a8936$export$7f4701ac5e05e39f
            ], $45b36222076a8936$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $45b36222076a8936$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $45b36222076a8936$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $45b36222076a8936$var$apply(cover, false)
    };
}
var $45b36222076a8936$var$BOUNCE_DIFF_THRESHOLD = 10;
var $45b36222076a8936$var$BOUNCE_DURATION = 600;
var $45b36222076a8936$var$FRICTION_FACTOR = 0.6;
var $45b36222076a8936$var$BASE_VELOCITY = 1.5;
var $45b36222076a8936$var$MIN_DURATION = 800;
function $45b36222076a8936$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($45b36222076a8936$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($45b36222076a8936$export$2aa493d7c3275167, clear);
        on([
            $45b36222076a8936$export$db40ab7c0855fa5c,
            $45b36222076a8936$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $45b36222076a8936$var$sign(destination) * size * $45b36222076a8936$var$floor($45b36222076a8936$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $45b36222076a8936$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $45b36222076a8936$var$max($45b36222076a8936$var$abs(destination - from) / $45b36222076a8936$var$BASE_VELOCITY, $45b36222076a8936$var$MIN_DURATION);
        callback = onScrolled;
        interval = $45b36222076a8936$export$46ad21b25b6dccf0(duration, onEnd, $45b36222076a8936$var$apply(update, from, destination, noConstrain), 1);
        set($45b36222076a8936$var$SCROLLING);
        emit($45b36222076a8936$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($45b36222076a8936$var$IDLE);
        callback && callback();
        emit($45b36222076a8936$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $45b36222076a8936$var$FRICTION_FACTOR;
            if ($45b36222076a8936$var$abs(diff) < $45b36222076a8936$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $45b36222076a8936$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $45b36222076a8936$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $45b36222076a8936$var$POINTER_MOVE_EVENTS, $45b36222076a8936$var$noop, $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $45b36222076a8936$var$POINTER_UP_EVENTS, $45b36222076a8936$var$noop, $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $45b36222076a8936$var$POINTER_DOWN_EVENTS, onPointerDown, $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $45b36222076a8936$var$prevent);
        on([
            $45b36222076a8936$export$d300dc1a2634364b,
            $45b36222076a8936$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $45b36222076a8936$var$MOVING,
                        $45b36222076a8936$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $45b36222076a8936$var$POINTER_MOVE_EVENTS, onPointerMove, $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $45b36222076a8936$var$POINTER_UP_EVENTS, onPointerUp, $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $45b36222076a8936$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($45b36222076a8936$var$DRAGGING)) {
            state.set($45b36222076a8936$var$DRAGGING);
            emit($45b36222076a8936$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $45b36222076a8936$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($45b36222076a8936$export$8e9f636d2c722196);
                $45b36222076a8936$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $45b36222076a8936$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($45b36222076a8936$var$DRAGGING)) {
            state.set($45b36222076a8936$var$IDLE);
            emit($45b36222076a8936$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $45b36222076a8936$var$prevent(e);
        }
        unbind(target, $45b36222076a8936$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $45b36222076a8936$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $45b36222076a8936$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($45b36222076a8936$export$742b62a5690c060)) Controller.go(orient($45b36222076a8936$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($45b36222076a8936$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $45b36222076a8936$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $45b36222076a8936$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $45b36222076a8936$var$abs(diffCoord(e)) > $45b36222076a8936$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($45b36222076a8936$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $45b36222076a8936$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $45b36222076a8936$var$sign(velocity) * $45b36222076a8936$var$min($45b36222076a8936$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $45b36222076a8936$var$timeOf(e) - $45b36222076a8936$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($45b36222076a8936$export$e5a58a5ee5b54c22) ? $45b36222076a8936$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$45b36222076a8936$var$matches(target2, "." + $45b36222076a8936$export$52f2cca6a5eee805 + ", ." + $45b36222076a8936$export$516e7d18e13a2dca) && (!noDrag || !$45b36222076a8936$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $45b36222076a8936$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $45b36222076a8936$var$ARROW_RIGHT,
    Left: $45b36222076a8936$var$ARROW_LEFT,
    Up: $45b36222076a8936$var$ARROW_UP,
    Down: $45b36222076a8936$var$ARROW_DOWN
};
function $45b36222076a8936$var$normalizeKey(key) {
    key = $45b36222076a8936$var$isString(key) ? key : key.key;
    return $45b36222076a8936$var$NORMALIZATION_MAP[key] || key;
}
var $45b36222076a8936$var$KEYBOARD_EVENT = "keydown";
function $45b36222076a8936$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($45b36222076a8936$export$db40ab7c0855fa5c, destroy);
        on($45b36222076a8936$export$db40ab7c0855fa5c, init);
        on($45b36222076a8936$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $45b36222076a8936$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $45b36222076a8936$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $45b36222076a8936$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $45b36222076a8936$var$normalizeKey(e);
            if (key === resolve($45b36222076a8936$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($45b36222076a8936$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $45b36222076a8936$var$SRC_DATA_ATTRIBUTE = $45b36222076a8936$var$DATA_ATTRIBUTE + "-lazy";
var $45b36222076a8936$var$SRCSET_DATA_ATTRIBUTE = $45b36222076a8936$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $45b36222076a8936$var$IMAGE_SELECTOR = "[" + $45b36222076a8936$var$SRC_DATA_ATTRIBUTE + "], [" + $45b36222076a8936$var$SRCSET_DATA_ATTRIBUTE + "]";
function $45b36222076a8936$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $45b36222076a8936$export$fe5802204b967f0d,
        $45b36222076a8936$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($45b36222076a8936$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $45b36222076a8936$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $45b36222076a8936$var$queryAll(Slide.slide, $45b36222076a8936$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $45b36222076a8936$var$getAttribute(img, $45b36222076a8936$var$SRC_DATA_ATTRIBUTE);
                var srcset = $45b36222076a8936$var$getAttribute(img, $45b36222076a8936$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $45b36222076a8936$var$child(parent, "." + className) || $45b36222076a8936$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $45b36222076a8936$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $45b36222076a8936$var$addClass(data[1].slide, $45b36222076a8936$export$d22ec4ccb7996ba2);
        bind(img, "load error", $45b36222076a8936$var$apply(onLoad, data));
        $45b36222076a8936$var$setAttribute(img, "src", $45b36222076a8936$var$getAttribute(img, $45b36222076a8936$var$SRC_DATA_ATTRIBUTE));
        $45b36222076a8936$var$setAttribute(img, "srcset", $45b36222076a8936$var$getAttribute(img, $45b36222076a8936$var$SRCSET_DATA_ATTRIBUTE));
        $45b36222076a8936$var$removeAttribute(img, $45b36222076a8936$var$SRC_DATA_ATTRIBUTE);
        $45b36222076a8936$var$removeAttribute(img, $45b36222076a8936$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $45b36222076a8936$var$removeClass(Slide.slide, $45b36222076a8936$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $45b36222076a8936$var$remove(data[2]);
            $45b36222076a8936$var$display(img, "");
            emit($45b36222076a8936$export$9f64346e17f0ec8e, img, Slide);
            emit($45b36222076a8936$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $45b36222076a8936$var$apply($45b36222076a8936$var$empty, entries),
        check: check
    };
}
function $45b36222076a8936$var$Pagination(Splide2, Components2, options) {
    var event = $45b36222076a8936$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $45b36222076a8936$export$db40ab7c0855fa5c,
            $45b36222076a8936$export$7f4701ac5e05e39f,
            $45b36222076a8936$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $45b36222076a8936$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $45b36222076a8936$export$2aa493d7c3275167,
                $45b36222076a8936$export$49801896908b5e33,
                $45b36222076a8936$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($45b36222076a8936$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $45b36222076a8936$var$remove(placeholder ? $45b36222076a8936$var$slice(list.children) : list);
            $45b36222076a8936$var$removeClass(list, paginationClasses);
            $45b36222076a8936$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $45b36222076a8936$var$ceil(length / perPage);
        list = placeholder || $45b36222076a8936$var$create("ul", classes.pagination, Elements.track.parentElement);
        $45b36222076a8936$var$addClass(list, paginationClasses = $45b36222076a8936$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $45b36222076a8936$var$setAttribute(list, $45b36222076a8936$var$ROLE, "tablist");
        $45b36222076a8936$var$setAttribute(list, $45b36222076a8936$var$ARIA_LABEL, i18n.select);
        $45b36222076a8936$var$setAttribute(list, $45b36222076a8936$var$ARIA_ORIENTATION, getDirection() === $45b36222076a8936$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $45b36222076a8936$var$create("li", null, list);
            var button = $45b36222076a8936$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $45b36222076a8936$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $45b36222076a8936$var$apply(onKeydown, i));
            $45b36222076a8936$var$setAttribute(li, $45b36222076a8936$var$ROLE, "presentation");
            $45b36222076a8936$var$setAttribute(button, $45b36222076a8936$var$ROLE, "tab");
            $45b36222076a8936$var$setAttribute(button, $45b36222076a8936$var$ARIA_CONTROLS, controls.join(" "));
            $45b36222076a8936$var$setAttribute(button, $45b36222076a8936$var$ARIA_LABEL, $45b36222076a8936$var$format(text, i + 1));
            $45b36222076a8936$var$setAttribute(button, $45b36222076a8936$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $45b36222076a8936$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($45b36222076a8936$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($45b36222076a8936$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $45b36222076a8936$var$focus(item.button);
            go(">" + nextPage);
            $45b36222076a8936$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $45b36222076a8936$var$removeClass(button, $45b36222076a8936$export$72d36ecf3758cb4b);
            $45b36222076a8936$var$removeAttribute(button, $45b36222076a8936$var$ARIA_SELECTED);
            $45b36222076a8936$var$setAttribute(button, $45b36222076a8936$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $45b36222076a8936$var$addClass(_button, $45b36222076a8936$export$72d36ecf3758cb4b);
            $45b36222076a8936$var$setAttribute(_button, $45b36222076a8936$var$ARIA_SELECTED, true);
            $45b36222076a8936$var$setAttribute(_button, $45b36222076a8936$var$TAB_INDEX, "");
        }
        emit($45b36222076a8936$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $45b36222076a8936$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $45b36222076a8936$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $45b36222076a8936$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $45b36222076a8936$export$f188226459c8a3ff(splide);
        event.on($45b36222076a8936$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($45b36222076a8936$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $45b36222076a8936$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($45b36222076a8936$export$5adb665701eda1ce, onClick);
        on($45b36222076a8936$export$6d5af59619d10e6a, onKeydown);
        on([
            $45b36222076a8936$export$d300dc1a2634364b,
            $45b36222076a8936$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($45b36222076a8936$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $45b36222076a8936$var$setAttribute(Components2.Elements.list, $45b36222076a8936$var$ARIA_ORIENTATION, options.direction === $45b36222076a8936$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($45b36222076a8936$var$includes($45b36222076a8936$var$TRIGGER_KEYS, $45b36222076a8936$var$normalizeKey(e))) {
            onClick(Slide);
            $45b36222076a8936$var$prevent(e);
        }
    }
    return {
        setup: $45b36222076a8936$var$apply(Components2.Media.set, {
            slideFocus: $45b36222076a8936$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $45b36222076a8936$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $45b36222076a8936$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $45b36222076a8936$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($45b36222076a8936$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $45b36222076a8936$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($45b36222076a8936$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $45b36222076a8936$var$SR_REMOVAL_DELAY = 90;
function $45b36222076a8936$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $45b36222076a8936$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $45b36222076a8936$var$create("span", $45b36222076a8936$export$bb78d7c200da8960);
    var interval = $45b36222076a8936$export$46ad21b25b6dccf0($45b36222076a8936$var$SR_REMOVAL_DELAY, $45b36222076a8936$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $45b36222076a8936$var$setAttribute(track, $45b36222076a8936$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($45b36222076a8936$export$23663268a31b79e2, $45b36222076a8936$var$apply(disable, true));
            on($45b36222076a8936$export$16a1e4f3d0368265, $45b36222076a8936$var$apply(disable, false));
            on([
                $45b36222076a8936$export$fe5802204b967f0d,
                $45b36222076a8936$export$ff8164bff3202b9
            ], $45b36222076a8936$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $45b36222076a8936$var$setAttribute(track, $45b36222076a8936$var$ARIA_BUSY, active);
        if (active) {
            $45b36222076a8936$var$append(track, sr);
            interval.start();
        } else {
            $45b36222076a8936$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $45b36222076a8936$var$removeAttribute(track, [
            $45b36222076a8936$var$ARIA_LIVE,
            $45b36222076a8936$var$ARIA_ATOMIC,
            $45b36222076a8936$var$ARIA_BUSY
        ]);
        $45b36222076a8936$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $45b36222076a8936$var$setAttribute(track, $45b36222076a8936$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $45b36222076a8936$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $45b36222076a8936$var$Media,
    Direction: $45b36222076a8936$var$Direction,
    Elements: $45b36222076a8936$var$Elements,
    Slides: $45b36222076a8936$var$Slides,
    Layout: $45b36222076a8936$var$Layout,
    Clones: $45b36222076a8936$var$Clones,
    Move: $45b36222076a8936$var$Move,
    Controller: $45b36222076a8936$var$Controller,
    Arrows: $45b36222076a8936$var$Arrows,
    Autoplay: $45b36222076a8936$var$Autoplay,
    Cover: $45b36222076a8936$var$Cover,
    Scroll: $45b36222076a8936$var$Scroll,
    Drag: $45b36222076a8936$var$Drag,
    Keyboard: $45b36222076a8936$var$Keyboard,
    LazyLoad: $45b36222076a8936$var$LazyLoad,
    Pagination: $45b36222076a8936$var$Pagination,
    Sync: $45b36222076a8936$var$Sync,
    Wheel: $45b36222076a8936$var$Wheel,
    Live: $45b36222076a8936$var$Live
});
var $45b36222076a8936$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $45b36222076a8936$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $45b36222076a8936$export$ba41d43e4a419565,
    i18n: $45b36222076a8936$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $45b36222076a8936$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $45b36222076a8936$export$f188226459c8a3ff(Splide2).on([
            $45b36222076a8936$export$d300dc1a2634364b,
            $45b36222076a8936$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $45b36222076a8936$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $45b36222076a8936$var$noop
    };
}
function $45b36222076a8936$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $45b36222076a8936$var$apply($45b36222076a8936$var$style, list, "transition");
    var endCallback;
    function mount() {
        $45b36222076a8936$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($45b36222076a8936$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($45b36222076a8936$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $45b36222076a8936$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $45b36222076a8936$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $45b36222076a8936$export$7254cc27399e90bd($45b36222076a8936$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $45b36222076a8936$var$isString(target) ? $45b36222076a8936$var$query(document, target) : target;
        $45b36222076a8936$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $45b36222076a8936$var$merge({
            label: $45b36222076a8936$var$getAttribute(root, $45b36222076a8936$var$ARIA_LABEL) || "",
            labelledby: $45b36222076a8936$var$getAttribute(root, $45b36222076a8936$var$ARIA_LABELLEDBY) || ""
        }, $45b36222076a8936$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $45b36222076a8936$var$merge(options, JSON.parse($45b36222076a8936$var$getAttribute(root, $45b36222076a8936$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $45b36222076a8936$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($45b36222076a8936$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $45b36222076a8936$var$assert(state.is([
            $45b36222076a8936$var$CREATED,
            $45b36222076a8936$var$DESTROYED
        ]), "Already mounted!");
        state.set($45b36222076a8936$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($45b36222076a8936$export$742b62a5690c060) ? $45b36222076a8936$var$Fade : $45b36222076a8936$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $45b36222076a8936$var$assign({}, $45b36222076a8936$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $45b36222076a8936$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $45b36222076a8936$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($45b36222076a8936$export$d300dc1a2634364b);
        $45b36222076a8936$var$addClass(this.root, $45b36222076a8936$export$7761661e2d5b9388);
        state.set($45b36222076a8936$var$IDLE);
        this.emit($45b36222076a8936$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($45b36222076a8936$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($45b36222076a8936$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($45b36222076a8936$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($45b36222076a8936$var$CREATED)) $45b36222076a8936$export$f188226459c8a3ff(this).on($45b36222076a8936$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $45b36222076a8936$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($45b36222076a8936$export$88c4cf7419e470cd);
            event.destroy();
            completely && $45b36222076a8936$var$empty(this.splides);
            state.set($45b36222076a8936$var$DESTROYED);
        }
        return this;
    };
    $45b36222076a8936$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $45b36222076a8936$export$24494c7438c070bf = $45b36222076a8936$var$_Splide;
$45b36222076a8936$export$24494c7438c070bf.defaults = {};
$45b36222076a8936$export$24494c7438c070bf.STATES = $45b36222076a8936$var$STATES;
var $45b36222076a8936$var$CLASS_RENDERED = "is-rendered";
var $45b36222076a8936$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $45b36222076a8936$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $45b36222076a8936$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $45b36222076a8936$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $45b36222076a8936$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $45b36222076a8936$var$merge($45b36222076a8936$export$f484e977a69c6ba6, defaults || {});
        $45b36222076a8936$var$merge($45b36222076a8936$var$merge(this.options, $45b36222076a8936$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $45b36222076a8936$var$assign({}, $45b36222076a8936$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $45b36222076a8936$var$uniqueId("splide");
        this.Style = new $45b36222076a8936$var$Style(this.id, this.options);
        this.Direction = $45b36222076a8936$var$Direction(null, null, this.options);
        $45b36222076a8936$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $45b36222076a8936$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $45b36222076a8936$var$queryAll(root, "." + $45b36222076a8936$export$2c1ba4a4f1aa4947);
        on($45b36222076a8936$export$d300dc1a2634364b, function() {
            $45b36222076a8936$var$remove($45b36222076a8936$var$child(root, "style"));
        });
        $45b36222076a8936$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $45b36222076a8936$var$push(this.slides, this.contents.map(function(content, index) {
            content = $45b36222076a8936$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $45b36222076a8936$export$72d36ecf3758cb4b : "");
            $45b36222076a8936$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $45b36222076a8936$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $45b36222076a8936$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $45b36222076a8936$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $45b36222076a8936$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $45b36222076a8936$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $45b36222076a8936$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $45b36222076a8936$var$unit(padding[prop] || ($45b36222076a8936$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $45b36222076a8936$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $45b36222076a8936$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $45b36222076a8936$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $45b36222076a8936$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $45b36222076a8936$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($45b36222076a8936$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $45b36222076a8936$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $45b36222076a8936$var$merge($45b36222076a8936$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $45b36222076a8936$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $45b36222076a8936$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $45b36222076a8936$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $45b36222076a8936$export$93b21159ad85c843,
            $45b36222076a8936$export$93b21159ad85c843 + "--" + options.type,
            $45b36222076a8936$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $45b36222076a8936$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $45b36222076a8936$export$93b21159ad85c843 + "--nav",
            $45b36222076a8936$export$72d36ecf3758cb4b,
            !this.config.hidden && $45b36222076a8936$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $45b36222076a8936$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $45b36222076a8936$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $45b36222076a8936$var$forOwn(styles, function(value, key) {
            style += " " + $45b36222076a8936$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$45b36222076a8936$var$push(slides, slides);
        $45b36222076a8936$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $45b36222076a8936$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $45b36222076a8936$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $45b36222076a8936$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $45b36222076a8936$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $45b36222076a8936$var$SIZE + " " + $45b36222076a8936$var$SIZE + "\" width=\"" + $45b36222076a8936$var$SIZE + "\" height=\"" + $45b36222076a8936$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $45b36222076a8936$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


document.addEventListener('DOMContentLoaded', function() {
    var imageSliderDivs = document.querySelectorAll('.image-slider');
    if (imageSliderDivs.length > 0) for(var i = 0; i < imageSliderDivs.length; i++){
        const imageSlider = new (0, $45b36222076a8936$export$24494c7438c070bf)(imageSliderDivs[i], {
            type: "fade",
            arrows: true,
            speed: 150,
            rewind: false,
            perMove: 1,
            waitForTransition: true,
            pagination: true,
            flickPower: 100,
            flickMaxPages: 1,
            updateOnMove: true,
            padding: {
                bottom: 50
            },
            breakpoints: {
                768: {
                }
            }
        });
        imageSlider.mount();
    }
});


const $8a368ed49fef4edd$var$accordions = document.querySelectorAll(".jsAccordionItem");
const $8a368ed49fef4edd$var$openAccordion = (accordion)=>{
    const content = accordion.querySelector(".jsAccordionContent");
    accordion.classList.add("accordion--active");
    content.style.maxHeight = content.scrollHeight + "px";
};
const $8a368ed49fef4edd$var$closeAccordion = (accordion)=>{
    const content = accordion.querySelector(".jsAccordionContent");
    accordion.classList.remove("accordion--active");
    content.style.maxHeight = null;
};
$8a368ed49fef4edd$var$accordions.forEach((accordion)=>{
    const intro = accordion.querySelector(".jsAccordionTitle");
    const content = accordion.querySelector(".jsAccordionContent");
    intro.onclick = ()=>{
        if (content.style.maxHeight) $8a368ed49fef4edd$var$closeAccordion(accordion);
        else {
            $8a368ed49fef4edd$var$accordions.forEach((accordion)=>$8a368ed49fef4edd$var$closeAccordion(accordion));
            $8a368ed49fef4edd$var$openAccordion(accordion);
        }
    };
});


const $d26a3ef3629325a3$var$hamburger = document.getElementById("menuButton");
const $d26a3ef3629325a3$var$mobileMenu = document.getElementById("mobileNav");
const $d26a3ef3629325a3$var$menuOverlay = document.getElementById("menuOverlay");
const $d26a3ef3629325a3$var$menuClose = document.getElementById("menuCloseButton");
if ($d26a3ef3629325a3$var$hamburger && $d26a3ef3629325a3$var$mobileMenu && $d26a3ef3629325a3$var$menuOverlay) {
    // The drawer is `position: fixed`, so it measures from the viewport and would
    // otherwise start above the header -- under the admin bar, the promo banner,
    // or both. Measuring the header's own top edge covers every combination at
    // once: whatever sits above it is already priced into that number, so the
    // drawer's close button lines up with the hamburger without the drawer
    // knowing what the chrome above it is made of.
    //
    // It has to be measured rather than assumed: the admin bar is `absolute`
    // below 601px so it scrolls away, and the promo banner is optional.
    const syncChromeOffset = ()=>{
        const header = document.getElementById("jsTopBanner");
        const offset = header ? Math.max(0, header.getBoundingClientRect().top) : 0;
        document.documentElement.style.setProperty("--njamito-chrome-offset", `${offset}px`);
    };
    const setState = (open)=>{
        if (open) syncChromeOffset();
        $d26a3ef3629325a3$var$mobileMenu.classList.toggle("active", open);
        $d26a3ef3629325a3$var$menuOverlay.classList.toggle("active", open);
        $d26a3ef3629325a3$var$hamburger.setAttribute("aria-expanded", open ? "true" : "false");
        // Without this the page keeps scrolling behind the drawer. The scrolling
        // element is <html>, so the class goes on both: the CSS locks <html>, and
        // the body class stays for anything else keying off the open state.
        document.body.classList.toggle("mobile-nav-open", open);
        document.documentElement.classList.toggle("mobile-nav-open", open);
    };
    const closeMenu = ()=>setState(false);
    $d26a3ef3629325a3$var$hamburger.setAttribute("aria-controls", "mobileNav");
    $d26a3ef3629325a3$var$hamburger.setAttribute("aria-expanded", "false");
    $d26a3ef3629325a3$var$hamburger.addEventListener("click", ()=>setState(true));
    $d26a3ef3629325a3$var$menuClose?.addEventListener("click", closeMenu);
    $d26a3ef3629325a3$var$menuOverlay.addEventListener("click", closeMenu);
    // Any menu link closes the drawer, otherwise same-page anchors leave it open
    // over a scroll-locked body.
    $d26a3ef3629325a3$var$mobileMenu.querySelectorAll("a").forEach((link)=>{
        link.addEventListener("click", closeMenu);
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeMenu();
    });
    // Resizing up to desktop hides the drawer in CSS; drop the scroll lock too.
    window.addEventListener("resize", ()=>{
        if (window.innerWidth > 768) closeMenu();
        else syncChromeOffset();
    });
    // The header's top edge moves as the banner and admin bar scroll away, and
    // again when the header goes sticky. The drawer locks scrolling while open,
    // so this only ever runs while it is closed -- it keeps the offset correct
    // for the next open.
    window.addEventListener("scroll", syncChromeOffset, {
        passive: true
    });
    syncChromeOffset();
}


let $9d49c6f241987013$var$forms = document.querySelectorAll(".logineko-login");
//Look for all the forms on the website
$9d49c6f241987013$var$forms.forEach((form)=>{
    let loginButton = form.querySelector('.logineko-login__submit');
    let username = form.querySelector('.logineko-login__input[name="username"]');
    let password = form.querySelector('.logineko-login__input[name="password"]');
    // Triger login button inside the form
    loginButton?.addEventListener('click', (e)=>{
        if (username.value != "" && password.value != "") {
            e.preventDefault();
            $9d49c6f241987013$var$loginekoLoginUser(e, form);
        }
    });
});
let $9d49c6f241987013$var$loginekoLoginUser = (e, form)=>{
    $9d49c6f241987013$var$switchLoginButton(e, form, "loading");
    const ajaxData = window.njamito_ajax;
    if (window.njamito_ajax) {
        let data = new FormData(form);
        data.append("action", "njamito_user_login_action");
        fetch(ajaxData.ajax_url, {
            method: 'POST',
            body: data
        }).then((response)=>{
            return response.json();
        }).then((jsonResponse)=>{
            if (!jsonResponse.success) {
                let messageBox = form.querySelector(".login-message");
                messageBox.innerHTML = jsonResponse.data.message;
                $9d49c6f241987013$var$switchLoginButton(e, form, "ready");
            }
            if (jsonResponse.success) window.location.href = jsonResponse.data.njamito_redirect;
        });
    }
};
const $9d49c6f241987013$var$switchLoginButton = (e, form, state)=>{
    const styles = window.getComputedStyle(e.target);
    const backgroundColor = styles.getPropertyValue('background-color');
    const globals = window.getComputedStyle(document.documentElement);
    const color = globals.getPropertyValue('--login-button-dynamic-color');
    const preloader = form.querySelector(".loader-citrus");
    //Change button text color to button background color and turn on preloader
    if (state == "loading") {
        e.target.style.color = backgroundColor;
        e.target.style.pointerEvents = "none";
        preloader.style.display = "block";
    }
    //Turn off preloader and reverse button text
    if (state == "ready") {
        e.target.style.color = color;
        e.target.style.pointerEvents = "initial";
        preloader.style.display = "none";
    }
};


if (document.querySelector("body")?.classList.contains("page-cart")) {
    /*
   * Elements and variables
   */ let wcsattWrapper = document.querySelector(".wcsatt-wrapper");
    let orderTypeChangeButton = document.querySelector(".product-type__change");
    let orderTypeSaveButton = document.querySelector(".product-type__change--save");
    let oneTimeLabel = document.querySelector(".wcsatt-options-prompt-action-input");
    let popupCloseBtn = document.getElementById("popupCloseIcon");
    let njamitoCouponButton = document.getElementById("njamito_coupon_button");
    //Subscription dropdown options
    let subscriptionOptions = document.querySelectorAll(".wcsatt-options-product-dropdown option");
    if (orderTypeChangeButton && wcsattWrapper) orderTypeChangeButton.addEventListener("click", (e)=>{
        if (wcsattWrapper) {
            wcsattWrapper.style.display = "flex";
            oneTimeLabel?.click();
            translateDropdown();
        }
    });
    if (popupCloseBtn) popupCloseBtn.addEventListener("click", (e)=>{
        if (wcsattWrapper) wcsattWrapper.style.display = "none";
    });
    if (orderTypeSaveButton) orderTypeSaveButton.addEventListener("click", (e)=>{
        orderTypeSaveButton?.classList.add("loading");
        getWcsattOption();
    });
    //Custom Coupon fields functionality
    if (njamitoCouponButton) njamitoCouponButton.addEventListener("click", (e)=>{
        let njamitoCouponField = document.getElementById("njamito_coupon_field");
        let wooCouponField = document.getElementsByName("coupon_code")[0];
        let wooCouponButton = document.getElementsByName("apply_coupon")[0];
        if (njamitoCouponField && wooCouponField && wooCouponButton) {
            if (!njamitoCouponField.value) return;
            wooCouponField.value = njamitoCouponField.value;
            wooCouponButton.click();
            njamitoCouponField.value = "";
        }
    });
    function getWcsattOption() {
        if (wcsattWrapper) {
            let selectedOption = wcsattWrapper.querySelector('input[name="subscribe-to-action-input"]:checked');
            let selectedOptionValue = selectedOption?.value;
            let activeSubscriptionScheme = "";
            if (selectedOptionValue == "yes") {
                //Subscription is selected
                let wcsattOptionsDropdown = document.querySelector(".wcsatt-options-product-dropdown");
                if (wcsattOptionsDropdown) activeSubscriptionScheme = wcsattOptionsDropdown.value;
            } else if (selectedOptionValue == "no") //One time is selected
            activeSubscriptionScheme = "";
            setCartState(activeSubscriptionScheme);
        }
    }
    /*
   * Bulk order type AJAX functionality
   */ function setCartState(activeSubscriptionScheme) {
        const ajaxData = window.njamito_ajax;
        if (window.njamito_ajax) {
            let data = new FormData();
            data.append("action", "njamito_set_cart_state_action");
            data.append("activeSubscriptionScheme", activeSubscriptionScheme);
            data.append("nonce", ajaxData.nonce);
            fetch(ajaxData.ajax_url, {
                method: "POST",
                body: data
            }).then((response)=>{
                return response.json();
            }).then((jsonResponse)=>{
                jsonResponse.success;
                if (jsonResponse.success) location.reload();
            });
        }
    }
    /*
   * Product quantity change
   */ function initCartQtyBtns() {
        let cartItems = document.querySelectorAll(".woocommerce-cart-form__cart-item");
        if (cartItems.length) cartItems.forEach((item)=>{
            let itemQty = item.querySelector("#itemQty");
            let qtyAdd = item.querySelector("#qtyAdd");
            let qtySub = item.querySelector("#qtySub");
            let qtyInput = item.querySelector("input[id*='quantity_']");
            if (itemQty && itemQty.textContent) {
                if (+itemQty.textContent == +qtyInput.max) qtyAdd.setAttribute("disabled", "true");
            }
            if (qtyAdd && qtySub && qtyInput && itemQty) {
                setQtyBtnEvent(qtyAdd, qtyInput, true, itemQty);
                setQtyBtnEvent(qtySub, qtyInput, false, itemQty);
            }
        });
        function setQtyBtnEvent(el, qtyInput, isAdd, itemQty) {
            el.addEventListener("click", (e)=>{
                e.preventDefault();
                if (isAdd) {
                    qtyInput.stepUp(1);
                    itemQty.innerText = qtyInput.value;
                } else {
                    qtyInput.stepDown(1);
                    itemQty.innerText = qtyInput.value;
                }
                updateCart();
            });
        }
    }
    function updateCart() {
        let updateCartBtn = document.getElementsByName("update_cart")[0];
        if (updateCartBtn) {
            updateCartBtn.removeAttribute("disabled");
            updateCartBtn.click();
        }
    }
    let observer = new MutationObserver(observerCallback);
    function setObserver() {
        //Listens for cart form DOM changes
        let cartForm = document.querySelector("form.woocommerce-cart-form");
        if (cartForm) observer.observe(cartForm, {
            childList: true
        });
    }
    /*
   * Listens for cart form DOM changes,
   * re-sets the observer to new form Element
   * and re-sets quantity buttons click event listener
   */ function observerCallback() {
        setObserver();
        initCartQtyBtns();
    }
    /*
   * Translate subscrion type dropdown
   */ function translateDropdown() {
        if (subscriptionOptions) subscriptionOptions.forEach((el)=>{
            if (el) {
                let string = el.innerHTML;
                let translatedString = string.replace("Every day", "Vsak dan");
                translatedString = translatedString.replace("Every week", "Vsak teden");
                translatedString = translatedString.replace("Every 2 weeks", "Vsak drugi teden");
                el.innerHTML = translatedString;
            }
        });
    }
    //Set form DOM change listener
    setObserver();
    //Set click events on quantity buttons
    initCartQtyBtns();
//End of file
}


var $5e3b4a74b1777671$var$checkoutPage = document.querySelector("body.page-checkout:not(.woocommerce-order-received)");
if ($5e3b4a74b1777671$var$checkoutPage) {
    //Redirects to cart if user goes back from Thank You page
    window.onpageshow = function(event) {
        if (event.persisted) window.location.replace("/cart");
    };
    document.addEventListener("DOMContentLoaded", function() {
        const hiddenBillingPhone = document.querySelectorAll("input[name='billing_phone']");
        //Fix the paypal and phone number field conflict
        hiddenBillingPhone[1]?.remove();
        //Adds placeholders to the login form
        const addPlaceholders = ()=>{
            let username = document.querySelector(".woocommerce-form-login #username");
            let password = document.querySelector(".woocommerce-form-login #password");
            if (username) username.placeholder = "Uporabni\u0161ko ime";
            if (password) password.placeholder = "Geslo";
        };
        /**
     * Observer for order summary section
     */ let observerCheckout = new MutationObserver(observerCallbackCheckout);
        function setCheckoutObserver() {
            //Listens for cart form DOM changes
            let cartForm = document.querySelector("#order_review");
            if (cartForm) observerCheckout.observe(cartForm, {
                childList: true
            });
        }
        function observerCallbackCheckout() {
            let initialContainer = document.querySelector("body.page-checkout:not(.woocommerce-order-received) .woocommerce-checkout-review-order-table .order-total");
            const intervalOptions = document.getElementById("intervalOptions");
            let copyContainer = document.querySelector(".order-total-custom");
            intervalOptions?.addEventListener("change", (e)=>{
                document.body.dispatchEvent(new Event("update_checkout"));
                const ajaxData = window.njamito_ajax;
                if (window.njamito_ajax) {
                    let data = new FormData();
                    data.append("action", "njamito_set_cart_state_action");
                    //data.append("activeSubscriptionScheme", intervalOptions.value);
                    data.append("nonce", ajaxData.nonce);
                    fetch(ajaxData.ajax_url, {
                        method: "POST",
                        body: data
                    }).then((response)=>{
                        return response.json();
                    }).then((jsonResponse)=>{
                        if (!jsonResponse.success) location.reload();
                        if (jsonResponse.success) document.body.dispatchEvent(new Event("update_checkout"));
                    });
                }
            });
            // Copy order summary section
            if (copyContainer.innerHTML != undefined) copyContainer.innerHTML = initialContainer.innerHTML;
            setCheckoutObserver();
        }
        //Set form DOM change listener
        setCheckoutObserver();
        addPlaceholders();
    });
}


/**
 * Inline "house number missing" error on the Checkout block's street fields.
 *
 * Puts the message under the street field through the block's own validation
 * store, which also keeps "Place order" from submitting and scrolls to the
 * field. A soft check, in the form only: the server accepts any address, so
 * orders from the Store API or an express wallet are never refused over it
 * (see inc/address-validation.php).
 *
 * The check runs when the shopper leaves the field and when "Place order" is
 * clicked — not while typing, so nobody is told off half-way through a word.
 * Part of main.js on purpose: it must hold with address suggestions switched off.
 *
 * Messages come from `niamitoHouseNumber`, localised on the checkout only.
 */ 
var $c3IU8 = parcelRequire("c3IU8");
const $7ccb60dc608fd542$var$messages = window.niamitoHouseNumber;
const $7ccb60dc608fd542$var$VALIDATION_STORE = 'wc/store/validation';
// The address-search controls next to the street field (addressAutocomplete.ts).
const $7ccb60dc608fd542$var$STILL_CHOOSING = [
    '.wc-block-components-address-autocomplete-icon',
    '.wc-block-components-address-autocomplete-suggestions',
    '.wc-block-components-address-autocomplete-suggestion',
    '.woocommerce-address-suggestions',
    '.address-search-icon'
].join(', ');
function $7ccb60dc608fd542$var$store() {
    const data = window.wp?.data;
    if (!data?.select || !data?.dispatch) return null;
    try {
        return {
            select: data.select($7ccb60dc608fd542$var$VALIDATION_STORE),
            dispatch: data.dispatch($7ccb60dc608fd542$var$VALIDATION_STORE)
        };
    } catch  {
        return null;
    }
}
function $7ccb60dc608fd542$var$check(type, show) {
    const validation = $7ccb60dc608fd542$var$store();
    if (!validation || !$7ccb60dc608fd542$var$messages) return;
    const id = `${type}_address_1`;
    const message = $7ccb60dc608fd542$var$messages[type];
    const input = document.getElementById(`${type}-address_1`);
    const value = input ? input.value.trim() : '';
    const current = validation.select.getValidationError(id);
    // A hidden form (billing folded into shipping) or an empty field — the block
    // reports "required" itself — or a valid one: drop only our own error.
    if (!input || !value || (0, $c3IU8.hasHouseNumber)(value)) {
        if (current && current.message === message) validation.dispatch.clearValidationError(id);
        return;
    }
    // Never replace one of the block's own errors for this field.
    if (current && current.message !== message) return;
    validation.dispatch.setValidationErrors({
        [id]: {
            message: message,
            hidden: !show
        }
    });
}
function $7ccb60dc608fd542$var$typeOf(target) {
    if (!(target instanceof HTMLInputElement)) return null;
    if (target.id === 'shipping-address_1') return 'shipping';
    if (target.id === 'billing-address_1') return 'billing';
    return null;
}
if ($7ccb60dc608fd542$var$messages) {
    // After the block's own blur validation, which clears errors on a field it
    // considers valid.
    document.addEventListener('focusout', (event)=>{
        const type = $7ccb60dc608fd542$var$typeOf(event.target);
        // Not when focus only moves on to the search button or a suggestion: the
        // shopper is still choosing the address, and a pick may add the number.
        const next = event.relatedTarget;
        if (type && !next?.closest?.($7ccb60dc608fd542$var$STILL_CHOOSING)) window.setTimeout(()=>$7ccb60dc608fd542$var$check(type, true), 0);
    });
    // Capture phase: settled before the block decides whether it may submit.
    document.addEventListener('click', (event)=>{
        const target = event.target;
        if (target?.closest?.('.wc-block-components-checkout-place-order-button')) {
            $7ccb60dc608fd542$var$check('shipping', true);
            $7ccb60dc608fd542$var$check('billing', true);
        }
    }, true);
}


const $3aa4b223a0b4bc21$var$popup = document.querySelector(".wcsatt-options-wrapper");
const $3aa4b223a0b4bc21$var$popupSubContent = document.querySelector(".wcsatt-options-product-wrapper");
const $3aa4b223a0b4bc21$var$popupSelect = document.querySelector(".wcsatt-options-product-dropdown");
if ($3aa4b223a0b4bc21$var$popup && $3aa4b223a0b4bc21$var$popupSubContent && $3aa4b223a0b4bc21$var$popupSelect) {
    //Insert One-Time text
    let popupSinglecontent = document.createElement("div");
    const popupText = window.njamito_ajax.translation.popupText;
    popupSinglecontent.classList.add("wcsatt-options-product-wrapper");
    popupSinglecontent.classList.add("wcsatt-options-product-wrapper--single");
    popupSinglecontent.textContent = popupText;
    $3aa4b223a0b4bc21$var$popupSubContent.after(popupSinglecontent);
    //Insert Subscribe text
    let popupListContent = document.createElement("div");
    const popupList = window.njamito_ajax.translation.popupList;
    popupListContent.innerHTML = popupList;
    $3aa4b223a0b4bc21$var$popupSelect.after(popupListContent);
}


const $7f1ee6903d5693ad$var$toggleSwitch = document.querySelectorAll(".product-info__toggle");
const $7f1ee6903d5693ad$var$qtyButtons = document.querySelectorAll(".summary__single-product-button");
const $7f1ee6903d5693ad$var$cartButton = document.getElementById("addToCart");
const $7f1ee6903d5693ad$var$qtyElements = document.querySelectorAll(".summary__single-product-qty-input");
const $7f1ee6903d5693ad$var$summaryWrap = document.querySelector(".summary__multi-product-wrap");
const $7f1ee6903d5693ad$var$minAmount = document.getElementById("minAmount");
const $7f1ee6903d5693ad$var$sumTotalWrap = document.getElementById("sumTotalWrap");
const $7f1ee6903d5693ad$var$sumTotalWrapLocale = $7f1ee6903d5693ad$var$sumTotalWrap ? $7f1ee6903d5693ad$var$sumTotalWrap.getAttribute("data-locale") : 'sl';
const $7f1ee6903d5693ad$var$sumTotalNumber = document.querySelector(".summary__total span");
const $7f1ee6903d5693ad$var$sumTotal = document.getElementById("sumTotal");
const $7f1ee6903d5693ad$var$sumBottlesWrap = document.getElementById("sumBottlesWrap");
const $7f1ee6903d5693ad$var$sumPacketsNumber = document.getElementById("sumPacketsNumber");
const $7f1ee6903d5693ad$var$sumBottlesNumber = document.getElementById("sumBottlesNumber");
const $7f1ee6903d5693ad$var$packetsPlural = document.getElementById("packetsPlural");
const $7f1ee6903d5693ad$var$messageSuccess = document.getElementById("messageSuccess");
const $7f1ee6903d5693ad$var$messageFail = document.getElementById("messageFail");
let $7f1ee6903d5693ad$var$totalPackets = 0;
let $7f1ee6903d5693ad$var$packPrice = $7f1ee6903d5693ad$var$sumTotalWrapLocale == 'de' ? 27.96 : 23.96;
let $7f1ee6903d5693ad$var$bottlePrice = $7f1ee6903d5693ad$var$sumTotalWrapLocale == 'de' ? 6.99 : 5.99;
let $7f1ee6903d5693ad$var$kgPrice = $7f1ee6903d5693ad$var$sumTotalWrapLocale == 'de' ? 19.19 : 15.36;
//Product details toggle
if ($7f1ee6903d5693ad$var$toggleSwitch) $7f1ee6903d5693ad$var$toggleSwitch.forEach((element)=>{
    element.addEventListener("click", (e)=>{
        element.classList.toggle("true");
    });
});
//Quantity buttons
if ($7f1ee6903d5693ad$var$qtyButtons && $7f1ee6903d5693ad$var$cartButton) Array.from($7f1ee6903d5693ad$var$qtyButtons).forEach((btn)=>{
    btn.addEventListener("click", (e)=>{
        if (e.target) {
            let productId = e.target.getAttribute("data-product-id");
            let buttonType = e.target.getAttribute("data-type");
            let qtyInput = document.querySelector(`.summary__single-product-qty-input[data-product-id='${productId}'`);
            let qtySpan = document.querySelector(`.summary__single-product-qty[data-product-id='${productId}'`);
            if (buttonType === "sub") qtyInput.stepDown(1);
            else if (buttonType === "add") qtyInput.stepUp(1);
            $7f1ee6903d5693ad$var$sumTotalWrap.style.display = "flex";
            $7f1ee6903d5693ad$var$messageSuccess.style.display = "none";
            $7f1ee6903d5693ad$var$messageFail.style.display = "none";
            qtySpan.innerHTML = qtyInput.value;
            $7f1ee6903d5693ad$var$calculateTotalSelectedPackets();
            if ($7f1ee6903d5693ad$var$totalPackets > 0) {
                $7f1ee6903d5693ad$var$cartButton.classList.remove("disabled");
                $7f1ee6903d5693ad$var$minAmount.style.display = "none";
                $7f1ee6903d5693ad$var$sumTotal.style.display = "block";
                $7f1ee6903d5693ad$var$sumBottlesWrap.style.display = "block";
                let totalPrice = $7f1ee6903d5693ad$var$totalPackets * $7f1ee6903d5693ad$var$packPrice;
                // Comment out, to disable discount display and calculation
                $7f1ee6903d5693ad$var$applyBulkDiscount(totalPrice, $7f1ee6903d5693ad$var$totalPackets);
                $7f1ee6903d5693ad$var$sumPacketsNumber.textContent = $7f1ee6903d5693ad$var$totalPackets.toString();
                $7f1ee6903d5693ad$var$sumBottlesNumber.textContent = ($7f1ee6903d5693ad$var$totalPackets * 4).toString();
                $7f1ee6903d5693ad$var$sumTotalNumber.textContent = totalPrice.toLocaleString('sl', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            } else {
                $7f1ee6903d5693ad$var$cartButton.classList.add("disabled");
                $7f1ee6903d5693ad$var$minAmount.style.display = "block";
                $7f1ee6903d5693ad$var$sumTotal.style.display = "none";
                $7f1ee6903d5693ad$var$sumBottlesWrap.style.display = "none";
                $7f1ee6903d5693ad$var$resetBulkDiscount();
            }
            if ($7f1ee6903d5693ad$var$sumTotalWrapLocale === 'de') switch($7f1ee6903d5693ad$var$totalPackets){
                case 0:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "";
                    break;
                case 1:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "";
                    break;
                default:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "e";
                    break;
            }
            else //Handle plurar for "Packets"
            switch($7f1ee6903d5693ad$var$totalPackets){
                case 0:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "";
                    break;
                case 1:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "";
                    break;
                case 2:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "a";
                    break;
                case 3:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "i";
                    break;
                case 4:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "i";
                    break;
                case 5:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "ov";
                    break;
                default:
                    $7f1ee6903d5693ad$var$packetsPlural.textContent = "ov";
                    break;
            }
        }
    });
});
//Cart button
if ($7f1ee6903d5693ad$var$cartButton) $7f1ee6903d5693ad$var$cartButton.addEventListener("click", (e)=>{
    e.preventDefault();
    $7f1ee6903d5693ad$var$cartButton.classList.add("loading");
    $7f1ee6903d5693ad$var$summaryWrap.classList.add("disabled");
    let selectedItemsArray = new Array();
    if ($7f1ee6903d5693ad$var$qtyElements) {
        $7f1ee6903d5693ad$var$qtyElements.forEach((e)=>{
            let qty = e.value;
            let id = e.getAttribute("data-product-id");
            if (qty && id) selectedItemsArray.push({
                id: +id,
                qty: +qty
            });
        });
        const ajaxData = window.njamito_ajax;
        if (window.njamito_ajax) {
            let data = new FormData();
            data.append("action", "njamito_add_to_cart");
            data.append("selectedItemsArray", JSON.stringify(selectedItemsArray));
            data.append("nonce", ajaxData.nonce);
            fetch(ajaxData.ajax_url, {
                method: "POST",
                body: data
            }).then((response)=>{
                return response.json();
            }).then((jsonResponse)=>{
                $7f1ee6903d5693ad$var$sumTotalWrap.style.display = "none";
                if (!jsonResponse.success) $7f1ee6903d5693ad$var$messageFail.style.display = "block";
                if (jsonResponse.success) //resetQuantities();
                //messageSuccess.style.display = "block";
                window.location.href = $7f1ee6903d5693ad$var$cartButton.getAttribute("data-href") || "/cart";
                $7f1ee6903d5693ad$var$cartButton.classList.remove("loading");
                $7f1ee6903d5693ad$var$cartButton.classList.add("disabled");
                $7f1ee6903d5693ad$var$summaryWrap.classList.remove("disabled");
            });
        }
    }
});
//Calculate total number of selected packets
function $7f1ee6903d5693ad$var$calculateTotalSelectedPackets() {
    if ($7f1ee6903d5693ad$var$qtyElements) {
        $7f1ee6903d5693ad$var$totalPackets = 0;
        $7f1ee6903d5693ad$var$qtyElements.forEach((e)=>{
            $7f1ee6903d5693ad$var$totalPackets += +e.value;
        });
        return $7f1ee6903d5693ad$var$totalPackets;
    }
}
//Resets all quantities back to zero
function $7f1ee6903d5693ad$var$resetQuantities() {
    $7f1ee6903d5693ad$var$qtyElements.forEach((e)=>{
        let productId = e.getAttribute("data-product-id");
        let qtySpan = document.querySelector(`.summary__single-product-qty[data-product-id='${productId}'`);
        if (productId && qtySpan) {
            e.value = "0";
            qtySpan.innerHTML = "0";
        }
    });
}
// Bulk discount
const $7f1ee6903d5693ad$var$sumTotalWithDiscount = document.querySelector(".summary__total-with-discounted");
const $7f1ee6903d5693ad$var$sumTotalWithDiscountNumber = document.querySelector(".summary__total-with-discounted span");
const $7f1ee6903d5693ad$var$perBottlePrice = document.getElementById("perBottlePrice");
const $7f1ee6903d5693ad$var$perBottlePriceDiscounted = document.getElementById("perBottlePriceDiscounted");
const $7f1ee6903d5693ad$var$perKgPrice = document.getElementById("perKgPrice");
const $7f1ee6903d5693ad$var$perKgPriceDiscounted = document.getElementById("perKgPriceDiscounted");
const $7f1ee6903d5693ad$var$bulk5Description = document.getElementById("bulk-discount-5-applied");
const $7f1ee6903d5693ad$var$bulk10Description = document.getElementById("bulk-discount-10-applied");
const $7f1ee6903d5693ad$var$bulk15Description = document.getElementById("bulk-discount-15-applied");
function $7f1ee6903d5693ad$var$resetBulkDiscount() {
    if ($7f1ee6903d5693ad$var$sumTotalWithDiscount === null) return; // Discount rule is not enabled
    $7f1ee6903d5693ad$var$sumTotalWithDiscount.style.display = "none";
    $7f1ee6903d5693ad$var$perBottlePriceDiscounted.style.display = "none";
    $7f1ee6903d5693ad$var$perKgPriceDiscounted.style.display = "none";
    $7f1ee6903d5693ad$var$bulk5Description.classList.add('hidden');
    $7f1ee6903d5693ad$var$bulk10Description.classList.add('hidden');
    $7f1ee6903d5693ad$var$bulk15Description.classList.add('hidden');
}
function $7f1ee6903d5693ad$var$applyBulkDiscount(totalPrice, totalPackets) {
    // discount is applicable only for Slovenian locale
    if ($7f1ee6903d5693ad$var$sumTotalWrapLocale !== 'sl') return;
    if ($7f1ee6903d5693ad$var$sumTotalWithDiscount === null) return; // Discount rule is not enabled
    // Return 0 to disable discount.
    let discount = 0;
    let perBottlePriceValue = $7f1ee6903d5693ad$var$perBottlePrice.dataset.price ? parseFloat($7f1ee6903d5693ad$var$perBottlePrice.dataset.price) : $7f1ee6903d5693ad$var$bottlePrice;
    let perKgPriceValue = $7f1ee6903d5693ad$var$perKgPrice.dataset.price ? parseFloat($7f1ee6903d5693ad$var$perKgPrice.dataset.price) : $7f1ee6903d5693ad$var$kgPrice;
    if (totalPackets === 1) {
        discount = 5;
        $7f1ee6903d5693ad$var$bulk5Description.classList.remove('hidden');
        $7f1ee6903d5693ad$var$bulk10Description.classList.add('hidden');
        $7f1ee6903d5693ad$var$bulk15Description.classList.add('hidden');
        $7f1ee6903d5693ad$var$perKgPriceDiscounted.textContent = (perKgPriceValue - perKgPriceValue / 100 * discount).toLocaleString('sl', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    if (totalPackets === 2) {
        discount = 10;
        $7f1ee6903d5693ad$var$bulk5Description.classList.add('hidden');
        $7f1ee6903d5693ad$var$bulk10Description.classList.remove('hidden');
        $7f1ee6903d5693ad$var$bulk15Description.classList.add('hidden');
        $7f1ee6903d5693ad$var$perKgPriceDiscounted.textContent = (perKgPriceValue - perKgPriceValue / 100 * discount).toLocaleString('sl', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    if (totalPackets >= 3) {
        discount = 15;
        $7f1ee6903d5693ad$var$bulk5Description.classList.add('hidden');
        $7f1ee6903d5693ad$var$bulk10Description.classList.add('hidden');
        $7f1ee6903d5693ad$var$bulk15Description.classList.remove('hidden');
        $7f1ee6903d5693ad$var$perKgPriceDiscounted.textContent = (perKgPriceValue - perKgPriceValue / 100 * discount).toLocaleString('sl', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    $7f1ee6903d5693ad$var$perBottlePriceDiscounted.textContent = (perBottlePriceValue - perBottlePriceValue / 100 * discount).toLocaleString('sl', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    let totalWithDiscountPrice = totalPrice - totalPrice / 100 * discount;
    if (totalWithDiscountPrice > 0 && totalPrice !== totalWithDiscountPrice) {
        $7f1ee6903d5693ad$var$sumTotalWithDiscountNumber.textContent = totalWithDiscountPrice.toLocaleString('sl', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        $7f1ee6903d5693ad$var$sumTotalWrap.classList.add("discounted");
        $7f1ee6903d5693ad$var$sumTotalWithDiscount.style.display = "block";
        $7f1ee6903d5693ad$var$perBottlePriceDiscounted.style.display = "inline";
        $7f1ee6903d5693ad$var$perKgPriceDiscounted.style.display = "inline";
    }
}


var $bb6af0f595dcfe4a$var$landingPage = document.querySelector("body.page-template-landing");
var $bb6af0f595dcfe4a$var$landingPageCastle = document.querySelector("body.page-template-landing-castle");
var $bb6af0f595dcfe4a$var$landingB2b = document.querySelector("body.page-template-landing-b2b");
/*
 * B2B Landing Page
 */ if ($bb6af0f595dcfe4a$var$landingB2b) {
    const statsNumberWrapper = document.querySelector(".stats__numbers-wrapper");
    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
    }
    function handleScroll() {
        if (isElementInViewport(statsNumberWrapper) && statsNumberWrapper) {
            statsNumberWrapper.classList.add("active");
            window.removeEventListener("scroll", handleScroll);
        }
    }
    window.addEventListener("scroll", handleScroll);
}
/*
 * Regular Landing Page
 */ $bb6af0f595dcfe4a$var$landingPage;
/*
 * Castle Event Landing Page
 */ if ($bb6af0f595dcfe4a$var$landingPageCastle) document.addEventListener("DOMContentLoaded", function() {
    //Store lot_id GET param in sessionStorage
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let lotId = urlParams.get("lot_id");
    setTimeout(()=>{
        if (window.location.hash === "#form") {
            var formElement = document.getElementById("form");
            if (formElement) formElement.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, 1000);
    if (lotId) {
        const lastChar = lotId[lotId.length - 1];
        if (lastChar.toLowerCase() != lastChar.toUpperCase()) lotId = lotId.slice(0, -1);
        sessionStorage.setItem("traceability_lot_id", lotId);
    }
    const form = document.getElementById("newsletter");
    form?.addEventListener("submit", (event)=>{
        event.preventDefault();
        const submitBtn = document.getElementById("submit");
        const ajaxData = window.njamito_ajax;
        const email = document.getElementById("email");
        if (submitBtn) {
            submitBtn.classList.add("loading");
            submitBtn.setAttribute("disabled", "true");
        }
        if (window.njamito_ajax) {
            let data = new FormData();
            data.append("action", "njamito_create_omnisend_contact");
            data.append("email", email.value);
            data.append("eventName", "prelaunch-waitlist");
            data.append("nonce", ajaxData.nonce);
            // admin-ajax has no page to infer a language from. WPML reads the request
            // language off this parameter, and it is what puts the right `locale:` tag
            // on the Omnisend contact instead of the site default.
            if (ajaxData.lang) data.append("lang", ajaxData.lang);
            fetch(ajaxData.ajax_url, {
                method: "POST",
                body: data
            }).then((response)=>{
                return response.json();
            }).then((jsonResponse)=>{
                jsonResponse.success;
                if (jsonResponse.success) {
                    form.remove();
                    const successMsg = document.querySelector(".product-newsletter__success-message");
                    if (successMsg) successMsg.style.display = "block";
                }
            });
        }
    });
});


var $b5440b32cec4498a$var$thankyouPage = document.querySelector("body.woocommerce-order-received") || null;
if ($b5440b32cec4498a$var$thankyouPage) {
    document.addEventListener("DOMContentLoaded", function() {
        let woltTrackingLink = document.getElementById("woocommerce__wolt-link") || null;
        if (woltTrackingLink && woltTrackingLink.getAttribute("href") == "") //Fetch Wolt Link
        fetchWoltLink();
    }, false);
    function fetchWoltLink() {
        let orderDetails = document.getElementById("customOrderCall") || null;
        let orderDetailsJSON = orderDetails?.value;
        if (orderDetailsJSON) {
            const orderId = JSON.parse(orderDetailsJSON).order_id;
            const ajaxData = window.njamito_ajax;
            fetchWoltCall(orderId, ajaxData);
        }
    }
    function displayWoltLink(woltlink) {
        document.querySelector(".loader-small")?.remove();
        let woltTrackingLink = document.getElementById("woocommerce__wolt-link") || null;
        if (woltTrackingLink) {
            woltTrackingLink.setAttribute("href", woltlink);
            woltTrackingLink.innerHTML = woltlink;
        }
    }
    //Fetch Wolt Call function - it's a separate function to order to have it in recursion
    function fetchWoltCall(orderId, ajaxData) {
        return new Promise((resolve)=>{
            if (window.njamito_ajax) {
                let data = new FormData();
                data.append("action", "njamito_get_wolt_link");
                data.append("orderId", orderId);
                data.append("nonce", ajaxData.nonce);
                fetch(ajaxData.ajax_url, {
                    method: "POST",
                    body: data
                }).then((response)=>{
                    return response.json();
                }).then((jsonResponse)=>{
                    jsonResponse.success;
                    if (jsonResponse.success) {
                        if (jsonResponse.data.wolt_tracking_url == "") //If Wolt link is not available, call itself again
                        fetchWoltCall(orderId, ajaxData);
                        else displayWoltLink(jsonResponse.data.wolt_tracking_url);
                    }
                });
            }
        });
    }
}


// Function to get URL parameters
function $bc1b49baeece29a6$var$getUrlParameters() {
    const searchParams = new URLSearchParams(window.location.search);
    const utmCampaign = searchParams.get("utm_campaign");
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmTerm = searchParams.get("utm_term");
    const utmContent = searchParams.get("utm_content");
    return {
        utmCampaign: utmCampaign,
        utmSource: utmSource,
        utmMedium: utmMedium,
        utmTerm: utmTerm,
        utmContent: utmContent
    };
}
// Store URL parameters in LocalStorage
function $bc1b49baeece29a6$var$storeParametersInLocalStorage() {
    const { utmCampaign: utmCampaign, utmSource: utmSource, utmMedium: utmMedium, utmTerm: utmTerm, utmContent: utmContent } = $bc1b49baeece29a6$var$getUrlParameters();
    if (utmCampaign) sessionStorage.setItem("utm_campaign", utmCampaign);
    if (utmSource) sessionStorage.setItem("utm_source", utmSource);
    if (utmMedium) sessionStorage.setItem("utm_medium", utmMedium);
    if (utmTerm) sessionStorage.setItem("utm_term", utmTerm);
    if (utmContent) sessionStorage.setItem("utm_content", utmContent);
    if (utmCampaign || utmSource || utmMedium || utmTerm || utmContent) $bc1b49baeece29a6$var$storeUtmParams(utmCampaign, utmSource, utmMedium, utmTerm, utmContent);
}
// Store UTM parameters on the backend
function $bc1b49baeece29a6$var$storeUtmParams(utmCampaign, utmSource, utmMedium, utmTerm, utmContent) {
    const ajaxData = window.njamito_ajax;
    if (window.njamito_ajax) {
        let data = new FormData();
        data.append("action", "njamito_store_utm_params");
        data.append("utmCampaign", utmCampaign);
        data.append("utmSource", utmSource);
        data.append("utmMedium", utmMedium);
        data.append("utmTerm", utmTerm);
        data.append("utmContent", utmContent);
        data.append("nonce", ajaxData.nonce);
        fetch(ajaxData.ajax_url, {
            method: "POST",
            body: data
        }).then((response)=>{
            return response.json();
        }).then((jsonResponse)=>{
            jsonResponse.success;
            jsonResponse.success;
        });
    }
}
// Run storeParametersInLocalStorage on full page load
window.onload = function() {
    $bc1b49baeece29a6$var$storeParametersInLocalStorage();
};


function $4d7b28447f3e821a$var$attachClickAndSimulate() {
    const revokeConsentLink = document.getElementById("revoke-consent");
    const revokeCookieElement = document.querySelector(".cn-revoke-cookie");
    if (revokeConsentLink && revokeCookieElement) revokeConsentLink.addEventListener("click", (event)=>{
        event.preventDefault();
        revokeCookieElement.click();
    });
}
function $4d7b28447f3e821a$var$runScriptOnUpdateCheckout() {
    $4d7b28447f3e821a$var$attachClickAndSimulate();
}
setInterval($4d7b28447f3e821a$var$runScriptOnUpdateCheckout, 1000);


// make top bar sticky
const $ed7d20d8f7f0caa1$var$navbar = document.getElementById('jsTopBanner');
if ($ed7d20d8f7f0caa1$var$navbar) {
    if (window.pageYOffset > 110) $ed7d20d8f7f0caa1$var$navbar.classList.add('sticky');
    window.addEventListener('scroll', ()=>{
        if (window.pageYOffset > 110) $ed7d20d8f7f0caa1$var$navbar.classList.add('sticky');
        if (window.pageYOffset <= 90) $ed7d20d8f7f0caa1$var$navbar.classList.remove('sticky');
    });
}


// Make the whole shop/archive product card clickable, while letting real
// interactive elements (links, buttons, inputs, quantity selector) behave
// natively. Mouse-only enhancement — keyboard/SR use the real product links.
const $131002f8aefb8dd5$var$productsContainer = document.querySelector(".woocommerce.archive #main .products");
if ($131002f8aefb8dd5$var$productsContainer) $131002f8aefb8dd5$var$productsContainer.addEventListener("click", (event)=>{
    // Plain primary click only — no new-tab/modifier handling by design.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target;
    const card = target.closest("li.product");
    if (!card) return;
    // Let any real interactive element handle its own click.
    if (target.closest("a, button, input, select, textarea, label, .njamito_shop_custom_quantity_selector")) return;
    // Don't hijack a text-selection drag.
    if (window.getSelection()?.toString()) return;
    const link = card.querySelector(".woocommerce-loop-product__link");
    if (link?.href) window.location.href = link.href;
});



/**
 * Accordion component
 */ const $ffb2f4ba9799f042$var$njamitoAccordionAnchorElements = document.querySelectorAll('.njamito-accordion__type--anchor');
document.querySelectorAll('.njamito-accordion__type--anchor[href^="#"]').forEach((anchor)=>{
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = anchor.getAttribute('href');
        if (targetId) {
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                const rect = targetElement.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const targetY = rect.top + scrollTop - 80;
                window.scrollTo({
                    top: targetY,
                    behavior: 'smooth'
                });
            }
        }
    });
});
document.querySelectorAll('.njamito-accordion__item-content').forEach((content)=>{
    const contentHeight = content.scrollHeight;
    const contentStyle = window.getComputedStyle(content);
    const paddingTop = parseFloat(contentStyle.paddingTop);
    const paddingBottom = parseFloat(contentStyle.paddingBottom);
    const marginTop = parseFloat(contentStyle.marginTop);
    const marginBottom = parseFloat(contentStyle.marginBottom);
    const totalHeight = contentHeight + paddingTop + paddingBottom + marginTop + marginBottom;
    content.style.setProperty('--njamito-accordion-item-content-max-height', totalHeight + 'px');
});
/**
 * Quantity component
 */ //const njamitoQuantityElements = document.querySelectorAll(".njamito-quantity__input");
const $ffb2f4ba9799f042$var$njamitoQuantityElements = document.querySelectorAll(".njamito-quantity__input");
if ($ffb2f4ba9799f042$var$njamitoQuantityElements) $ffb2f4ba9799f042$var$njamitoQuantityElements.forEach((element)=>{
    const fieldId = element.id;
    const quantityAdd = document.getElementById(fieldId + "-add");
    const quantitySubtract = document.getElementById(fieldId + "-subtract");
    const quantityValue = document.getElementById(fieldId + "-value");
    // Ensure buttons exist before adding event listeners
    if (quantityAdd) quantityAdd.addEventListener("click", ()=>{
        $ffb2f4ba9799f042$var$njamitoSetQuantity(fieldId, 1);
    });
    if (quantitySubtract) quantitySubtract.addEventListener("click", ()=>{
        $ffb2f4ba9799f042$var$njamitoSetQuantity(fieldId, -1);
    });
    element.addEventListener("change", (event)=>{
        const inputElement = event.target;
        if (quantityValue) quantityValue.textContent = inputElement.value;
        $ffb2f4ba9799f042$var$updateButtonState(fieldId);
        $ffb2f4ba9799f042$var$updateAddToCartQuantity(element);
    });
    // Seed the visible value on load. Grouped-product rows ship an empty
    // field, which would otherwise render a blank gap between -/+.
    if (quantityValue && quantityValue.textContent?.trim() === "") {
        const initial = parseInt(element.value);
        const initialMin = element.min ? parseInt(element.min) : 1;
        quantityValue.textContent = String(Number.isNaN(initial) ? initialMin : initial);
    }
    // Initialize button state on load
    $ffb2f4ba9799f042$var$updateButtonState(fieldId);
    $ffb2f4ba9799f042$var$updateAddToCartQuantity(element);
});
function $ffb2f4ba9799f042$var$njamitoSetQuantity(fieldId, changeValue) {
    const field = document.getElementById(fieldId);
    const quantityValue = document.getElementById(fieldId + "-value");
    if (!field || !quantityValue) return;
    // Ensure min & max values are handled correctly
    const minValue = field.min ? parseInt(field.min) : 1;
    const maxValue = field.max ? parseInt(field.max) : Infinity;
    // Grouped (bundle) products render their child rows with an empty value and
    // min="0", so parseInt() yields NaN. Fall back to the minimum, otherwise the
    // arithmetic below stays NaN and `type="number"` silently discards the write.
    const currentValue = parseInt(field.value);
    const baseValue = Number.isNaN(currentValue) ? minValue : currentValue;
    let newValue = baseValue + changeValue;
    newValue = Math.max(minValue, Math.min(newValue, maxValue));
    field.value = newValue.toString();
    quantityValue.textContent = newValue.toString(); // Update displayed value
    field.dispatchEvent(new Event("change"));
    // Update button states after change
    $ffb2f4ba9799f042$var$updateButtonState(fieldId);
    $ffb2f4ba9799f042$var$updateAddToCartQuantity(field);
}
function $ffb2f4ba9799f042$var$updateButtonState(fieldId) {
    const field = document.getElementById(fieldId);
    const quantityAdd = document.getElementById(fieldId + "-add");
    const quantitySubtract = document.getElementById(fieldId + "-subtract");
    if (!field || !quantityAdd || !quantitySubtract) return;
    const minValue = field.min ? parseInt(field.min) : 1;
    const maxValue = field.max ? parseInt(field.max) : Infinity;
    // An empty grouped-product field reads as NaN; treat it as the minimum so the
    // subtract button starts disabled instead of comparing against NaN.
    const parsedValue = parseInt(field.value);
    const currentValue = Number.isNaN(parsedValue) ? minValue : parsedValue;
    // Disable or enable subtract button
    quantitySubtract.disabled = currentValue <= minValue;
    quantityAdd.disabled = currentValue >= maxValue;
}
function $ffb2f4ba9799f042$var$updateAddToCartQuantity(inputElement) {
    // Find the closest WooCommerce product container
    const productContainer = inputElement.closest(".product");
    if (!productContainer) return;
    // Find the "Add to Cart" button inside this product
    const addToCartButton = productContainer.querySelector(".add_to_cart_button");
    if (addToCartButton) addToCartButton.setAttribute("data-quantity", inputElement.value);
}
/**
 * Select-Dropdown component
 */ const $ffb2f4ba9799f042$var$njamitoSelectElements = document.querySelectorAll('.njamito-select');
if ($ffb2f4ba9799f042$var$njamitoSelectElements) document.addEventListener("click", (event)=>{
    $ffb2f4ba9799f042$var$njamitoSelectElements.forEach((select)=>{
        const id = select.getAttribute('data-id');
        const input = id ? document.getElementById(id) : null;
        if (input && !select.contains(event.target)) input.checked = false;
    });
});


/**
 * Header bag count.
 *
 * Mirrors the `span.niamito-cart-count` fragment (inc/cart-count.php) onto the
 * header bag badge after an AJAX cart change.
 *
 * The badge is drawn by CSS as `.icon--cart::after` with
 * `content: attr(data-cart-qty)`, and is force-hidden unless the body carries
 * `cart-not-empty` — which is set server-side at page load only. So both the
 * attribute and that class have to be updated here, or the number silently
 * stays at its page-load value (or never appears at all, going from an empty
 * cart to a full one).
 *
 * Deliberately not guarded on the side cart drawer: the count has to keep
 * working when `enable_custom_side_cart` is off and the tooltip
 * (inc/cart-tooltip.php) is the confirmation UI instead.
 */ // Wrapped in a block so the jQuery alias stays local: these modules are
// concatenated without import/export, so a top-level `const $` would collide
// with the one in singleProductAddToCart.ts.
{
    const $ = window.jQuery;
    const syncCartCount = ()=>{
        // Any of the carriers will do — desktop and mobile hold the same number, and
        // WooCommerce replaces both with the same fragment.
        const carrier = document.querySelector(".niamito-cart-count");
        if (!carrier) return;
        const count = carrier.getAttribute("data-cart-count") ?? "0";
        document.querySelectorAll(".icon--cart").forEach((el)=>el.setAttribute("data-cart-qty", count));
        document.body.classList.toggle("cart-not-empty", parseInt(count, 10) > 0);
    };
    if ($) // `added_to_cart` is WooCommerce's own (archive/loop AJAX); the namespaced
    // one comes from singleProductAddToCart.ts, which avoids core's event so
    // core does not append its "View cart" link beside the button. The refresh
    // events cover removals and cross-tab syncing.
    $(document.body).on("added_to_cart niamito_added_to_cart wc_fragments_refreshed wc_fragments_loaded", syncCartCount);
    // Initial sync: fragments may have been applied from the session cache before
    // this script ran, leaving the carrier ahead of the server-rendered badge.
    syncCartCount();
}

/**
 * Custom Side Cart drawer.
 *
 * Auto-opens on WooCommerce archive add-to-cart and removes a line via the
 * njamito_remove_cart_item endpoint (then asks WooCommerce to refresh
 * fragments). The header bag badge is owned by cartCount.ts, which stays out of
 * this module so the count also works when the drawer is switched off.
 *
 * Guarded on the drawer shell: when the Main Options toggle is off the markup is
 * absent and nothing below runs.
 */ const $b6405ec9a86ae0d2$var$sideCart = document.querySelector(".njamito-side-cart");
if ($b6405ec9a86ae0d2$var$sideCart) {
    const overlay = $b6405ec9a86ae0d2$var$sideCart.querySelector(".njamito-side-cart__overlay");
    const closeBtn = $b6405ec9a86ae0d2$var$sideCart.querySelector(".njamito-side-cart__close");
    const $ = window.jQuery;
    const ajax = window.njamito_ajax;
    // Mirrors the state hamburger.ts sets, so the bag can dismiss the mobile nav
    // without the two modules importing each other.
    const closeMobileNav = ()=>{
        const nav = document.getElementById("mobileNav");
        if (!nav || !nav.classList.contains("active")) return;
        nav.classList.remove("active");
        document.getElementById("menuOverlay")?.classList.remove("active");
        document.getElementById("menuButton")?.setAttribute("aria-expanded", "false");
        document.body.classList.remove("mobile-nav-open");
        document.documentElement.classList.remove("mobile-nav-open");
    };
    const openDrawer = ()=>{
        $b6405ec9a86ae0d2$var$sideCart.classList.add("is-open");
        $b6405ec9a86ae0d2$var$sideCart.setAttribute("aria-hidden", "false");
        document.body.classList.add("side-cart-open");
    };
    const closeDrawer = ()=>{
        $b6405ec9a86ae0d2$var$sideCart.classList.remove("is-open");
        $b6405ec9a86ae0d2$var$sideCart.setAttribute("aria-hidden", "true");
        document.body.classList.remove("side-cart-open");
    };
    // Close interactions.
    closeBtn?.addEventListener("click", closeDrawer);
    overlay?.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeDrawer();
    });
    // Delegated clicks inside the drawer (contents get swapped by fragments).
    $b6405ec9a86ae0d2$var$sideCart.addEventListener("click", (e)=>{
        const target = e.target;
        // Continue Shopping -> just close. In the filled cart it is a link to the
        // shop; modified clicks (new tab/window) keep that behaviour.
        if (target.closest(".njamito-side-cart__continue")) {
            const me = e;
            if (me.metaKey || me.ctrlKey || me.shiftKey || me.altKey || me.button !== 0) return;
            e.preventDefault();
            closeDrawer();
            return;
        }
        // Remove line.
        const removeBtn = target.closest(".njamito-side-cart__remove");
        if (removeBtn && ajax) {
            e.preventDefault();
            const key = removeBtn.getAttribute("data-cart-item-key");
            if (!key) return;
            removeBtn.classList.add("is-loading");
            const body = new FormData();
            body.append("cart_item_key", key);
            body.append("nonce", ajax.nonce);
            // WooCommerce wc-ajax endpoint (relative -> same origin -> shared cart session).
            // Built from WooCommerce's localised URL so it keeps the WPML language
            // prefix: a bare `/?wc-ajax=` runs in the default language and lets WCML
            // re-key the cart lines against the wrong translation.
            const params = window.wc_cart_fragments_params || window.wc_add_to_cart_params;
            const removeUrl = params?.wc_ajax_url ? String(params.wc_ajax_url).replace("%%endpoint%%", "njamito_remove_cart_item") : "/?wc-ajax=njamito_remove_cart_item";
            fetch(removeUrl, {
                method: "POST",
                body: body,
                credentials: "same-origin"
            }).then((r)=>r.json()).then((res)=>{
                if (res && res.success && $) $(document.body).trigger("wc_fragment_refresh");
                else removeBtn.classList.remove("is-loading");
            }).catch(()=>removeBtn.classList.remove("is-loading"));
        }
    });
    // Header bag -> open the drawer instead of navigating to the cart page.
    // An empty cart page is a dead end, and redirecting the icon to the shop
    // instead would teach the wrong affordance: the bag has to keep meaning "your
    // cart" so it is still the way back once there is something in it. The drawer
    // has its own empty state, so it answers both cases in place.
    //
    // The <a href> is left intact as the no-JS fallback; only the click is taken.
    document.querySelectorAll(".icon--cart a").forEach((link)=>{
        link.addEventListener("click", (e)=>{
            // Let modified clicks (new tab/window, downloads) behave normally.
            const me = e;
            if (me.metaKey || me.ctrlKey || me.shiftKey || me.altKey || me.button !== 0) return;
            e.preventDefault();
            // The mobile nav is a fixed drawer over the page; leaving it open would
            // bury the side cart behind it.
            closeMobileNav();
            openDrawer();
        });
    });
    // Other "open cart" links (the sticky cart bar, inc/sticky-cart-bar.php) ask
    // for the drawer too. Delegated, because the bar's links live inside a cart
    // fragment and are replaced on every cart change.
    document.addEventListener("click", (e)=>{
        const link = e.target.closest("[data-niamito-open-cart]");
        if (!link) return;
        const me = e;
        if (me.metaKey || me.ctrlKey || me.shiftKey || me.altKey || me.button !== 0) return;
        e.preventDefault();
        closeMobileNav();
        openDrawer();
    });
    // WooCommerce fragment events (jQuery custom events).
    if ($) // `added_to_cart` is WooCommerce's own (archive/loop AJAX); the namespaced
    // one comes from singleProductAddToCart.ts, which avoids core's event so
    // core does not append its "View cart" link beside the button.
    $(document.body).on("added_to_cart niamito_added_to_cart", openDrawer);
}


/**
 * Add-to-cart confirmation tooltip.
 *
 * Shown when the custom side cart is switched off: without the drawer sliding
 * open, an AJAX add is otherwise silent apart from the header badge ticking up.
 * Anchors a short "added" popover to whichever header bag is visible and offers
 * a way through to the cart page.
 *
 * Guarded on the markup: inc/cart-tooltip.php only renders it when the drawer is
 * off, so with the drawer on nothing below runs.
 */ const $a4b45f8a1cb17921$var$tooltips = Array.from(document.querySelectorAll(".niamito-cart-tooltip"));
if ($a4b45f8a1cb17921$var$tooltips.length) {
    const $ = window.jQuery;
    const VISIBLE_MS = 4000;
    // One timer across all instances: only ever one tooltip is on screen (the
    // other sits in the hidden breakpoint's header), so they share the schedule.
    let hideTimer;
    const clearTimer = ()=>{
        if (hideTimer !== undefined) {
            window.clearTimeout(hideTimer);
            hideTimer = undefined;
        }
    };
    const hideAll = ()=>{
        clearTimer();
        $a4b45f8a1cb17921$var$tooltips.forEach((el)=>{
            el.classList.remove("is-open");
            el.hidden = true;
        });
    };
    const startTimer = ()=>{
        clearTimer();
        hideTimer = window.setTimeout(hideAll, VISIBLE_MS);
    };
    /**
   * Reveal every instance. The one in the hidden header is display:none via the
   * breakpoint's own rules, so showing both is harmless and saves us guessing
   * which header is live at the current width.
   *
   * `hidden` is dropped a frame before `is-open` goes on so the CSS transition
   * has a start state to animate from.
   */ const show = ()=>{
        $a4b45f8a1cb17921$var$tooltips.forEach((el)=>{
            el.hidden = false;
        });
        window.requestAnimationFrame(()=>{
            $a4b45f8a1cb17921$var$tooltips.forEach((el)=>el.classList.add("is-open"));
        });
        startTimer();
    };
    $a4b45f8a1cb17921$var$tooltips.forEach((el)=>{
        // Hovering or tabbing in means the shopper is reaching for the CTA — the
        // tooltip must not evaporate mid-reach. Timer resumes when they leave.
        el.addEventListener("mouseenter", clearTimer);
        el.addEventListener("mouseleave", ()=>{
            if (!el.hidden) startTimer();
        });
        el.addEventListener("focusin", clearTimer);
        el.addEventListener("focusout", ()=>{
            if (!el.hidden) startTimer();
        });
        // Clicks inside must not reach the outside-click handler below.
        el.addEventListener("click", (e)=>e.stopPropagation());
    });
    document.addEventListener("click", ()=>hideAll());
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") hideAll();
    });
    if ($) // `added_to_cart` covers WooCommerce's own archive/loop AJAX. The single
    // product page fires the namespaced event instead (singleProductAddToCart.ts)
    // so it can add to the cart without WooCommerce's handler appending its
    // "View cart" link next to the button.
    $(document.body).on("added_to_cart niamito_added_to_cart", show);
}


/**
 * Sticky cart bar.
 *
 * Shows the bottom bar while the cart has items and hides it when it empties.
 * The bar's contents are a WooCommerce fragment (inc/sticky-cart-bar.php), so
 * after every cart change the fresh `data-cart-count` on the fragment root is
 * the source of truth; this module only mirrors it onto the shell and body.
 *
 * `has-sticky-cart-bar` on <body> reserves room at the bottom of the page so
 * the footer is never stuck behind the bar. It is also set server-side, so a
 * page loaded with a full cart does not jump.
 *
 * Guarded on the markup: with the Main Options toggle off, or on the cart and
 * checkout pages, the bar is not rendered and nothing below runs.
 */ {
    const bar = document.querySelector(".niamito-sticky-cart-bar");
    if (bar) {
        const $ = window.jQuery;
        let hideTimer;
        const show = ()=>{
            if (hideTimer !== undefined) {
                window.clearTimeout(hideTimer);
                hideTimer = undefined;
            }
            document.body.classList.add("has-sticky-cart-bar");
            if (bar.classList.contains("is-visible")) return;
            // `hidden` is dropped a frame before `is-visible` goes on so the slide-in
            // has a start state to animate from.
            bar.hidden = false;
            window.requestAnimationFrame(()=>bar.classList.add("is-visible"));
        };
        const hide = ()=>{
            document.body.classList.remove("has-sticky-cart-bar");
            if (!bar.classList.contains("is-visible")) return;
            bar.classList.remove("is-visible");
            // Matches the transition in _sticky-cart-bar.css; `hidden` then takes the
            // links out of the tab order.
            hideTimer = window.setTimeout(()=>{
                bar.hidden = true;
                hideTimer = undefined;
            }, 300);
        };
        const sync = ()=>{
            const contents = bar.querySelector(".niamito-sticky-cart-bar__contents");
            const count = parseInt(contents?.getAttribute("data-cart-count") ?? "0", 10);
            if (count > 0) show();
            else hide();
        };
        if ($) // Fragment events cover adds, removals and cross-tab syncing; the add
        // events are listed too because the single product page fires its own
        // namespaced one (singleProductAddToCart.ts).
        $(document.body).on("added_to_cart niamito_added_to_cart removed_from_cart wc_fragments_refreshed wc_fragments_loaded", sync);
        // Fragments may already have been applied from the session cache before
        // this ran, leaving the markup ahead of the server-rendered state.
        sync();
    }
}

/**
 * Single product page — AJAX add-to-cart that opens the side cart.
 *
 * WooCommerce's single-product form (`form.cart` + `.single_add_to_cart_button`)
 * is a plain POST that reloads the page. Intercept it, add via WooCommerce's
 * `wc-ajax=add_to_cart` endpoint, apply the returned fragments, and fire
 * `added_to_cart` so the drawer opens and the header badge updates — matching the
 * archive add-to-cart behaviour.
 *
 * Only simple products are handled; variable products (with a `variation_id`
 * field) and disabled buttons fall through to the native submit.
 */ const $1b5e2f661b483aad$var$$ = window.jQuery;
if ($1b5e2f661b483aad$var$$) $1b5e2f661b483aad$var$$(function() {
    $1b5e2f661b483aad$var$$(document.body).on("submit", "form.cart", function(e) {
        const $form = $1b5e2f661b483aad$var$$(this);
        const $button = $form.find(".single_add_to_cart_button");
        const productId = $button.val();
        // Bail to the native submit for anything that isn't a plain simple-product add.
        if (!$button.length || $button.is(".disabled") || !productId || $form.find("[name='variation_id']").length) return;
        e.preventDefault();
        const quantity = $form.find("input.qty").val() || 1;
        $button.removeClass("added").addClass("loading");
        const data = new FormData();
        data.append("product_id", String(productId));
        data.append("quantity", String(quantity));
        // WooCommerce's localised endpoint carries the WPML language prefix
        // (`/en/?wc-ajax=…`). A bare `/?wc-ajax=` runs in the default language
        // while posting the translated product ID, and WCML's cross-language
        // re-keying then drops or splits the line instead of adding to it.
        const params = window.wc_add_to_cart_params;
        const addToCartUrl = params?.wc_ajax_url ? String(params.wc_ajax_url).replace("%%endpoint%%", "add_to_cart") : "/?wc-ajax=add_to_cart";
        fetch(addToCartUrl, {
            method: "POST",
            body: data,
            credentials: "same-origin"
        }).then((r)=>r.json()).then((res)=>{
            if (!res) return;
            // WooCommerce asks for a redirect (e.g. "AJAX add to cart" disabled) or errors out.
            if (res.error && res.product_url) {
                window.location.assign(res.product_url);
                return;
            }
            if (res.fragments) Object.keys(res.fragments).forEach((key)=>{
                $1b5e2f661b483aad$var$$(key).replaceWith(res.fragments[key]);
            });
            $button.removeClass("loading").addClass("added");
            // Namespaced rather than WooCommerce's own `added_to_cart`: core's
            // add-to-cart.js listens for that one and appends a "View cart" link
            // beside the button, which we do not want on the single product page.
            // Fragments are applied above, so nothing of core's handler is needed.
            // sideCart.ts / cartTooltip.ts both listen for this event.
            $1b5e2f661b483aad$var$$(document.body).trigger("niamito_added_to_cart", [
                res.fragments,
                res.cart_hash,
                $button
            ]);
        }).catch(()=>{
            // Network/parse failure: fall back to a normal page-reload submit.
            $button.removeClass("loading");
            $form.off("submit");
            this.submit();
        });
    });
});


/**
 * Product promo area / cart discount hint — keep them in step with the cart.
 *
 * Both are rendered server-side (inc/product-promo.php). When the cart changes
 * without a page load, ask `wc-ajax=niamito_product_promo` for a fresh copy and
 * swap it in. The URL comes from the element itself: it carries the WPML
 * language prefix, so the reply is in the page language.
 *
 * Refreshes are triggered by:
 *   - `data-niamito-promo-geo` on load — the page was rendered without the
 *     visitor's IP (it may be a cached copy), and the endpoint geolocates
 *   - `niamito_added_to_cart` — single product AJAX add (singleProductAddToCart.ts)
 *   - `added_to_cart` / `removed_from_cart` / `wc_fragments_refreshed` — archive
 *     adds, the side cart and other fragment refreshes
 *   - the Cart block's `wc/store/cart` data store — quantity steppers, removals,
 *     coupons and the shipping calculator on the cart page
 */ const $e1c60d82e017f599$var$PROMO_SELECTOR = "[data-niamito-promo]";
let $e1c60d82e017f599$var$promoRefreshTimer;
let $e1c60d82e017f599$var$promoRefreshAbort;
let $e1c60d82e017f599$var$promoLiveRegion;
/**
 * Reads a changed discount hint out to screen readers. The hint itself cannot
 * be a live region: every refresh replaces it, and a replaced region is not
 * announced. This one stays put.
 */ function $e1c60d82e017f599$var$announcePromoHint(text) {
    if (!$e1c60d82e017f599$var$promoLiveRegion) {
        $e1c60d82e017f599$var$promoLiveRegion = document.createElement("div");
        $e1c60d82e017f599$var$promoLiveRegion.className = "niamito-product-promo__live";
        $e1c60d82e017f599$var$promoLiveRegion.setAttribute("role", "status");
        $e1c60d82e017f599$var$promoLiveRegion.setAttribute("aria-live", "polite");
        document.body.appendChild($e1c60d82e017f599$var$promoLiveRegion);
    }
    $e1c60d82e017f599$var$promoLiveRegion.textContent = text;
}
const $e1c60d82e017f599$var$promoHintText = (el)=>el?.querySelector(".niamito-discount-progress__hint, .niamito-discount-progress__note")?.textContent?.trim() || "";
function $e1c60d82e017f599$var$refreshPromoElement(el) {
    const url = el.dataset.niamitoPromoUrl;
    if (!url) return Promise.resolve();
    const params = new URLSearchParams({
        context: el.dataset.niamitoPromo || "product"
    });
    if (el.dataset.niamitoPromoProduct) params.set("product_id", el.dataset.niamitoPromoProduct);
    return fetch(`${url}${url.includes("?") ? "&" : "?"}${params}`, {
        credentials: "same-origin",
        signal: $e1c60d82e017f599$var$promoRefreshAbort?.signal
    }).then((r)=>r.json()).then((res)=>{
        if (!res?.success || typeof res.data?.html !== "string") return;
        // An empty reply means no card applies any more (say the product went
        // out of stock): keep an empty element so a later change can fill it.
        if (res.data.html === "") {
            el.innerHTML = "";
            return;
        }
        const template = document.createElement("template");
        template.innerHTML = res.data.html.trim();
        const next = template.content.firstElementChild;
        if (!next) return;
        const before = $e1c60d82e017f599$var$promoHintText(el);
        el.replaceWith(next);
        const after = $e1c60d82e017f599$var$promoHintText(next);
        if (after && after !== before) $e1c60d82e017f599$var$announcePromoHint(after);
    }).catch(()=>{
    // Aborted by a newer refresh, or offline: the current copy stays.
    });
}
function $e1c60d82e017f599$var$refreshPromos() {
    window.clearTimeout($e1c60d82e017f599$var$promoRefreshTimer);
    $e1c60d82e017f599$var$promoRefreshTimer = window.setTimeout(()=>{
        $e1c60d82e017f599$var$promoRefreshAbort?.abort();
        $e1c60d82e017f599$var$promoRefreshAbort = new AbortController();
        document.querySelectorAll($e1c60d82e017f599$var$PROMO_SELECTOR).forEach((el)=>void $e1c60d82e017f599$var$refreshPromoElement(el));
    }, 250);
}
function $e1c60d82e017f599$var$watchPromoCartBlock() {
    const data = window.wp?.data;
    if (!data?.select || !data?.subscribe) return;
    // What the promo depends on — lines and quantities, coupons, the total and
    // the shipping destination — so the key moves when those do and not on every
    // store tick. null until the store has loaded the cart.
    const promoCartKey = ()=>{
        const cart = data.select("wc/store/cart")?.getCartData?.();
        if (!Array.isArray(cart?.items)) return null;
        const address = cart.shippingAddress || {};
        return [
            cart.items.map((item)=>`${item.key}:${item.quantity}`).join(","),
            (cart.coupons || []).map((coupon)=>coupon.code).join(","),
            cart.totals?.total_price,
            `${address.country}/${address.state}/${address.postcode}`
        ].join("|");
    };
    let last = promoCartKey();
    data.subscribe(()=>{
        const key = promoCartKey();
        if (key === null || key === last) return;
        // The store loading the cart the page was rendered with is not a change.
        const loaded = last !== null;
        last = key;
        if (loaded) $e1c60d82e017f599$var$refreshPromos();
    });
}
/**
 * Moves the cart-page promo under the cart's item list, ahead of the totals.
 *
 * The server prints it in front of the Cart block (PHP cannot reach inside the
 * block: its markup is rebuilt by React), and CSS keeps it hidden there. Once
 * the block has rendered its item column, the promo is appended to it. The
 * observer puts it back whenever the block rebuilds that column or a refresh
 * swaps the element.
 *
 * Emptying the cart unmounts the column and the promo with it, so the last
 * element seen is kept and re-appended when a filled cart comes back.
 */ function $e1c60d82e017f599$var$placeCartPromo() {
    const root = document.querySelector(".wp-block-woocommerce-cart");
    if (!root) return;
    let promo = document.querySelector('[data-niamito-promo="cart"]');
    const place = ()=>{
        promo = document.querySelector('[data-niamito-promo="cart"]') || promo;
        const column = root.querySelector(".wc-block-cart__main");
        if (promo && column && promo.parentElement !== column) column.appendChild(promo);
    };
    place();
    new MutationObserver(place).observe(root, {
        childList: true,
        subtree: true
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    if (!document.querySelector($e1c60d82e017f599$var$PROMO_SELECTOR)) return;
    const $ = window.jQuery;
    if ($) $(document.body).on("niamito_added_to_cart added_to_cart removed_from_cart wc_fragments_refreshed", $e1c60d82e017f599$var$refreshPromos);
    if (document.querySelector('[data-niamito-promo="cart"]')) {
        $e1c60d82e017f599$var$placeCartPromo();
        $e1c60d82e017f599$var$watchPromoCartBlock();
    }
    if (document.querySelector("[data-niamito-promo-geo]")) $e1c60d82e017f599$var$refreshPromos();
});


document.addEventListener('DOMContentLoaded', function() {
    const counters = document.querySelectorAll('.counter');
    if (!counters) return;
    counters.forEach((counter)=>{
        const counterDigits = counter.querySelectorAll('.counter__digit');
        const totalDigits = counterDigits.length;
        const targetCount = counter.getAttribute('data-count') || "000000";
        const animationDuration = 3000; // Duration in milliseconds
        function animateDigit(digitElement, targetValue, delay) {
            let currentValue = 0;
            const increment = targetValue / (animationDuration / 100);
            function updateDigit() {
                if (currentValue < targetValue) {
                    currentValue += increment;
                    digitElement.textContent = Math.floor(currentValue);
                    requestAnimationFrame(updateDigit);
                } else digitElement.textContent = targetValue;
            }
            setTimeout(updateDigit, delay);
        }
        function startAnimation() {
            counterDigits.forEach((digit, index)=>{
                if (index >= totalDigits - 6) {
                    const delay = (totalDigits - index - 1) * 100; // Delay for each digit
                    const targetValue = parseInt(targetCount.charAt(index), 10);
                    if (targetValue > 0) animateDigit(digit, targetValue, delay);
                }
            });
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.intersectionRatio >= 1) {
                    startAnimation();
                    observer.unobserve(counter);
                }
            });
            for (const { isIntersecting: isIntersecting, target: target } of entries)if (isIntersecting) {
                startAnimation();
                observer.unobserve(target);
            }
        }, {
            root: null,
            rootMargin: '-100px 0px',
            threshold: [
                1.0
            ]
        });
        observer.observe(counter);
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.njamito-hero-media__video[data-source-src]');
    videos.forEach((video)=>{
        function loadVideo(videoElement) {
            const source = document.createElement('source');
            source.src = videoElement.dataset.sourceSrc;
            source.type = videoElement.dataset.sourceType;
            videoElement.appendChild(source);
            videoElement.load();
            videoElement.play().catch((err)=>{
                console.log("Autoplay failed:", err);
            });
        }
        const style = window.getComputedStyle(video);
        if (style.display !== 'none' && video.querySelector('source') === null) loadVideo(video);
        const observer = new IntersectionObserver((entries, obs)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && entry.target.querySelector('source') === null) {
                    loadVideo(entry.target);
                    obs.unobserve(entry.target); // Stop observing after load
                }
            });
        }, {
            threshold: 0.1 // Trigger when at least 10% of the video is visible
        });
        observer.observe(video);
    });
    // YouTube hero backgrounds: drive via the IFrame API so we can autoplay
    // muted, loop seamlessly, and reveal the frame only once it is PLAYING —
    // which hides YouTube's centred play / prev / next chrome that shows while
    // the player is paused or loading.
    const ytFrames = Array.from(document.querySelectorAll('.njamito-hero-media__yt-player'));
    if (ytFrames.length) {
        const w = window;
        const initPlayers = ()=>{
            ytFrames.forEach((frame)=>{
                let loopTimer;
                const startSeamlessLoop = (player)=>{
                    if (loopTimer) return;
                    // Poll and jump back BEFORE the clip ends — reaching the real
                    // end shows YouTube's replay/pause overlay for a beat.
                    loopTimer = window.setInterval(()=>{
                        const duration = player.getDuration();
                        const current = player.getCurrentTime();
                        if (duration > 0 && duration - current < 0.4) player.seekTo(0, true);
                    }, 250);
                };
                new w.YT.Player(frame, {
                    events: {
                        onReady: (e)=>{
                            e.target.mute();
                            e.target.playVideo();
                        },
                        onStateChange: (e)=>{
                            if (e.data === w.YT.PlayerState.PLAYING) startSeamlessLoop(e.target);
                            // Safety net if the poll ever misses the window.
                            if (e.data === w.YT.PlayerState.ENDED) {
                                e.target.seekTo(0, true);
                                e.target.playVideo();
                            }
                        }
                    }
                });
            });
        };
        if (w.YT && w.YT.Player) initPlayers();
        else {
            const prev = w.onYouTubeIframeAPIReady;
            w.onYouTubeIframeAPIReady = ()=>{
                if (typeof prev === 'function') prev();
                initPlayers();
            };
            if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                document.head.appendChild(tag);
            }
        }
    }
});


// Fit-to-width titles: size each heading inside `.njamito-section-title--fit`
// so its text spans the full container width. Pure CSS can't measure text, so
// we measure the real text width (via a Range) and scale the font-size to match.
function $d2baa90d203f36ef$var$fitHeading(heading, container) {
    const cs = window.getComputedStyle(container);
    const avail = container.clientWidth - parseFloat(cs.paddingLeft || '0') - parseFloat(cs.paddingRight || '0');
    if (avail <= 0) return;
    // Measure text width at a known reference size, then scale linearly.
    const REF = 100;
    heading.style.fontSize = `${REF}px`;
    const range = document.createRange();
    range.selectNodeContents(heading);
    const textWidth = range.getBoundingClientRect().width;
    if (textWidth > 0) heading.style.fontSize = `${REF * avail / textWidth}px`;
}
function $d2baa90d203f36ef$var$fitAll(reveal = false) {
    const containers = Array.from(document.querySelectorAll('.njamito-section-title--fit'));
    containers.forEach((container)=>{
        const headings = Array.from(container.querySelectorAll('h1, h2, h3, h4, h5, h6'));
        headings.forEach((h)=>$d2baa90d203f36ef$var$fitHeading(h, container));
        // Reveal only once sizing is final, so the text never shows at the
        // wrong size (`.is-fit` drops the visibility:hidden guard).
        if (reveal) container.classList.add('is-fit');
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    if (!document.querySelector('.njamito-section-title--fit')) return;
    // Measure while hidden, then measure again + reveal once web fonts are ready
    // (the real face changes text metrics). A timeout guarantees the title never
    // stays hidden if fonts.ready stalls. Single visible paint.
    $d2baa90d203f36ef$var$fitAll(false);
    const fontsReady = 'fonts' in document ? document.fonts.ready : Promise.resolve();
    const timeout = new Promise((resolve)=>setTimeout(resolve, 500));
    Promise.race([
        fontsReady,
        timeout
    ]).then(()=>$d2baa90d203f36ef$var$fitAll(true));
    let raf = 0;
    window.addEventListener('resize', ()=>{
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(()=>$d2baa90d203f36ef$var$fitAll(false));
    });
});


/**
 * Referral share block (thank-you page).
 *
 * Uses the Web Share API where available — one tap into whichever app the
 * customer actually uses — and falls back to explicit WhatsApp / SMS / email
 * links plus copy-to-clipboard. All copy comes from data attributes rendered by
 * PHP so translation stays in the logineko text domain.
 */ const $7d2e64c4caf53e9c$var$block = document.querySelector(".referral-share");
if ($7d2e64c4caf53e9c$var$block) {
    const url = $7d2e64c4caf53e9c$var$block.dataset.referralUrl ?? "";
    const title = $7d2e64c4caf53e9c$var$block.dataset.shareTitle ?? "";
    const text = $7d2e64c4caf53e9c$var$block.dataset.shareText ?? "";
    const copiedLabel = $7d2e64c4caf53e9c$var$block.dataset.copiedLabel ?? "Copied";
    const nativeButton = $7d2e64c4caf53e9c$var$block.querySelector(".referral-share__native");
    const copyButton = $7d2e64c4caf53e9c$var$block.querySelector(".referral-share__copy");
    const targets = $7d2e64c4caf53e9c$var$block.querySelector(".referral-share__targets");
    // Web Share is the better mobile path, so prefer it and hide the per-app row.
    if (nativeButton && typeof navigator.share === "function") {
        nativeButton.hidden = false;
        targets?.setAttribute("hidden", "hidden");
        // navigator.share() must be called synchronously from the user gesture;
        // awaiting anything first throws NotAllowedError.
        nativeButton.addEventListener("click", ()=>{
            navigator.share({
                title: title,
                text: text,
                url: url
            }).catch((error)=>{
                // AbortError just means the user dismissed the share sheet — leave the
                // UI alone. Anything else means sharing is genuinely unavailable, so
                // restore the per-app row.
                if (error && error.name === "AbortError") return;
                targets?.removeAttribute("hidden");
            });
        });
    }
    if (copyButton) {
        // The button is icon-only, so the label lives in aria-label/title — that is
        // what has to carry the copied confirmation for screen readers and hover.
        const originalLabel = copyButton.getAttribute("aria-label") ?? "";
        copyButton.addEventListener("click", async ()=>{
            try {
                await navigator.clipboard.writeText(url);
            } catch  {
                // Older Safari and any non-secure context: fall back to selecting the
                // field so the customer can copy manually.
                const field = $7d2e64c4caf53e9c$var$block.querySelector(".referral-share__url");
                field?.select();
                return;
            }
            copyButton.setAttribute("aria-label", copiedLabel);
            copyButton.setAttribute("title", copiedLabel);
            copyButton.classList.add("is-copied");
            window.setTimeout(()=>{
                copyButton.setAttribute("aria-label", originalLabel);
                copyButton.setAttribute("title", originalLabel);
                copyButton.classList.remove("is-copied");
            }, 2000);
        });
    }
}


/**
 * Native newsletter signup form.
 *
 * Submits template-parts/newsletter-form.php to the
 * niamito_newsletter_subscribe endpoint and reports what came back.
 *
 * The landing-page signup (landing.ts) is the ancestor of this flow, but it
 * handles exactly one outcome: on success it removes the form, and on failure
 * `if (!jsonResponse.success) {}` does nothing at all — a visitor whose signup
 * failed watches a spinner and is told nothing. Every failure is named here
 * instead: an address the browser can reject without asking the server, an
 * endpoint that answered with an error, and a request that never arrived.
 *
 * All copy comes from `niamitoNewsletter`, localised in inc/enqueue.php, so the
 * messages are translated with the rest of the theme rather than hardcoded in
 * English here.
 */ // Marks the file as a module. Without it every name below lands in the shared
// global scope the other bundled scripts occupy, where `init` already collides
// with one of them.
// Deliberately loose: a full RFC 5322 check belongs on the server, which does
// one. This only spares the visitor a round trip for an obviously wrong entry.
const $b0fa09e458d61a52$var$EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function $b0fa09e458d61a52$var$messages() {
    return window.niamitoNewsletter || {};
}
function $b0fa09e458d61a52$var$ajax() {
    const data = window.njamito_ajax;
    return data && data.ajax_url ? data : null;
}
/**
 * Turn the endpoint's answer into a message in the reader's language.
 *
 * The endpoint returns wording too, but it is answered through admin-ajax,
 * where the catalogue that gets loaded is not always the one the page was
 * rendered with — an error can come back in English on a German page. The code
 * is language-free, so it is what gets matched; the returned text is kept only
 * as a fallback for a code this build does not know.
 */ function $b0fa09e458d61a52$var$messageFor(copy, code, fallback) {
    switch(code){
        case "invalid_email":
            return copy.invalidEmail;
        case "expired":
            return copy.expired;
        case "already_subscribed":
            return copy.alreadySigned;
        case "subscribed":
            return copy.success;
        case "not_configured":
            return copy.genericError;
        default:
            return fallback || copy.genericError;
    }
}
function $b0fa09e458d61a52$var$setLoading(form, loading) {
    const submit = form.querySelector(".niamito-newsletter-form__submit");
    form.classList.toggle("is-loading", loading);
    if (submit) {
        submit.classList.toggle("loading", loading);
        submit.disabled = loading;
    }
}
function $b0fa09e458d61a52$var$showError(form, text) {
    const box = form.querySelector(".niamito-newsletter-form__message");
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
}
function $b0fa09e458d61a52$var$clearError(form) {
    const box = form.querySelector(".niamito-newsletter-form__message");
    if (box) {
        box.textContent = "";
        box.hidden = true;
    }
}
/**
 * Swap the form out for the success message.
 *
 * The form is hidden rather than removed so the section keeps its height and
 * the layout does not jump under the reader. Focus moves to the message
 * because the element that had focus — the submit button — is now hidden, and
 * a screen reader would otherwise be left with nothing to announce.
 */ function $b0fa09e458d61a52$var$showSuccess(form, text) {
    const container = form.parentElement || document;
    const success = container.querySelector(".product-newsletter__success-message");
    form.hidden = true;
    if (!success) return;
    if (text) {
        // The message carries a check icon as a sibling element, so the text goes
        // into its own span — writing to the container would replace the icon.
        const label = success.querySelector(".product-newsletter__success-text");
        (label || success).textContent = text;
    }
    success.classList.add("is-visible");
    success.setAttribute("tabindex", "-1");
    // preventScroll, then scroll deliberately below: focus() alone jumps the
    // message to the edge of the viewport, which on a phone can leave it half
    // under the address bar.
    success.focus({
        preventScroll: true
    });
    const box = success.getBoundingClientRect();
    const offscreen = box.top < 0 || box.bottom > window.innerHeight;
    if (offscreen) {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        success.scrollIntoView({
            behavior: reduced ? "auto" : "smooth",
            block: "center"
        });
    }
}
function $b0fa09e458d61a52$var$setup(form) {
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        const copy = $b0fa09e458d61a52$var$messages();
        const endpoint = $b0fa09e458d61a52$var$ajax();
        const input = form.querySelector('input[name="email_address"]');
        if (!input) return;
        const email = input.value.trim();
        if (!$b0fa09e458d61a52$var$EMAIL_PATTERN.test(email)) {
            $b0fa09e458d61a52$var$showError(form, copy.invalidEmail);
            input.focus();
            return;
        }
        // Without the localised endpoint there is nothing to post to. Saying so
        // beats a submit button that stays stuck in its loading state.
        if (!endpoint) {
            $b0fa09e458d61a52$var$showError(form, copy.genericError);
            return;
        }
        const honeypot = form.querySelector('input[name="niamito_hp"]');
        $b0fa09e458d61a52$var$clearError(form);
        $b0fa09e458d61a52$var$setLoading(form, true);
        const data = new FormData();
        data.append("action", "niamito_newsletter_subscribe");
        data.append("email_address", email);
        data.append("nonce", endpoint.nonce);
        // admin-ajax has no page to infer a language from. WPML reads the request
        // language off this parameter, and it is what puts the right `locale:` tag
        // on the Omnisend contact — without it every signup reports as the site's
        // default language.
        if (copy.lang) data.append("lang", copy.lang);
        if (honeypot) data.append("niamito_hp", honeypot.value);
        fetch(endpoint.ajax_url, {
            method: "POST",
            body: data
        }).then((response)=>// A non-JSON body means a PHP fatal or an HTML error page rather than
            // an answer from the endpoint; it is reported as a generic failure.
            response.json().catch(()=>null)).then((json)=>{
            $b0fa09e458d61a52$var$setLoading(form, false);
            if (!json) {
                $b0fa09e458d61a52$var$showError(form, copy.genericError);
                return;
            }
            if (json.success) {
                const payload = json.data || {};
                $b0fa09e458d61a52$var$showSuccess(form, $b0fa09e458d61a52$var$messageFor(copy, payload.code, payload.message));
                return;
            }
            const error = json.data || {};
            $b0fa09e458d61a52$var$showError(form, $b0fa09e458d61a52$var$messageFor(copy, error.code, error.message));
        }).catch(()=>{
            // Only a transport failure lands here: offline, DNS, a blocked
            // request. An HTTP error status resolves and is handled above.
            $b0fa09e458d61a52$var$setLoading(form, false);
            $b0fa09e458d61a52$var$showError(form, copy.networkError);
        });
    });
}
function $b0fa09e458d61a52$var$init() {
    document.querySelectorAll("[data-niamito-newsletter]").forEach($b0fa09e458d61a52$var$setup);
}
// The bundle is enqueued in the footer, below the section, so the form is
// normally already parsed. The readyState check covers the case where it is
// not — a deferred or moved script, or an optimisation plugin relocating it.
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $b0fa09e458d61a52$var$init);
else $b0fa09e458d61a52$var$init();


var $a6e6748126aae905$exports = {};
!function(e, t) {
    $a6e6748126aae905$exports = t();
}($a6e6748126aae905$exports, function() {
    return function(e) {
        function t(o) {
            if (n[o]) return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "dist/", t(0);
    }([
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var i = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
                }
                return e;
            }, r = n(1), a = (o(r), n(6)), u = o(a), c = n(7), s = o(c), f = n(8), d = o(f), l = n(9), p = o(l), m = n(10), b = o(m), v = n(11), y = o(v), g = n(14), h = o(g), w = [], k = !1, x = {
                offset: 120,
                delay: 0,
                easing: "ease",
                duration: 400,
                disable: !1,
                once: !1,
                startEvent: "DOMContentLoaded",
                throttleDelay: 99,
                debounceDelay: 50,
                disableMutationObserver: !1
            }, j = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
            }, O = function() {
                w = (0, h.default)(), j();
            }, M = function() {
                w.forEach(function(e, t) {
                    e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
                });
            }, S = function(e) {
                return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
            }, _ = function(e) {
                x = i(x, e), w = (0, h.default)();
                var t = document.all && !window.atob;
                return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && [
                    "complete",
                    "interactive"
                ].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function() {
                    j(!0);
                }) : document.addEventListener(x.startEvent, function() {
                    j(!0);
                }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function() {
                    (0, b.default)(w, x.once);
                }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
            };
            e.exports = {
                init: _,
                refresh: j,
                refreshHard: O
            };
        },
        function(e, t) {},
        ,
        ,
        ,
        ,
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function o(t) {
                        var n = b, o = v;
                        return b = v = void 0, k = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return k = e, h = setTimeout(f, t), M ? o(e) : g;
                    }
                    function a(e) {
                        var n = e - w, o = e - k, i = t - n;
                        return S ? j(i, y - o) : i;
                    }
                    function c(e) {
                        var n = e - w, o = e - k;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = O();
                        return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(O());
                    }
                    function m() {
                        var e = O(), n = c(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), o(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, k = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e, t, o) {
                    var r = !0, a = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
                        leading: r,
                        maxWait: t,
                        trailing: a
                    });
                }
                function i(e) {
                    var t = "undefined" == typeof e ? "undefined" : c(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function r(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
                }
                function a(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
                }
                function u(e) {
                    if ("number" == typeof e) return e;
                    if (a(e)) return f;
                    if (i(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = i(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(l, "");
                    var n = m.test(e);
                    return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
                }
                var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, s = "Expected a function", f = NaN, d = "[object Symbol]", l = /^\s+|\s+$/g, p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, b = /^0o[0-7]+$/i, v = parseInt, y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t, g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self, h = y || g || Function("return this")(), w = Object.prototype, k = w.toString, x = Math.max, j = Math.min, O = function() {
                    return h.Date.now();
                };
                e.exports = o;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function i(t) {
                        var n = b, o = v;
                        return b = v = void 0, O = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return O = e, h = setTimeout(f, t), M ? i(e) : g;
                    }
                    function u(e) {
                        var n = e - w, o = e - O, i = t - n;
                        return S ? x(i, y - o) : i;
                    }
                    function s(e) {
                        var n = e - w, o = e - O;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = j();
                        return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(j());
                    }
                    function m() {
                        var e = j(), n = s(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), i(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, O = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(c);
                    return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e) {
                    var t = "undefined" == typeof e ? "undefined" : u(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function i(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
                }
                function r(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
                }
                function a(e) {
                    if ("number" == typeof e) return e;
                    if (r(e)) return s;
                    if (o(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = o(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(d, "");
                    var n = p.test(e);
                    return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
                }
                var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, c = "Expected a function", s = NaN, f = "[object Symbol]", d = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t, y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self, g = v || y || Function("return this")(), h = Object.prototype, w = h.toString, k = Math.max, x = Math.min, j = function() {
                    return g.Date.now();
                };
                e.exports = n;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            "use strict";
            function n(e) {
                var t = void 0, o = void 0, i = void 0;
                for(t = 0; t < e.length; t += 1){
                    if (o = e[t], o.dataset && o.dataset.aos) return !0;
                    if (i = o.children && n(o.children)) return !0;
                }
                return !1;
            }
            function o() {
                return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            }
            function i() {
                return !!o();
            }
            function r(e, t) {
                var n = window.document, i = o(), r = new i(a);
                u = t, r.observe(n.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0
                });
            }
            function a(e) {
                e && e.forEach(function(e) {
                    var t = Array.prototype.slice.call(e.addedNodes), o = Array.prototype.slice.call(e.removedNodes), i = t.concat(o);
                    if (n(i)) return u();
                });
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = function() {};
            t.default = {
                isSupported: i,
                ready: r
            };
        },
        function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function o() {
                return navigator.userAgent || navigator.vendor || window.opera || "";
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                    }
                }
                return function(t, n, o) {
                    return n && e(t.prototype, n), o && e(t, o), t;
                };
            }(), r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, s = function() {
                function e() {
                    n(this, e);
                }
                return i(e, [
                    {
                        key: "phone",
                        value: function() {
                            var e = o();
                            return !(!r.test(e) && !a.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "mobile",
                        value: function() {
                            var e = o();
                            return !(!u.test(e) && !c.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "tablet",
                        value: function() {
                            return this.mobile() && !this.phone();
                        }
                    }
                ]), e;
            }();
            t.default = new s;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e, t, n) {
                var o = e.node.getAttribute("data-aos-once");
                t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
            }, o = function(e, t) {
                var o = window.pageYOffset, i = window.innerHeight;
                e.forEach(function(e, r) {
                    n(e, i + o, t);
                });
            };
            t.default = o;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(12), r = o(i), a = function(e, t) {
                return e.forEach(function(e, n) {
                    e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
                }), e;
            };
            t.default = a;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(13), r = o(i), a = function(e, t) {
                var n = 0, o = 0, i = window.innerHeight, a = {
                    offset: e.getAttribute("data-aos-offset"),
                    anchor: e.getAttribute("data-aos-anchor"),
                    anchorPlacement: e.getAttribute("data-aos-anchor-placement")
                };
                switch(a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement){
                    case "top-bottom":
                        break;
                    case "center-bottom":
                        n += e.offsetHeight / 2;
                        break;
                    case "bottom-bottom":
                        n += e.offsetHeight;
                        break;
                    case "top-center":
                        n += i / 2;
                        break;
                    case "bottom-center":
                        n += i / 2 + e.offsetHeight;
                        break;
                    case "center-center":
                        n += i / 2 + e.offsetHeight / 2;
                        break;
                    case "top-top":
                        n += i;
                        break;
                    case "bottom-top":
                        n += e.offsetHeight + i;
                        break;
                    case "center-top":
                        n += e.offsetHeight / 2 + i;
                }
                return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
            };
            t.default = a;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
                return {
                    top: n,
                    left: t
                };
            };
            t.default = n;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function(e) {
                    return {
                        node: e
                    };
                });
            };
            t.default = n;
        }
    ]);
});




var $5cDU9 = parcelRequire("5cDU9");
/*!
 * CSSPlugin 3.15.0
 * https://gsap.com
 *
 * Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $5cDU9 = parcelRequire("5cDU9");
var $3de7579eded08fad$var$_win, $3de7579eded08fad$var$_doc, $3de7579eded08fad$var$_docElement, $3de7579eded08fad$var$_pluginInitted, $3de7579eded08fad$var$_tempDiv, $3de7579eded08fad$var$_tempDivStyler, $3de7579eded08fad$var$_recentSetterPlugin, $3de7579eded08fad$var$_reverting, $3de7579eded08fad$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $3de7579eded08fad$var$_transformProps = {}, $3de7579eded08fad$var$_RAD2DEG = 180 / Math.PI, $3de7579eded08fad$var$_DEG2RAD = Math.PI / 180, $3de7579eded08fad$var$_atan2 = Math.atan2, $3de7579eded08fad$var$_bigNum = 1e8, $3de7579eded08fad$var$_capsExp = /([A-Z])/g, $3de7579eded08fad$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $3de7579eded08fad$var$_complexExp = /[\s,\(]\S/, $3de7579eded08fad$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $3de7579eded08fad$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $3de7579eded08fad$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $3de7579eded08fad$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$3de7579eded08fad$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$3de7579eded08fad$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $3de7579eded08fad$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $3de7579eded08fad$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $3de7579eded08fad$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $3de7579eded08fad$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $3de7579eded08fad$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $3de7579eded08fad$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $3de7579eded08fad$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $3de7579eded08fad$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $3de7579eded08fad$var$_transformProp = "transform", $3de7579eded08fad$var$_transformOriginProp = $3de7579eded08fad$var$_transformProp + "Origin", $3de7579eded08fad$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $3de7579eded08fad$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $3de7579eded08fad$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $3de7579eded08fad$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $3de7579eded08fad$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $3de7579eded08fad$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $3de7579eded08fad$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($3de7579eded08fad$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($3de7579eded08fad$var$_transformOriginProp, isNotCSS, "");
        }
        property = $3de7579eded08fad$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $3de7579eded08fad$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $3de7579eded08fad$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($3de7579eded08fad$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $3de7579eded08fad$var$_reverting();
        if ((!i || !i.isStart) && !style[$3de7579eded08fad$var$_transformProp]) {
            $3de7579eded08fad$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$3de7579eded08fad$var$_transformOriginProp]) {
                style[$3de7579eded08fad$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $3de7579eded08fad$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $3de7579eded08fad$var$_revertStyle,
        save: $3de7579eded08fad$var$_saveStyle
    };
    target._gsap || (0, $5cDU9.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $3de7579eded08fad$var$_supports3D, $3de7579eded08fad$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $3de7579eded08fad$var$_doc.createElementNS ? $3de7579eded08fad$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $3de7579eded08fad$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $3de7579eded08fad$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $3de7579eded08fad$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($3de7579eded08fad$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $3de7579eded08fad$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $3de7579eded08fad$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $3de7579eded08fad$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $3de7579eded08fad$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($3de7579eded08fad$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $3de7579eded08fad$var$_prefixes[i] : "") + property;
}, $3de7579eded08fad$var$_initCore = function _initCore() {
    if ($3de7579eded08fad$var$_windowExists() && window.document) {
        $3de7579eded08fad$var$_win = window;
        $3de7579eded08fad$var$_doc = $3de7579eded08fad$var$_win.document;
        $3de7579eded08fad$var$_docElement = $3de7579eded08fad$var$_doc.documentElement;
        $3de7579eded08fad$var$_tempDiv = $3de7579eded08fad$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $3de7579eded08fad$var$_tempDivStyler = $3de7579eded08fad$export$a232bb0480ae674a("div");
        $3de7579eded08fad$var$_transformProp = $3de7579eded08fad$export$8cbef5dd49a09c8b($3de7579eded08fad$var$_transformProp);
        $3de7579eded08fad$var$_transformOriginProp = $3de7579eded08fad$var$_transformProp + "Origin";
        $3de7579eded08fad$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $3de7579eded08fad$var$_supports3D = !!$3de7579eded08fad$export$8cbef5dd49a09c8b("perspective");
        $3de7579eded08fad$var$_reverting = (0, $5cDU9.gsap).core.reverting;
        $3de7579eded08fad$var$_pluginInitted = 1;
    }
}, $3de7579eded08fad$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $3de7579eded08fad$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $3de7579eded08fad$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $3de7579eded08fad$var$_docElement.removeChild(svg);
    return bbox;
}, $3de7579eded08fad$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $3de7579eded08fad$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $3de7579eded08fad$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $3de7579eded08fad$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$3de7579eded08fad$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$3de7579eded08fad$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $3de7579eded08fad$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $3de7579eded08fad$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$3de7579eded08fad$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $3de7579eded08fad$var$_transformProps && property !== $3de7579eded08fad$var$_transformOriginProp) property = $3de7579eded08fad$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($3de7579eded08fad$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $3de7579eded08fad$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $5cDU9.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $3de7579eded08fad$var$_renderNonTweeningValueOnlyAtEnd : $3de7579eded08fad$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $3de7579eded08fad$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $3de7579eded08fad$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$3de7579eded08fad$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $3de7579eded08fad$var$_tempDiv.style, horizontal = $3de7579eded08fad$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $3de7579eded08fad$var$_nonConvertibleUnits[unit] || $3de7579eded08fad$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $3de7579eded08fad$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($3de7579eded08fad$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $5cDU9._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $3de7579eded08fad$var$_doc || !parent.appendChild) parent = $3de7579eded08fad$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $5cDU9._ticker).time && !cache.uncache) return (0, $5cDU9._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $3de7579eded08fad$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$3de7579eded08fad$var$_nonStandardLayouts[$3de7579eded08fad$var$_getComputedProperty(parent, "display")] && (style.position = $3de7579eded08fad$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($3de7579eded08fad$var$_tempDiv);
            px = $3de7579eded08fad$var$_tempDiv[measureProperty];
            parent.removeChild($3de7579eded08fad$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $5cDU9._getCache)(parent);
            cache.time = (0, $5cDU9._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $5cDU9._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $3de7579eded08fad$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $3de7579eded08fad$var$_pluginInitted || $3de7579eded08fad$var$_initCore();
    if (property in $3de7579eded08fad$var$_propertyAliases && property !== "transform") {
        property = $3de7579eded08fad$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($3de7579eded08fad$var$_transformProps[property] && property !== "transform") {
        value = $3de7579eded08fad$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $3de7579eded08fad$var$_firstTwoOnly($3de7579eded08fad$var$_getComputedProperty(target, $3de7579eded08fad$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $3de7579eded08fad$var$_specialProps[property] && $3de7579eded08fad$var$_specialProps[property](target, property, unit) || $3de7579eded08fad$var$_getComputedProperty(target, property) || (0, $5cDU9._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $3de7579eded08fad$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $3de7579eded08fad$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $3de7579eded08fad$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $3de7579eded08fad$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $3de7579eded08fad$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $5cDU9.PropTween)(this._pt, target.style, prop, 0, 1, (0, $5cDU9._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $3de7579eded08fad$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $3de7579eded08fad$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $3de7579eded08fad$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $5cDU9._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $5cDU9._numWithUnitExp)) || [];
    endValues = end.match((0, $5cDU9._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $5cDU9._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $5cDU9._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $5cDU9._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $5cDU9._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $3de7579eded08fad$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $3de7579eded08fad$var$_renderNonTweeningValueOnlyAtEnd : $3de7579eded08fad$var$_renderNonTweeningValue;
    (0, $5cDU9._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $3de7579eded08fad$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $3de7579eded08fad$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $3de7579eded08fad$var$_keywordToPercent[x] || x;
    split[1] = $3de7579eded08fad$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $3de7579eded08fad$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($3de7579eded08fad$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $3de7579eded08fad$var$_transformOriginProp : $3de7579eded08fad$var$_transformProp;
                }
                $3de7579eded08fad$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $3de7579eded08fad$var$_removeProperty(target, $3de7579eded08fad$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $3de7579eded08fad$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $3de7579eded08fad$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$3de7579eded08fad$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $5cDU9.PropTween)(plugin._pt, target, property, 0, 0, $3de7579eded08fad$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $3de7579eded08fad$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $3de7579eded08fad$var$_rotationalProperties = {}, $3de7579eded08fad$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $3de7579eded08fad$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $3de7579eded08fad$var$_getComputedProperty(target, $3de7579eded08fad$var$_transformProp);
    return $3de7579eded08fad$var$_isNullTransform(matrixString) ? $3de7579eded08fad$var$_identity2DMatrix : matrixString.substr(7).match((0, $5cDU9._numExp)).map((0, $5cDU9._round));
}, $3de7579eded08fad$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $5cDU9._getCache)(target), style = target.style, matrix = $3de7579eded08fad$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $3de7579eded08fad$var$_identity2DMatrix : matrix;
    } else if (matrix === $3de7579eded08fad$var$_identity2DMatrix && !target.offsetParent && target !== $3de7579eded08fad$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $3de7579eded08fad$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $3de7579eded08fad$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $3de7579eded08fad$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $3de7579eded08fad$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $3de7579eded08fad$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $3de7579eded08fad$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $3de7579eded08fad$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $3de7579eded08fad$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$3de7579eded08fad$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $3de7579eded08fad$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $3de7579eded08fad$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $3de7579eded08fad$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $3de7579eded08fad$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $3de7579eded08fad$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $5cDU9.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $3de7579eded08fad$var$_getComputedProperty(target, $3de7579eded08fad$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $3de7579eded08fad$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$3de7579eded08fad$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$3de7579eded08fad$var$_transformProp] !== "none" ? cs[$3de7579eded08fad$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $3de7579eded08fad$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $3de7579eded08fad$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $3de7579eded08fad$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $3de7579eded08fad$var$_atan2(b, a) * $3de7579eded08fad$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $3de7579eded08fad$var$_atan2(c, d) * $3de7579eded08fad$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $3de7579eded08fad$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $3de7579eded08fad$var$_atan2(a32, a33);
            rotationX = angle * $3de7579eded08fad$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $3de7579eded08fad$var$_atan2(-c, a33);
            rotationY = angle * $3de7579eded08fad$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $3de7579eded08fad$var$_atan2(b, a);
            rotation = angle * $3de7579eded08fad$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $5cDU9._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $5cDU9._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $3de7579eded08fad$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $3de7579eded08fad$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$3de7579eded08fad$var$_isNullTransform($3de7579eded08fad$var$_getComputedProperty(target, $3de7579eded08fad$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $5cDU9._round)(scaleX);
    cache.scaleY = (0, $5cDU9._round)(scaleY);
    cache.rotation = (0, $5cDU9._round)(rotation) + deg;
    cache.rotationX = (0, $5cDU9._round)(rotationX) + deg;
    cache.rotationY = (0, $5cDU9._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$3de7579eded08fad$var$_transformOriginProp] = $3de7579eded08fad$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $5cDU9._config).force3D;
    cache.renderTransform = cache.svg ? $3de7579eded08fad$var$_renderSVGTransforms : $3de7579eded08fad$var$_supports3D ? $3de7579eded08fad$var$_renderCSSTransforms : $3de7579eded08fad$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $3de7579eded08fad$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$3de7579eded08fad$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $5cDU9.getUnit)(start);
    return (0, $5cDU9._round)(parseFloat(start) + parseFloat($3de7579eded08fad$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $3de7579eded08fad$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $3de7579eded08fad$var$_renderCSSTransforms(ratio, cache);
}, $3de7579eded08fad$var$_zeroDeg = "0deg", $3de7579eded08fad$var$_zeroPx = "0px", $3de7579eded08fad$var$_endParenthesis = ") ", $3de7579eded08fad$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $3de7579eded08fad$var$_zeroDeg || rotationY !== $3de7579eded08fad$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $3de7579eded08fad$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $3de7579eded08fad$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $3de7579eded08fad$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $3de7579eded08fad$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $3de7579eded08fad$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $3de7579eded08fad$var$_zeroPx) transforms += "perspective(" + transformPerspective + $3de7579eded08fad$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $3de7579eded08fad$var$_zeroPx || y !== $3de7579eded08fad$var$_zeroPx || z !== $3de7579eded08fad$var$_zeroPx) transforms += z !== $3de7579eded08fad$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $3de7579eded08fad$var$_endParenthesis;
    if (rotation !== $3de7579eded08fad$var$_zeroDeg) transforms += "rotate(" + rotation + $3de7579eded08fad$var$_endParenthesis;
    if (rotationY !== $3de7579eded08fad$var$_zeroDeg) transforms += "rotateY(" + rotationY + $3de7579eded08fad$var$_endParenthesis;
    if (rotationX !== $3de7579eded08fad$var$_zeroDeg) transforms += "rotateX(" + rotationX + $3de7579eded08fad$var$_endParenthesis;
    if (skewX !== $3de7579eded08fad$var$_zeroDeg || skewY !== $3de7579eded08fad$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $3de7579eded08fad$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $3de7579eded08fad$var$_endParenthesis;
    target.style[$3de7579eded08fad$var$_transformProp] = transforms || "translate(0, 0)";
}, $3de7579eded08fad$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $3de7579eded08fad$var$_DEG2RAD;
        skewX *= $3de7579eded08fad$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $3de7579eded08fad$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $5cDU9._round)(a11);
        a21 = (0, $5cDU9._round)(a21);
        a12 = (0, $5cDU9._round)(a12);
        a22 = (0, $5cDU9._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $3de7579eded08fad$var$_convertToUnit(target, "x", x, "px");
        ty = $3de7579eded08fad$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $5cDU9._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $5cDU9._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $5cDU9._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $5cDU9._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$3de7579eded08fad$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $3de7579eded08fad$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $5cDU9._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $3de7579eded08fad$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $3de7579eded08fad$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $3de7579eded08fad$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $5cDU9.PropTween)(plugin._pt, target, property, startNum, change, $3de7579eded08fad$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $3de7579eded08fad$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $3de7579eded08fad$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $3de7579eded08fad$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$3de7579eded08fad$var$_transformProp] = transforms;
        endCache = $3de7579eded08fad$var$_parseTransform(target, 1);
        $3de7579eded08fad$var$_removeProperty(target, $3de7579eded08fad$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$3de7579eded08fad$var$_transformProp];
        style[$3de7579eded08fad$var$_transformProp] = transforms;
        endCache = $3de7579eded08fad$var$_parseTransform(target, 1);
        style[$3de7579eded08fad$var$_transformProp] = startValue;
    }
    for(p in $3de7579eded08fad$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $5cDU9.getUnit)(startValue);
            endUnit = (0, $5cDU9.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $3de7579eded08fad$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $5cDU9.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $3de7579eded08fad$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $3de7579eded08fad$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $5cDU9._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $3de7579eded08fad$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $3de7579eded08fad$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $3de7579eded08fad$export$855822f522f18eef = {
    name: "css",
    register: $3de7579eded08fad$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $3de7579eded08fad$var$_pluginInitted || $3de7579eded08fad$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $3de7579eded08fad$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $5cDU9._plugins)[p] && (0, $5cDU9._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $3de7579eded08fad$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $5cDU9._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $5cDU9._colorExp).lastIndex = 0;
                if (!(0, $5cDU9._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $5cDU9.getUnit)(startValue);
                    endUnit = (0, $5cDU9.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $3de7579eded08fad$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $5cDU9._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $5cDU9._replaceRandom)(startValue));
                    (0, $5cDU9.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $5cDU9._config).units[p] || (0, $5cDU9.getUnit)($3de7579eded08fad$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $3de7579eded08fad$var$_get(target, p)); // can't work with relative values
                } else startValue = $3de7579eded08fad$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $3de7579eded08fad$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $3de7579eded08fad$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $3de7579eded08fad$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $3de7579eded08fad$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $3de7579eded08fad$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $3de7579eded08fad$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $3de7579eded08fad$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $3de7579eded08fad$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $3de7579eded08fad$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $5cDU9.PropTween)(this._pt, style, $3de7579eded08fad$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $5cDU9.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $5cDU9._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $3de7579eded08fad$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($3de7579eded08fad$var$_transformOriginProp, 0, style[$3de7579eded08fad$var$_transformOriginProp]);
                        endValue = $3de7579eded08fad$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $3de7579eded08fad$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $3de7579eded08fad$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $3de7579eded08fad$var$_addNonTweeningPT(this, style, p, $3de7579eded08fad$var$_firstTwoOnly(startValue), $3de7579eded08fad$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $3de7579eded08fad$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $3de7579eded08fad$var$_rotationalProperties) {
                        $3de7579eded08fad$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $5cDU9._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $3de7579eded08fad$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $3de7579eded08fad$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $3de7579eded08fad$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$3de7579eded08fad$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $5cDU9.getUnit)(endValue) || (p in (0, $5cDU9._config).units ? (0, $5cDU9._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $3de7579eded08fad$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $5cDU9.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $5cDU9._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $3de7579eded08fad$var$_renderRoundedCSSProp : $3de7579eded08fad$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $3de7579eded08fad$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $3de7579eded08fad$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $5cDU9._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $3de7579eded08fad$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $5cDU9._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$3de7579eded08fad$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $3de7579eded08fad$var$_get,
    aliases: $3de7579eded08fad$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $3de7579eded08fad$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $3de7579eded08fad$var$_transformProps && property !== $3de7579eded08fad$var$_transformOriginProp && (target._gsap.x || $3de7579eded08fad$var$_get(target, "x")) ? plugin && $3de7579eded08fad$var$_recentSetterPlugin === plugin ? property === "scale" ? $3de7579eded08fad$var$_setterScale : $3de7579eded08fad$var$_setterTransform : ($3de7579eded08fad$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $3de7579eded08fad$var$_setterScaleWithRender : $3de7579eded08fad$var$_setterTransformWithRender) : target.style && !(0, $5cDU9._isUndefined)(target.style[property]) ? $3de7579eded08fad$var$_setterCSSStyle : ~property.indexOf("-") ? $3de7579eded08fad$var$_setterCSSProp : (0, $5cDU9._getSetter)(target, property);
    },
    core: {
        _removeProperty: $3de7579eded08fad$var$_removeProperty,
        _getMatrix: $3de7579eded08fad$var$_getMatrix
    }
};
(0, $5cDU9.gsap).utils.checkPrefix = $3de7579eded08fad$export$8cbef5dd49a09c8b;
(0, $5cDU9.gsap).core.getStyleSaver = $3de7579eded08fad$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $5cDU9._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $3de7579eded08fad$var$_transformProps[name] = 1;
    });
    (0, $5cDU9._forEachName)(rotation, function(name) {
        (0, $5cDU9._config).units[name] = "deg";
        $3de7579eded08fad$var$_rotationalProperties[name] = 1;
    });
    $3de7579eded08fad$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $5cDU9._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $3de7579eded08fad$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $5cDU9._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $5cDU9._config).units[name] = "px";
});
(0, $5cDU9.gsap).registerPlugin($3de7579eded08fad$export$855822f522f18eef);


var $e96f038975c5d4d2$export$99ee26438460406a = (0, $5cDU9.gsap).registerPlugin((0, $3de7579eded08fad$export$855822f522f18eef)) || (0, $5cDU9.gsap), // to protect from tree shaking
$e96f038975c5d4d2$export$7b23975ad686bf91 = $e96f038975c5d4d2$export$99ee26438460406a.core.Tween;


function $b342ce5e9daca273$var$horizontalLoop(items, config) {
    items = (0, $e96f038975c5d4d2$export$99ee26438460406a).utils.toArray(items);
    config = config || {};
    const tl = (0, $e96f038975c5d4d2$export$99ee26438460406a).timeline({
        repeat: config.repeat,
        defaults: {
            ease: "none"
        },
        onReverseComplete: ()=>{
            tl.totalTime(tl.rawTime() + tl.duration() * 100);
        }
    });
    const length = items.length;
    const startX = items[0].offsetLeft;
    const widths = [];
    const xPercents = [];
    const pixelsPerSecond = (config.speed || 1) * 5;
    const snap = config.snap === false ? (v)=>v : (0, $e96f038975c5d4d2$export$99ee26438460406a).utils.snap(config.snap || 1);
    (0, $e96f038975c5d4d2$export$99ee26438460406a).set(items, {
        xPercent: (i, el)=>{
            const w = widths[i] = parseFloat((0, $e96f038975c5d4d2$export$99ee26438460406a).getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat((0, $e96f038975c5d4d2$export$99ee26438460406a).getProperty(el, "x", "px")) / w * 100 + (0, $e96f038975c5d4d2$export$99ee26438460406a).getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });
    (0, $e96f038975c5d4d2$export$99ee26438460406a).set(items, {
        x: 0
    });
    const totalWidth = items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * (0, $e96f038975c5d4d2$export$99ee26438460406a).getProperty(items[length - 1], "scaleX") + (parseFloat(String(config.paddingRight)) || 0);
    for(let i = 0; i < length; i++){
        const item = items[i];
        const curX = xPercents[i] / 100 * widths[i];
        const distanceToStart = item.offsetLeft + curX - startX;
        const distanceToLoop = distanceToStart + widths[i] * (0, $e96f038975c5d4d2$export$99ee26438460406a).getProperty(item, "scaleX");
        tl.to(item, {
            xPercent: snap((curX - distanceToLoop) / widths[i] * 100),
            duration: distanceToLoop / pixelsPerSecond
        }, 0).fromTo(item, {
            xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)
        }, {
            xPercent: xPercents[i],
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false
        }, distanceToLoop / pixelsPerSecond);
    }
    tl.progress(1, true).progress(0, true);
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }
    return tl;
}
function $b342ce5e9daca273$var$initMarquee(container, trackSelector = ".njamito-marquee__track") {
    const track = container.querySelector(trackSelector);
    if (!track) return null;
    const speed = parseFloat(container.dataset.marqueeSpeed || "1");
    const direction = container.dataset.marqueeDirection || "left";
    const reversed = direction === "right";
    const items = Array.from(track.children);
    if (items.length === 0) return null;
    // Convert CSS gap to margin-right since horizontalLoop positions items individually
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    if (gap) {
        track.style.gap = "0px";
        items.forEach((item)=>{
            item.style.marginRight = `${gap}px`;
        });
    }
    const paddingRight = gap || parseFloat((0, $e96f038975c5d4d2$export$99ee26438460406a).getProperty(items[0], "marginRight", "px")) || 0;
    const tl = $b342ce5e9daca273$var$horizontalLoop(items, {
        repeat: -1,
        speed: speed,
        reversed: reversed,
        paddingRight: paddingRight
    });
    container.addEventListener("mouseenter", ()=>{
        (0, $e96f038975c5d4d2$export$99ee26438460406a).to(tl, {
            timeScale: 0,
            duration: 0.5,
            overwrite: true
        });
    });
    container.addEventListener("mouseleave", ()=>{
        (0, $e96f038975c5d4d2$export$99ee26438460406a).to(tl, {
            timeScale: reversed ? -1 : 1,
            duration: 0.5,
            overwrite: true
        });
    });
    return tl;
}
window.addEventListener("load", ()=>{
    document.querySelectorAll(".njamito-marquee").forEach((el)=>{
        try {
            $b342ce5e9daca273$var$initMarquee(el);
        } catch (e) {
            console.warn("Marquee init failed:", e);
        }
    });
});


/* ════════════════════════════════════════════════════════════
   Hero Products conveyor — ACF block `acf/section-hero-products`.
   Port of the design prototype (docs/design_handoff_hero_products_slider/
   reference/prototype.js) into a per-instance, GSAP-driven module.

   · products ride a conveyor: desktop = curved arc, mobile = slide.
   · while a product rests it bobs (CSS) and ingredients drift (CSS).
   · ingredient explosion: each sprite flies in/out from its own random
     direction; hero ingredients (ACF) are larger than the hardcoded
     oat/leaf/pea basics.
   · background blobs morph (CSS) and recolour / pulse / roam (GSAP).
   · per-product NOVO badge fades in/out.
   ════════════════════════════════════════════════════════════ */ 
const $ef86fbc7a254aee2$var$ANIM = 1150; // ms — conveyor sweep
const $ef86fbc7a254aee2$var$ROTATE_DEFAULT = 4400; // ms — rest before the belt advances
const $ef86fbc7a254aee2$var$SLOTS = 13; // ingredient sprite pool
const $ef86fbc7a254aee2$var$HERO_W = 140; // px — hero ingredient width
const $ef86fbc7a254aee2$var$MOBILE_BP = 900;
const $ef86fbc7a254aee2$var$BASIC_W = {
    oat1: 17,
    oat2: 21,
    leaf1: 35,
    leaf2: 39,
    pea1: 24,
    pea2: 22
};
const $ef86fbc7a254aee2$var$BASIC_POOL = [
    'oat1',
    'leaf1',
    'pea1',
    'oat2',
    'leaf2',
    'oat1',
    'pea2',
    'oat2',
    'leaf1'
];
const $ef86fbc7a254aee2$var$rand = (a, b)=>a + Math.random() * (b - a);
const $ef86fbc7a254aee2$var$lerp = (a, b, t)=>a + (b - a) * t;
const $ef86fbc7a254aee2$var$easeInOut = (t)=>t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
const $ef86fbc7a254aee2$var$isMobile = ()=>window.innerWidth < $ef86fbc7a254aee2$var$MOBILE_BP;
const $ef86fbc7a254aee2$var$pxv = (v)=>v.toFixed(1) + 'px';
function $ef86fbc7a254aee2$var$shuffle(a) {
    a = a.slice();
    for(let i = a.length - 1; i > 0; i--){
        const j = Math.random() * (i + 1) | 0;
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    return a;
}
function $ef86fbc7a254aee2$var$initStage(stage) {
    let products = [];
    let basics = {};
    try {
        products = JSON.parse(stage.dataset.products || '[]');
        basics = JSON.parse(stage.dataset.basics || '{}');
    } catch (e) {
        return;
    }
    if (!products.length) return;
    const single = stage.dataset.single === '1' || products.length <= 1;
    const rotate = parseInt(stage.dataset.rotation || '', 10) || $ef86fbc7a254aee2$var$ROTATE_DEFAULT;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* ── DOM refs (scoped to this stage) ── */ const blobsLayer = stage.querySelector('.hero-products__blobs');
    const halos = Array.from(stage.querySelectorAll('.blob'));
    const ingLayer = stage.querySelector('.hero-products__ingredients');
    const novo = stage.querySelector('.hero-products__novo');
    const nameEl = stage.querySelector('.hero-products__name');
    const flavorEl = stage.querySelector('.hero-products__name .flavor');
    const catEl = stage.querySelector('.hero-products__name .cat');
    const dotsBox = stage.querySelector('.hero-products__dots');
    const frontEl = stage.querySelector('.hero-products__slide.is-front');
    const backEl = stage.querySelector('.hero-products__slide.is-back');
    if (!frontEl || !backEl) return;
    let front = {
        el: frontEl,
        img: frontEl.querySelector('img')
    };
    let back = {
        el: backEl,
        img: backEl.querySelector('img')
    };
    /* preload product + hero ingredient images */ const preload = new Set();
    products.forEach((p)=>{
        if (p.img) preload.add(p.img);
        (p.heroes || []).forEach((h)=>preload.add(h));
    });
    Object.values(basics).forEach((b)=>preload.add(b));
    preload.forEach((src)=>{
        const im = new Image();
        im.src = src;
    });
    /* ════════════════ BACKGROUND BLOBS ════════════════ */ // b-main sits behind the product; the two small blobs orbit around it and
    // advance their angle on each product switch for a dynamic, random look.
    const orbitAngle = [
        0,
        -Math.PI / 4,
        Math.PI * 0.78
    ]; // [main(unused), b-2, b-3]
    if (halos.length) (0, $e96f038975c5d4d2$export$99ee26438460406a).set(halos, {
        xPercent: -50,
        yPercent: -50
    });
    function paintHalos(color) {
        if (!halos.length) return;
        (0, $e96f038975c5d4d2$export$99ee26438460406a).to(halos, {
            backgroundColor: color,
            duration: 1,
            ease: 'power1.inOut',
            overwrite: 'auto'
        });
    }
    function placeBlob(i, x, y, rot, sc, animate) {
        const b = halos[i];
        if (!b) return;
        const vars = {
            left: x + '%',
            top: y + '%',
            rotation: rot,
            scale: sc
        };
        if (animate && !reduceMotion) (0, $e96f038975c5d4d2$export$99ee26438460406a).to(b, {
            ...vars,
            duration: 0.9,
            ease: 'power2.inOut',
            overwrite: 'auto'
        });
        else (0, $e96f038975c5d4d2$export$99ee26438460406a).set(b, vars);
    }
    const blobCentre = ()=>$ef86fbc7a254aee2$var$isMobile() ? {
            cx: 52,
            cy: 46,
            rx: 20,
            ry: 20
        } : {
            cx: 58,
            cy: 50,
            rx: 26,
            ry: 28
        };
    // Init: don't move the blobs — only centre them (matching the CSS transform) and
    // seed each small blob's orbit angle from where CSS already painted it, so the
    // first paint → JS hand-off is seamless (no jump). Orbit kicks in on the 1st switch.
    function initBlobs() {
        if (!halos.length) return;
        (0, $e96f038975c5d4d2$export$99ee26438460406a).set(halos, {
            xPercent: -50,
            yPercent: -50,
            rotation: 0,
            scale: 1
        });
        const { cx: cx, cy: cy, rx: rx, ry: ry } = blobCentre();
        const w = (blobsLayer ? blobsLayer.clientWidth : stage.clientWidth) || 1;
        const h = (blobsLayer ? blobsLayer.clientHeight : stage.clientHeight) || 1;
        for(let i = 1; i < halos.length; i++){
            const cs = getComputedStyle(halos[i]);
            const xPct = (parseFloat(cs.left) || 0) / w * 100;
            const yPct = (parseFloat(cs.top) || 0) / h * 100;
            orbitAngle[i] = Math.atan2((yPct - cy) / ry, (xPct - cx) / rx);
        }
    }
    function positionBlobs(animate) {
        if (!halos.length) return;
        const { cx: cx, cy: cy, rx: rx, ry: ry } = blobCentre();
        // b-main: gentle roam around its anchor
        placeBlob(0, cx + $ef86fbc7a254aee2$var$rand(-3, 3), cy + $ef86fbc7a254aee2$var$rand(-2, 2), $ef86fbc7a254aee2$var$rand(-18, 18), $ef86fbc7a254aee2$var$rand(.92, 1.08), animate);
        // small blobs: advance their orbit angle, then sit on the circle around b-main
        for(let i = 1; i < halos.length; i++){
            orbitAngle[i] += (Math.random() < .5 ? -1 : 1) * $ef86fbc7a254aee2$var$rand(0.6, 1.5);
            const x = cx + rx * Math.cos(orbitAngle[i]) + $ef86fbc7a254aee2$var$rand(-2, 2);
            const y = cy + ry * Math.sin(orbitAngle[i]) + $ef86fbc7a254aee2$var$rand(-2, 2);
            placeBlob(i, x, y, $ef86fbc7a254aee2$var$rand(-30, 30), $ef86fbc7a254aee2$var$rand(.85, 1.12), animate);
        }
    }
    function popBlobs() {
        if (reduceMotion || !blobsLayer) return;
        blobsLayer.classList.remove('pop');
        blobsLayer.offsetWidth;
        blobsLayer.classList.add('pop');
    }
    /* ════════════════ INGREDIENT EXPLOSION ════════════════ */ const slots = [];
    if (ingLayer) for(let s = 0; s < $ef86fbc7a254aee2$var$SLOTS; s++){
        const ing = document.createElement('div');
        ing.className = 'ing';
        const drift = document.createElement('div');
        drift.className = 'ing-drift';
        const shape = document.createElement('div');
        shape.className = 'ing-shape';
        drift.appendChild(shape);
        ing.appendChild(drift);
        ingLayer.appendChild(ing);
        slots.push({
            ing: ing,
            drift: drift,
            shape: shape
        });
    }
    let curActive = 0;
    // The sprite set is rebuilt per product from THAT product's hero ingredients
    // (ACF, mapped to the slide) topped up with the basics. On a switch the old
    // sprites burst out and the incoming product's set bursts in.
    function buildSetFor(p) {
        const list = [];
        const heroUrls = [];
        (p.heroes || []).forEach((h)=>{
            if (h && heroUrls.indexOf(h) === -1) heroUrls.push(h);
        });
        $ef86fbc7a254aee2$var$shuffle(heroUrls).slice(0, Math.min(5, heroUrls.length)).forEach((u)=>list.push({
                url: u,
                w: $ef86fbc7a254aee2$var$HERO_W
            }));
        const pool = $ef86fbc7a254aee2$var$shuffle($ef86fbc7a254aee2$var$BASIC_POOL).filter((k)=>basics[k]);
        let bi = 0;
        while(list.length < $ef86fbc7a254aee2$var$SLOTS && pool.length){
            const k = pool[bi++ % pool.length];
            list.push({
                url: basics[k],
                w: $ef86fbc7a254aee2$var$BASIC_W[k] || 22
            });
        }
        return $ef86fbc7a254aee2$var$shuffle(list).slice(0, $ef86fbc7a254aee2$var$SLOTS);
    }
    let curSet = [];
    // Even spread via a jittered grid (one sprite per cell) — avoids the dense
    // clumps that pure-random positions produce.
    function genRest() {
        const mob = $ef86fbc7a254aee2$var$isMobile();
        // Near-square grid with one sprite per cell, spanning the full stage so the
        // sprites scatter across the whole area instead of clumping in one region.
        const cols = mob ? 5 : 5;
        const rows = Math.ceil($ef86fbc7a254aee2$var$SLOTS / cols);
        const x0 = mob ? 1 : 1, x1 = mob ? 99 : 99;
        const y0 = mob ? 3 : 2, y1 = mob ? 70 : 97;
        const cw = (x1 - x0) / cols, ch = (y1 - y0) / rows;
        const cells = [];
        for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++)cells.push([
            c,
            r
        ]);
        // Keep sprites clear of the central blob (where the product sits): any point
        // landing inside the blob ellipse is pushed radially out onto an edge ring.
        const { cx: cx, cy: cy, rx: rx, ry: ry } = blobCentre();
        const clamp = (v, a, b)=>Math.max(a, Math.min(b, v));
        // Jitter nearly fills each cell, so sprites reach cell edges and read as an
        // even, organic scatter rather than a visible lattice.
        return $ef86fbc7a254aee2$var$shuffle(cells).slice(0, $ef86fbc7a254aee2$var$SLOTS).map(([c, r])=>{
            let x = x0 + (c + $ef86fbc7a254aee2$var$rand(0.05, 0.95)) * cw;
            let y = y0 + (r + $ef86fbc7a254aee2$var$rand(0.05, 0.95)) * ch;
            const nx = (x - cx) / rx, ny = (y - cy) / ry;
            const nr = Math.hypot(nx, ny);
            if (nr < 1.05) {
                let ux = nx / nr, uy = ny / nr;
                if (!isFinite(ux) || !isFinite(uy) || nr < 1e-3) {
                    const a = $ef86fbc7a254aee2$var$rand(0, Math.PI * 2);
                    ux = Math.cos(a);
                    uy = Math.sin(a);
                }
                const tr = $ef86fbc7a254aee2$var$rand(1.05, 1.4); // edge ring just outside the blob
                x = cx + ux * tr * rx;
                y = cy + uy * tr * ry;
            }
            return [
                clamp(x, x0, x1),
                clamp(y, y0, y1)
            ];
        });
    }
    function launchVectors(rect) {
        const W = rect.width, H = rect.height;
        return slots.map(()=>{
            const a = $ef86fbc7a254aee2$var$rand(0, Math.PI * 2), d = $ef86fbc7a254aee2$var$rand(.26, .48);
            return [
                Math.cos(a) * d * W,
                Math.sin(a) * d * H
            ];
        });
    }
    function applyDrift(sl) {
        sl.drift.style.setProperty('--dx', $ef86fbc7a254aee2$var$rand(-8, 8).toFixed(0) + 'px');
        sl.drift.style.setProperty('--dy', (-4 - $ef86fbc7a254aee2$var$rand(0, 9)).toFixed(0) + 'px');
        sl.drift.style.setProperty('--dr', $ef86fbc7a254aee2$var$rand(-8, 8).toFixed(0) + 'deg');
        sl.drift.style.setProperty('--ddur', (6.5 + $ef86fbc7a254aee2$var$rand(0, 4)).toFixed(1) + 's');
    }
    function enterIngredients(set) {
        if (!ingLayer || !slots.length) return;
        curSet = set;
        const rect = ingLayer.getBoundingClientRect();
        const rest = genRest();
        const vecs = launchVectors(rect);
        curActive = $ef86fbc7a254aee2$var$SLOTS;
        slots.forEach((sl, i)=>{
            const spec = curSet[i];
            if (!spec) {
                sl.ing.style.display = 'none';
                return;
            }
            sl.ing.style.display = '';
            sl.shape.innerHTML = `<img src="${spec.url}" width="${spec.w}" alt="" loading="eager">`;
            sl.ing.style.left = rest[i][0] + '%';
            sl.ing.style.top = rest[i][1] + '%';
            applyDrift(sl);
            if (reduceMotion) {
                // place at rest, no burst animation
                sl.ing.classList.remove('out', 'burst');
                sl.ing.style.opacity = '1';
                return;
            }
            sl.ing.style.opacity = '';
            sl.ing.style.setProperty('--fx', $ef86fbc7a254aee2$var$pxv(vecs[i][0]));
            sl.ing.style.setProperty('--fy', $ef86fbc7a254aee2$var$pxv(vecs[i][1]));
            sl.ing.style.setProperty('--r0', $ef86fbc7a254aee2$var$rand(-90, 90).toFixed(0) + 'deg');
            sl.ing.style.setProperty('--r1', $ef86fbc7a254aee2$var$rand(-45, 45).toFixed(0) + 'deg');
            sl.ing.style.setProperty('--delay', (i * $ef86fbc7a254aee2$var$rand(.02, .045) + $ef86fbc7a254aee2$var$rand(0, .05)).toFixed(3) + 's');
            sl.ing.classList.remove('out', 'burst');
            sl.ing.offsetWidth;
            sl.ing.classList.add('burst');
        });
    }
    // On a product switch the current sprites burst out, then the incoming
    // product's set bursts in — so the ingredients always match the slide.
    function exitIngredients() {
        if (!ingLayer) return;
        const rect = ingLayer.getBoundingClientRect();
        const vecs = launchVectors(rect); // same outward vectors as the burst-in
        slots.forEach((sl, i)=>{
            if (sl.ing.style.display === 'none') return;
            sl.ing.style.setProperty('--ox', $ef86fbc7a254aee2$var$pxv(vecs[i][0]));
            sl.ing.style.setProperty('--oy', $ef86fbc7a254aee2$var$pxv(vecs[i][1]));
            sl.ing.style.setProperty('--or', $ef86fbc7a254aee2$var$rand(-60, 60).toFixed(0) + 'deg');
            sl.ing.style.setProperty('--odelay', (i * $ef86fbc7a254aee2$var$rand(.01, .03)).toFixed(3) + 's');
            sl.ing.classList.remove('burst');
            sl.ing.offsetWidth;
            sl.ing.classList.add('out');
        });
    }
    function changeIngredients(p) {
        const set = buildSetFor(p);
        if (!curActive || reduceMotion) {
            enterIngredients(set);
            return;
        }
        exitIngredients();
        window.setTimeout(()=>enterIngredients(set), Math.round($ef86fbc7a254aee2$var$ANIM * 0.4));
    }
    let ARC;
    function computeArc() {
        const r = stage.getBoundingClientRect();
        const W = r.width || 480, H = r.height || 560;
        const Cx = W * 0.92;
        const Cy = -H * 1.30;
        const R = Math.hypot(Cx, Cy);
        const rest = Math.atan2(-Cy, -Cx);
        const enter = rest + 0.56;
        const exit = rest - 0.56;
        const cR = Math.cos(rest), sR = Math.sin(rest);
        const off = (th)=>[
                R * (Math.cos(th) - cR),
                R * (Math.sin(th) - sR)
            ];
        ARC = {
            enter: enter,
            rest: rest,
            exit: exit,
            off: off,
            W: W
        };
    }
    computeArc();
    function frame(phase, t) {
        const mob = $ef86fbc7a254aee2$var$isMobile();
        const e = $ef86fbc7a254aee2$var$easeInOut(t);
        if (phase === 'enter') {
            const op = Math.min(1, t / 0.40);
            if (mob) return {
                x: $ef86fbc7a254aee2$var$lerp(-ARC.W * 0.6, 0, e),
                y: 0,
                sc: $ef86fbc7a254aee2$var$lerp(.86, 1, e),
                rot: $ef86fbc7a254aee2$var$lerp(-3, 0, e),
                op: op
            };
            const o = ARC.off($ef86fbc7a254aee2$var$lerp(ARC.enter, ARC.rest, e));
            return {
                x: o[0],
                y: o[1],
                sc: $ef86fbc7a254aee2$var$lerp(.52, 1, e),
                rot: $ef86fbc7a254aee2$var$lerp(-9, 0, e),
                op: op
            };
        } else {
            const op = t < 0.6 ? 1 : Math.max(0, 1 - (t - 0.6) / 0.4);
            if (mob) return {
                x: $ef86fbc7a254aee2$var$lerp(0, ARC.W * 0.6, e),
                y: 0,
                sc: $ef86fbc7a254aee2$var$lerp(1, .84, e),
                rot: $ef86fbc7a254aee2$var$lerp(0, 4, e),
                op: op
            };
            const o = ARC.off($ef86fbc7a254aee2$var$lerp(ARC.rest, ARC.exit, e));
            return {
                x: o[0],
                y: o[1],
                sc: $ef86fbc7a254aee2$var$lerp(1, .52, e),
                rot: $ef86fbc7a254aee2$var$lerp(0, 9, e),
                op: op
            };
        }
    }
    function applyFrame(slot, f) {
        slot.el.style.transform = `translate(-50%,-50%) translate(${f.x.toFixed(1)}px,${f.y.toFixed(1)}px) rotate(${f.rot.toFixed(2)}deg) scale(${f.sc.toFixed(3)})`;
        slot.el.style.opacity = f.op.toFixed(3);
    }
    const REST = {
        x: 0,
        y: 0,
        sc: 1,
        rot: 0,
        op: 1
    };
    let switchTween = null;
    let animating = false;
    function finalizeAnim() {
        if (switchTween) {
            switchTween.kill();
            switchTween = null;
        }
        applyFrame(back, REST);
        front.el.style.opacity = '0';
        [front, back] = [
            back,
            front
        ];
        animating = false;
    }
    function startSwitch(item) {
        if (animating) finalizeAnim();
        // Incoming slide always above outgoing so it can never sit behind it on overflow.
        back.el.style.zIndex = '11';
        front.el.style.zIndex = '10';
        back.img.src = item.img;
        back.img.alt = item.alt || 'Niamito ' + item.name;
        if (reduceMotion) {
            applyFrame(back, REST);
            front.el.style.opacity = '0';
            [front, back] = [
                back,
                front
            ];
            return;
        }
        applyFrame(back, frame('enter', 0));
        animating = true;
        const state = {
            t: 0
        };
        switchTween = (0, $e96f038975c5d4d2$export$99ee26438460406a).to(state, {
            t: 1,
            duration: $ef86fbc7a254aee2$var$ANIM / 1000,
            ease: 'none',
            onUpdate: ()=>{
                applyFrame(back, frame('enter', state.t));
                applyFrame(front, frame('exit', state.t));
            },
            onComplete: finalizeAnim
        });
    }
    /* ════════════════ NOVO BADGE ════════════════ */ let novoVisible = false;
    if (novo) (0, $e96f038975c5d4d2$export$99ee26438460406a).set(novo, {
        rotation: -12,
        transformOrigin: '50% 50%'
    });
    function setNovo(on) {
        if (!novo || on === novoVisible) return;
        novoVisible = on;
        (0, $e96f038975c5d4d2$export$99ee26438460406a).to(novo, {
            autoAlpha: on ? 1 : 0,
            scale: on ? 1 : 0.5,
            duration: 0.46,
            ease: on ? 'power2.out' : 'power1.in',
            overwrite: 'auto'
        });
    }
    /* ════════════════ DOTS + ROTATION ════════════════ */ const dots = [];
    if (dotsBox && !single) products.forEach((_, i)=>{
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'hp-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Show product ' + (i + 1));
        d.addEventListener('click', ()=>{
            show(i);
            restart();
        });
        dotsBox.appendChild(d);
        dots.push(d);
    });
    // Update the name pill, hiding it entirely when the product has no name/category.
    function applyName(it) {
        if (!nameEl) return;
        const has = !!(it.name && it.name.trim() || it.category && it.category.trim());
        if (flavorEl) flavorEl.textContent = it.name || '';
        if (catEl) catEl.textContent = it.category || '';
        nameEl.classList.toggle('is-empty', !has);
    }
    applyName(products[0]);
    let idx = 0;
    let timer = null;
    function show(i) {
        if (i === idx) return;
        idx = i;
        const it = products[i];
        startSwitch(it);
        stage.style.setProperty('--flavor', it.color);
        paintHalos(it.color);
        popBlobs();
        positionBlobs(true);
        changeIngredients(it);
        if (nameEl) {
            nameEl.style.opacity = '0';
            window.setTimeout(()=>{
                applyName(it);
                nameEl.style.opacity = '1';
            }, 260);
        }
        setNovo(it.new);
        dots.forEach((d, k)=>d.classList.toggle('active', k === i));
    }
    function next() {
        show((idx + 1) % products.length);
    }
    function start() {
        if (reduceMotion || single) return;
        stop();
        timer = window.setInterval(next, rotate);
    }
    function stop() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function restart() {
        stop();
        start();
    }
    /* ════════════════ INIT ════════════════ */ const first = products[0];
    front.img.src = first.img;
    front.img.alt = first.alt || 'Niamito ' + first.name;
    applyFrame(front, REST);
    back.el.style.opacity = '0';
    stage.style.setProperty('--flavor', first.color);
    paintHalos(first.color);
    initBlobs();
    if (novo) {
        novoVisible = first.new;
        (0, $e96f038975c5d4d2$export$99ee26438460406a).set(novo, {
            autoAlpha: first.new ? 1 : 0,
            scale: first.new ? 1 : 0.5
        });
    }
    // First ingredient entrance + autoplay start once the stage scrolls into view.
    let entered = false;
    const kickoff = ()=>{
        if (entered) return;
        entered = true;
        computeArc();
        enterIngredients(buildSetFor(first));
        start();
    };
    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries, obs)=>{
            entries.forEach((en)=>{
                if (en.isIntersecting) {
                    kickoff();
                    obs.disconnect();
                }
            });
        }, {
            rootMargin: '0px 0px -10% 0px'
        });
        io.observe(stage);
    } else kickoff();
    window.addEventListener('resize', ()=>{
        computeArc();
        if (!animating) applyFrame(front, REST);
    });
    document.addEventListener('visibilitychange', ()=>{
        if (document.hidden) stop();
        else if (entered) start();
    });
}
window.addEventListener('load', ()=>{
    document.querySelectorAll('.hero-products__stage').forEach((stage)=>{
        try {
            $ef86fbc7a254aee2$var$initStage(stage);
        } catch (e) {
            console.warn('Hero products init failed:', e);
        }
    });
});



/*!
 * ScrollTrigger 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $7951ad84588ee8e0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7951ad84588ee8e0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7951ad84588ee8e0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7951ad84588ee8e0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $7951ad84588ee8e0$var$gsap, $7951ad84588ee8e0$var$_coreInitted, $7951ad84588ee8e0$var$_clamp, $7951ad84588ee8e0$var$_win, $7951ad84588ee8e0$var$_doc, $7951ad84588ee8e0$var$_docEl, $7951ad84588ee8e0$var$_body, $7951ad84588ee8e0$var$_isTouch, $7951ad84588ee8e0$var$_pointerType, $7951ad84588ee8e0$var$ScrollTrigger, $7951ad84588ee8e0$var$_root, $7951ad84588ee8e0$var$_normalizer, $7951ad84588ee8e0$var$_eventTypes, $7951ad84588ee8e0$var$_context, $7951ad84588ee8e0$var$_getGSAP = function _getGSAP() {
    return $7951ad84588ee8e0$var$gsap || typeof window !== "undefined" && ($7951ad84588ee8e0$var$gsap = window.gsap) && $7951ad84588ee8e0$var$gsap.registerPlugin && $7951ad84588ee8e0$var$gsap;
}, $7951ad84588ee8e0$var$_startup = 1, $7951ad84588ee8e0$var$_observers = [], $7951ad84588ee8e0$export$3cd1cee43d19b683 = [], $7951ad84588ee8e0$export$d8e56d510a804d0a = [], $7951ad84588ee8e0$var$_getTime = Date.now, $7951ad84588ee8e0$var$_bridge = function _bridge(name, value) {
    return value;
}, $7951ad84588ee8e0$var$_integrate = function _integrate() {
    var core = $7951ad84588ee8e0$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $7951ad84588ee8e0$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $7951ad84588ee8e0$export$d8e56d510a804d0a);
    $7951ad84588ee8e0$export$3cd1cee43d19b683 = scrollers;
    $7951ad84588ee8e0$export$d8e56d510a804d0a = proxies;
    $7951ad84588ee8e0$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $7951ad84588ee8e0$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$7951ad84588ee8e0$export$d8e56d510a804d0a.indexOf(element) && $7951ad84588ee8e0$export$d8e56d510a804d0a[$7951ad84588ee8e0$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $7951ad84588ee8e0$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$7951ad84588ee8e0$var$_root.indexOf(el);
}, $7951ad84588ee8e0$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $7951ad84588ee8e0$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $7951ad84588ee8e0$var$_scrollLeft = "scrollLeft", $7951ad84588ee8e0$var$_scrollTop = "scrollTop", $7951ad84588ee8e0$var$_onScroll = function _onScroll() {
    return $7951ad84588ee8e0$var$_normalizer && $7951ad84588ee8e0$var$_normalizer.isPressed || $7951ad84588ee8e0$export$3cd1cee43d19b683.cache++;
}, $7951ad84588ee8e0$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $7951ad84588ee8e0$var$_startup && ($7951ad84588ee8e0$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $7951ad84588ee8e0$var$_normalizer && $7951ad84588ee8e0$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($7951ad84588ee8e0$var$_normalizer && $7951ad84588ee8e0$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $7951ad84588ee8e0$export$3cd1cee43d19b683.cache;
            isNormalizing && $7951ad84588ee8e0$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $7951ad84588ee8e0$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $7951ad84588ee8e0$var$_bridge("ref")) {
            cachingFunc.cacheID = $7951ad84588ee8e0$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $7951ad84588ee8e0$export$b2cabb342cb0ebe1 = {
    s: $7951ad84588ee8e0$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $7951ad84588ee8e0$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $7951ad84588ee8e0$var$_win.scrollTo(value, $7951ad84588ee8e0$export$8e40fc98ff518e9d.sc()) : $7951ad84588ee8e0$var$_win.pageXOffset || $7951ad84588ee8e0$var$_doc[$7951ad84588ee8e0$var$_scrollLeft] || $7951ad84588ee8e0$var$_docEl[$7951ad84588ee8e0$var$_scrollLeft] || $7951ad84588ee8e0$var$_body[$7951ad84588ee8e0$var$_scrollLeft] || 0;
    })
}, $7951ad84588ee8e0$export$8e40fc98ff518e9d = {
    s: $7951ad84588ee8e0$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $7951ad84588ee8e0$export$b2cabb342cb0ebe1,
    sc: $7951ad84588ee8e0$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $7951ad84588ee8e0$var$_win.scrollTo($7951ad84588ee8e0$export$b2cabb342cb0ebe1.sc(), value) : $7951ad84588ee8e0$var$_win.pageYOffset || $7951ad84588ee8e0$var$_doc[$7951ad84588ee8e0$var$_scrollTop] || $7951ad84588ee8e0$var$_docEl[$7951ad84588ee8e0$var$_scrollTop] || $7951ad84588ee8e0$var$_body[$7951ad84588ee8e0$var$_scrollTop] || 0;
    })
}, $7951ad84588ee8e0$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $7951ad84588ee8e0$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $7951ad84588ee8e0$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $7951ad84588ee8e0$var$_isWithin = function _isWithin(element, list) {
    // check if the element is in the list or is a descendant of an element in the list.
    var i = list.length;
    while(i--){
        if (list[i] === element || list[i].contains(element)) return true;
    }
    return false;
}, $7951ad84588ee8e0$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $7951ad84588ee8e0$export$4330f3a92e5d2e94(element) && (element = $7951ad84588ee8e0$var$_doc.scrollingElement || $7951ad84588ee8e0$var$_docEl);
    var i = $7951ad84588ee8e0$export$3cd1cee43d19b683.indexOf(element), offset = sc === $7951ad84588ee8e0$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $7951ad84588ee8e0$export$3cd1cee43d19b683.push(element) - 1);
    $7951ad84588ee8e0$export$3cd1cee43d19b683[i + offset] || $7951ad84588ee8e0$var$_addListener(element, "scroll", $7951ad84588ee8e0$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $7951ad84588ee8e0$export$3cd1cee43d19b683[i + offset], func = prev || ($7951ad84588ee8e0$export$3cd1cee43d19b683[i + offset] = $7951ad84588ee8e0$var$_scrollCacheFunc($7951ad84588ee8e0$export$6078f1ef08b38af9(element, s), true) || ($7951ad84588ee8e0$export$4330f3a92e5d2e94(element) ? sc : $7951ad84588ee8e0$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $7951ad84588ee8e0$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $7951ad84588ee8e0$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $7951ad84588ee8e0$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $7951ad84588ee8e0$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $7951ad84588ee8e0$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $7951ad84588ee8e0$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.cancelable !== false && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $7951ad84588ee8e0$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $7951ad84588ee8e0$var$_setScrollTrigger = function _setScrollTrigger() {
    $7951ad84588ee8e0$var$ScrollTrigger = $7951ad84588ee8e0$var$gsap.core.globals().ScrollTrigger;
    $7951ad84588ee8e0$var$ScrollTrigger && $7951ad84588ee8e0$var$ScrollTrigger.core && $7951ad84588ee8e0$var$_integrate();
}, $7951ad84588ee8e0$var$_initCore = function _initCore(core) {
    $7951ad84588ee8e0$var$gsap = core || $7951ad84588ee8e0$var$_getGSAP();
    if (!$7951ad84588ee8e0$var$_coreInitted && $7951ad84588ee8e0$var$gsap && typeof document !== "undefined" && document.body) {
        $7951ad84588ee8e0$var$_win = window;
        $7951ad84588ee8e0$var$_doc = document;
        $7951ad84588ee8e0$var$_docEl = $7951ad84588ee8e0$var$_doc.documentElement;
        $7951ad84588ee8e0$var$_body = $7951ad84588ee8e0$var$_doc.body;
        $7951ad84588ee8e0$var$_root = [
            $7951ad84588ee8e0$var$_win,
            $7951ad84588ee8e0$var$_doc,
            $7951ad84588ee8e0$var$_docEl,
            $7951ad84588ee8e0$var$_body
        ];
        $7951ad84588ee8e0$var$_clamp = $7951ad84588ee8e0$var$gsap.utils.clamp;
        $7951ad84588ee8e0$var$_context = $7951ad84588ee8e0$var$gsap.core.context || function() {};
        $7951ad84588ee8e0$var$_pointerType = "onpointerenter" in $7951ad84588ee8e0$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $7951ad84588ee8e0$var$_isTouch = $7951ad84588ee8e0$export$c1cbdee04e18ea8b.isTouch = $7951ad84588ee8e0$var$_win.matchMedia && $7951ad84588ee8e0$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $7951ad84588ee8e0$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $7951ad84588ee8e0$var$_eventTypes = $7951ad84588ee8e0$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $7951ad84588ee8e0$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $7951ad84588ee8e0$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $7951ad84588ee8e0$var$_startup = 0;
        }, 500);
        $7951ad84588ee8e0$var$_coreInitted = 1;
    }
    $7951ad84588ee8e0$var$ScrollTrigger || $7951ad84588ee8e0$var$_setScrollTrigger(); // Observer might be initted BEFORE ScrollTrigger, so don't put this with the initting code. ScrollTrigger will call Observer.register() when it inits.
    return $7951ad84588ee8e0$var$_coreInitted;
};
$7951ad84588ee8e0$export$b2cabb342cb0ebe1.op = $7951ad84588ee8e0$export$8e40fc98ff518e9d;
$7951ad84588ee8e0$export$3cd1cee43d19b683.cache = 0;
var $7951ad84588ee8e0$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $7951ad84588ee8e0$var$_coreInitted || $7951ad84588ee8e0$var$_initCore($7951ad84588ee8e0$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $7951ad84588ee8e0$var$ScrollTrigger || $7951ad84588ee8e0$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $7951ad84588ee8e0$export$937374fea3f88711(target) || $7951ad84588ee8e0$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $7951ad84588ee8e0$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($7951ad84588ee8e0$var$_win.getComputedStyle($7951ad84588ee8e0$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = $7951ad84588ee8e0$export$8665aac53dad5647(target, $7951ad84588ee8e0$export$b2cabb342cb0ebe1), scrollFuncY = $7951ad84588ee8e0$export$8665aac53dad5647(target, $7951ad84588ee8e0$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $7951ad84588ee8e0$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $7951ad84588ee8e0$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $7951ad84588ee8e0$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $7951ad84588ee8e0$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && $7951ad84588ee8e0$var$_isWithin(e.target, ignore) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $7951ad84588ee8e0$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $7951ad84588ee8e0$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDragStart && dragged === 1 && onDragStart(self);
                    onDrag && onDrag(self);
                    dragged = 0;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $7951ad84588ee8e0$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
                dragged || (dragged = isDragging ? 2 : 1); // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $7951ad84588ee8e0$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $7951ad84588ee8e0$var$_addListener(isNormalizer ? target : ownerDoc, $7951ad84588ee8e0$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $7951ad84588ee8e0$var$_removeListener(isNormalizer ? target : ownerDoc, $7951ad84588ee8e0$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $7951ad84588ee8e0$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $7951ad84588ee8e0$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($7951ad84588ee8e0$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $7951ad84588ee8e0$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $7951ad84588ee8e0$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $7951ad84588ee8e0$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $7951ad84588ee8e0$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $7951ad84588ee8e0$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $7951ad84588ee8e0$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $7951ad84588ee8e0$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $7951ad84588ee8e0$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $7951ad84588ee8e0$var$_addListener(isViewport ? ownerDoc : target, "scroll", $7951ad84588ee8e0$var$_onScroll);
                type.indexOf("scroll") >= 0 && $7951ad84588ee8e0$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $7951ad84588ee8e0$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $7951ad84588ee8e0$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $7951ad84588ee8e0$var$_addListener(target, $7951ad84588ee8e0$var$_eventTypes[0], _onPress, passive, capture);
                    $7951ad84588ee8e0$var$_addListener(ownerDoc, $7951ad84588ee8e0$var$_eventTypes[2], _onRelease);
                    $7951ad84588ee8e0$var$_addListener(ownerDoc, $7951ad84588ee8e0$var$_eventTypes[3], _onRelease);
                    allowClicks && $7951ad84588ee8e0$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $7951ad84588ee8e0$var$_addListener(target, "click", _onClick);
                    onGestureStart && $7951ad84588ee8e0$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $7951ad84588ee8e0$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $7951ad84588ee8e0$var$_addListener(target, $7951ad84588ee8e0$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $7951ad84588ee8e0$var$_addListener(target, $7951ad84588ee8e0$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $7951ad84588ee8e0$var$_addListener(target, $7951ad84588ee8e0$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
                self._vx.reset();
                self._vy.reset();
                scrollX = scrollFuncX();
                scrollY = scrollFuncY();
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $7951ad84588ee8e0$var$_observers.filter(function(o) {
                    return o !== self && $7951ad84588ee8e0$export$4330f3a92e5d2e94(o.target);
                }).length || $7951ad84588ee8e0$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $7951ad84588ee8e0$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $7951ad84588ee8e0$var$_removeListener(isNormalizer ? target : ownerDoc, $7951ad84588ee8e0$var$_eventTypes[1], _onDrag, true);
                }
                $7951ad84588ee8e0$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $7951ad84588ee8e0$var$_removeListener(target, "wheel", _onWheel, capture);
                $7951ad84588ee8e0$var$_removeListener(target, $7951ad84588ee8e0$var$_eventTypes[0], _onPress, capture);
                $7951ad84588ee8e0$var$_removeListener(ownerDoc, $7951ad84588ee8e0$var$_eventTypes[2], _onRelease);
                $7951ad84588ee8e0$var$_removeListener(ownerDoc, $7951ad84588ee8e0$var$_eventTypes[3], _onRelease);
                $7951ad84588ee8e0$var$_removeListener(target, "click", clickCapture, true);
                $7951ad84588ee8e0$var$_removeListener(target, "click", _onClick);
                $7951ad84588ee8e0$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $7951ad84588ee8e0$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $7951ad84588ee8e0$var$_removeListener(target, $7951ad84588ee8e0$var$_pointerType + "enter", _onHover);
                $7951ad84588ee8e0$var$_removeListener(target, $7951ad84588ee8e0$var$_pointerType + "leave", _onHoverEnd);
                $7951ad84588ee8e0$var$_removeListener(target, $7951ad84588ee8e0$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $7951ad84588ee8e0$var$_observers.indexOf(self);
            i >= 0 && $7951ad84588ee8e0$var$_observers.splice(i, 1);
            $7951ad84588ee8e0$var$_normalizer === self && ($7951ad84588ee8e0$var$_normalizer = 0);
        };
        $7951ad84588ee8e0$var$_observers.push(self);
        isNormalizer && $7951ad84588ee8e0$export$4330f3a92e5d2e94(target) && ($7951ad84588ee8e0$var$_normalizer = self);
        self.enable(event);
    };
    $7951ad84588ee8e0$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$7951ad84588ee8e0$export$c1cbdee04e18ea8b.version = "3.15.0";
$7951ad84588ee8e0$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $7951ad84588ee8e0$export$c1cbdee04e18ea8b(vars);
};
$7951ad84588ee8e0$export$c1cbdee04e18ea8b.register = $7951ad84588ee8e0$var$_initCore;
$7951ad84588ee8e0$export$c1cbdee04e18ea8b.getAll = function() {
    return $7951ad84588ee8e0$var$_observers.slice();
};
$7951ad84588ee8e0$export$c1cbdee04e18ea8b.getById = function(id) {
    return $7951ad84588ee8e0$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$7951ad84588ee8e0$var$_getGSAP() && $7951ad84588ee8e0$var$gsap.registerPlugin($7951ad84588ee8e0$export$c1cbdee04e18ea8b);


var $5b7018eaa860fc7e$var$gsap, $5b7018eaa860fc7e$var$_coreInitted, $5b7018eaa860fc7e$var$_win, $5b7018eaa860fc7e$var$_doc, $5b7018eaa860fc7e$var$_docEl, $5b7018eaa860fc7e$var$_body, $5b7018eaa860fc7e$var$_root, $5b7018eaa860fc7e$var$_resizeDelay, $5b7018eaa860fc7e$var$_toArray, $5b7018eaa860fc7e$var$_clamp, $5b7018eaa860fc7e$var$_time2, $5b7018eaa860fc7e$var$_syncInterval, $5b7018eaa860fc7e$var$_refreshing, $5b7018eaa860fc7e$var$_pointerIsDown, $5b7018eaa860fc7e$var$_transformProp, $5b7018eaa860fc7e$var$_i, $5b7018eaa860fc7e$var$_prevWidth, $5b7018eaa860fc7e$var$_prevHeight, $5b7018eaa860fc7e$var$_autoRefresh, $5b7018eaa860fc7e$var$_sort, $5b7018eaa860fc7e$var$_suppressOverwrites, $5b7018eaa860fc7e$var$_ignoreResize, $5b7018eaa860fc7e$var$_normalizer, $5b7018eaa860fc7e$var$_ignoreMobileResize, $5b7018eaa860fc7e$var$_baseScreenHeight, $5b7018eaa860fc7e$var$_baseScreenWidth, $5b7018eaa860fc7e$var$_fixIOSBug, $5b7018eaa860fc7e$var$_context, $5b7018eaa860fc7e$var$_scrollRestoration, $5b7018eaa860fc7e$var$_div100vh, $5b7018eaa860fc7e$var$_100vh, $5b7018eaa860fc7e$var$_isReverted, $5b7018eaa860fc7e$var$_clampingMax, $5b7018eaa860fc7e$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$5b7018eaa860fc7e$var$_startup = 1, $5b7018eaa860fc7e$var$_getTime = Date.now, $5b7018eaa860fc7e$var$_time1 = $5b7018eaa860fc7e$var$_getTime(), $5b7018eaa860fc7e$var$_lastScrollTime = 0, $5b7018eaa860fc7e$var$_enabled = 0, $5b7018eaa860fc7e$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $5b7018eaa860fc7e$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $5b7018eaa860fc7e$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$5b7018eaa860fc7e$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $5b7018eaa860fc7e$var$_rafBugFix = function _rafBugFix() {
    return $5b7018eaa860fc7e$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$5b7018eaa860fc7e$var$_pointerDownHandler = function _pointerDownHandler() {
    return $5b7018eaa860fc7e$var$_pointerIsDown = 1;
}, $5b7018eaa860fc7e$var$_pointerUpHandler = function _pointerUpHandler() {
    return $5b7018eaa860fc7e$var$_pointerIsDown = 0;
}, $5b7018eaa860fc7e$var$_passThrough = function _passThrough(v) {
    return v;
}, $5b7018eaa860fc7e$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $5b7018eaa860fc7e$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $5b7018eaa860fc7e$var$_getGSAP = function _getGSAP() {
    return $5b7018eaa860fc7e$var$gsap || $5b7018eaa860fc7e$var$_windowExists() && ($5b7018eaa860fc7e$var$gsap = window.gsap) && $5b7018eaa860fc7e$var$gsap.registerPlugin && $5b7018eaa860fc7e$var$gsap;
}, $5b7018eaa860fc7e$var$_isViewport = function _isViewport(e) {
    return !!~$5b7018eaa860fc7e$var$_root.indexOf(e);
}, $5b7018eaa860fc7e$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $5b7018eaa860fc7e$var$_100vh : $5b7018eaa860fc7e$var$_win["inner" + dimensionProperty]) || $5b7018eaa860fc7e$var$_docEl["client" + dimensionProperty] || $5b7018eaa860fc7e$var$_body["client" + dimensionProperty];
}, $5b7018eaa860fc7e$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($5b7018eaa860fc7e$var$_isViewport(element) ? function() {
        $5b7018eaa860fc7e$var$_winOffsets.width = $5b7018eaa860fc7e$var$_win.innerWidth;
        $5b7018eaa860fc7e$var$_winOffsets.height = $5b7018eaa860fc7e$var$_100vh;
        return $5b7018eaa860fc7e$var$_winOffsets;
    } : function() {
        return $5b7018eaa860fc7e$var$_getBounds(element);
    });
}, $5b7018eaa860fc7e$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $5b7018eaa860fc7e$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $5b7018eaa860fc7e$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $7951ad84588ee8e0$export$d8e56d510a804d0a).indexOf(element) ? $5b7018eaa860fc7e$var$_getBoundsFunc(element) : function() {
        return $5b7018eaa860fc7e$var$_winOffsets;
    };
}, $5b7018eaa860fc7e$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(element, s)) ? a() - $5b7018eaa860fc7e$var$_getBoundsFunc(element)()[d] : $5b7018eaa860fc7e$var$_isViewport(element) ? ($5b7018eaa860fc7e$var$_docEl[s] || $5b7018eaa860fc7e$var$_body[s]) - $5b7018eaa860fc7e$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $5b7018eaa860fc7e$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $5b7018eaa860fc7e$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($5b7018eaa860fc7e$var$_autoRefresh[i + 1])) && func($5b7018eaa860fc7e$var$_autoRefresh[i], $5b7018eaa860fc7e$var$_autoRefresh[i + 1], $5b7018eaa860fc7e$var$_autoRefresh[i + 2]);
}, $5b7018eaa860fc7e$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $5b7018eaa860fc7e$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $5b7018eaa860fc7e$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $5b7018eaa860fc7e$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $5b7018eaa860fc7e$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $5b7018eaa860fc7e$var$_callback = function _callback(self, func, extraParam) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self, extraParam);
        }) : func(self, extraParam);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $5b7018eaa860fc7e$var$_abs = Math.abs, $5b7018eaa860fc7e$var$_left = "left", $5b7018eaa860fc7e$var$_top = "top", $5b7018eaa860fc7e$var$_right = "right", $5b7018eaa860fc7e$var$_bottom = "bottom", $5b7018eaa860fc7e$var$_width = "width", $5b7018eaa860fc7e$var$_height = "height", $5b7018eaa860fc7e$var$_Right = "Right", $5b7018eaa860fc7e$var$_Left = "Left", $5b7018eaa860fc7e$var$_Top = "Top", $5b7018eaa860fc7e$var$_Bottom = "Bottom", $5b7018eaa860fc7e$var$_padding = "padding", $5b7018eaa860fc7e$var$_margin = "margin", $5b7018eaa860fc7e$var$_Width = "Width", $5b7018eaa860fc7e$var$_Height = "Height", $5b7018eaa860fc7e$var$_px = "px", $5b7018eaa860fc7e$var$_getComputedStyle = function _getComputedStyle(element) {
    return $5b7018eaa860fc7e$var$_win.getComputedStyle(element.nodeType === Node.DOCUMENT_NODE ? element.scrollingElement : element);
}, $5b7018eaa860fc7e$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $5b7018eaa860fc7e$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $5b7018eaa860fc7e$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $5b7018eaa860fc7e$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $5b7018eaa860fc7e$var$_getComputedStyle(element)[$5b7018eaa860fc7e$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $5b7018eaa860fc7e$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect ? element.getBoundingClientRect() : element.scrollingElement.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $5b7018eaa860fc7e$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $5b7018eaa860fc7e$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $5b7018eaa860fc7e$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $5b7018eaa860fc7e$var$gsap.utils.snap($5b7018eaa860fc7e$var$_getLabelRatioArray(animation), value);
    };
}, $5b7018eaa860fc7e$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $5b7018eaa860fc7e$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $5b7018eaa860fc7e$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $5b7018eaa860fc7e$var$_snapDirectional($5b7018eaa860fc7e$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $5b7018eaa860fc7e$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $5b7018eaa860fc7e$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $5b7018eaa860fc7e$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $5b7018eaa860fc7e$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $5b7018eaa860fc7e$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $5b7018eaa860fc7e$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $5b7018eaa860fc7e$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $5b7018eaa860fc7e$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($5b7018eaa860fc7e$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $5b7018eaa860fc7e$var$_keywords ? $5b7018eaa860fc7e$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $5b7018eaa860fc7e$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $5b7018eaa860fc7e$var$_doc.createElement("div"), useFixedPosition = $5b7018eaa860fc7e$var$_isViewport(container) || (0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $5b7018eaa860fc7e$var$_body : container.tagName === "IFRAME" ? container.contentDocument.body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d) ? $5b7018eaa860fc7e$var$_right : $5b7018eaa860fc7e$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $5b7018eaa860fc7e$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $5b7018eaa860fc7e$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $5b7018eaa860fc7e$var$_Width] = 1;
    vars["border" + oppositeSide + $5b7018eaa860fc7e$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $5b7018eaa860fc7e$var$gsap.set(marker, vars);
}, $5b7018eaa860fc7e$var$_triggers = [], $5b7018eaa860fc7e$var$_ids = {}, $5b7018eaa860fc7e$var$_rafID, $5b7018eaa860fc7e$var$_sync = function _sync() {
    return $5b7018eaa860fc7e$var$_getTime() - $5b7018eaa860fc7e$var$_lastScrollTime > 34 && ($5b7018eaa860fc7e$var$_rafID || ($5b7018eaa860fc7e$var$_rafID = requestAnimationFrame($5b7018eaa860fc7e$var$_updateAll)));
}, $5b7018eaa860fc7e$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$5b7018eaa860fc7e$var$_normalizer || !$5b7018eaa860fc7e$var$_normalizer.isPressed || $5b7018eaa860fc7e$var$_normalizer.startX > $5b7018eaa860fc7e$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache++;
        if ($5b7018eaa860fc7e$var$_normalizer) $5b7018eaa860fc7e$var$_rafID || ($5b7018eaa860fc7e$var$_rafID = requestAnimationFrame($5b7018eaa860fc7e$var$_updateAll));
        else $5b7018eaa860fc7e$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $5b7018eaa860fc7e$var$_lastScrollTime || $5b7018eaa860fc7e$var$_dispatch("scrollStart");
        $5b7018eaa860fc7e$var$_lastScrollTime = $5b7018eaa860fc7e$var$_getTime();
    }
}, $5b7018eaa860fc7e$var$_setBaseDimensions = function _setBaseDimensions() {
    $5b7018eaa860fc7e$var$_baseScreenWidth = $5b7018eaa860fc7e$var$_win.innerWidth;
    $5b7018eaa860fc7e$var$_baseScreenHeight = $5b7018eaa860fc7e$var$_win.innerHeight;
}, $5b7018eaa860fc7e$var$_onResize = function _onResize(force) {
    (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache++;
    (force === true || !$5b7018eaa860fc7e$var$_refreshing && !$5b7018eaa860fc7e$var$_ignoreResize && !$5b7018eaa860fc7e$var$_doc.fullscreenElement && !$5b7018eaa860fc7e$var$_doc.webkitFullscreenElement && (!$5b7018eaa860fc7e$var$_ignoreMobileResize || $5b7018eaa860fc7e$var$_baseScreenWidth !== $5b7018eaa860fc7e$var$_win.innerWidth || Math.abs($5b7018eaa860fc7e$var$_win.innerHeight - $5b7018eaa860fc7e$var$_baseScreenHeight) > $5b7018eaa860fc7e$var$_win.innerHeight * 0.25)) && $5b7018eaa860fc7e$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$5b7018eaa860fc7e$var$_listeners = {}, $5b7018eaa860fc7e$var$_emptyArray = [], $5b7018eaa860fc7e$var$_softRefresh = function _softRefresh() {
    return $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$export$875bcbe48555930, "scrollEnd", _softRefresh) || $5b7018eaa860fc7e$var$_refreshAll(true);
}, $5b7018eaa860fc7e$var$_dispatch = function _dispatch(type) {
    return $5b7018eaa860fc7e$var$_listeners[type] && $5b7018eaa860fc7e$var$_listeners[type].map(function(f) {
        return f();
    }) || $5b7018eaa860fc7e$var$_emptyArray;
}, $5b7018eaa860fc7e$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$5b7018eaa860fc7e$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $5b7018eaa860fc7e$var$_savedStyles.length; i += 5)if (!media || $5b7018eaa860fc7e$var$_savedStyles[i + 4] && $5b7018eaa860fc7e$var$_savedStyles[i + 4].query === media) {
        $5b7018eaa860fc7e$var$_savedStyles[i].style.cssText = $5b7018eaa860fc7e$var$_savedStyles[i + 1];
        $5b7018eaa860fc7e$var$_savedStyles[i].getBBox && $5b7018eaa860fc7e$var$_savedStyles[i].setAttribute("transform", $5b7018eaa860fc7e$var$_savedStyles[i + 2] || "");
        $5b7018eaa860fc7e$var$_savedStyles[i + 3].uncache = 1;
    }
}, $5b7018eaa860fc7e$var$_recordScrollPositions = function _recordScrollPositions() {
    return (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).forEach(function(obj) {
        return $5b7018eaa860fc7e$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    });
}, // record the current scroll position. Also force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
$5b7018eaa860fc7e$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($5b7018eaa860fc7e$var$_i = 0; $5b7018eaa860fc7e$var$_i < $5b7018eaa860fc7e$var$_triggers.length; $5b7018eaa860fc7e$var$_i++){
        trigger = $5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $5b7018eaa860fc7e$var$_isReverted = true;
    media && $5b7018eaa860fc7e$var$_revertRecorded(media);
    media || $5b7018eaa860fc7e$var$_dispatch("revert");
}, $5b7018eaa860fc7e$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache++;
    (force || !$5b7018eaa860fc7e$var$_refreshingAll) && (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).forEach(function(obj) {
        return $5b7018eaa860fc7e$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $5b7018eaa860fc7e$var$_isString(scrollRestoration) && ($5b7018eaa860fc7e$var$_win.history.scrollRestoration = $5b7018eaa860fc7e$var$_scrollRestoration = scrollRestoration);
}, $5b7018eaa860fc7e$var$_refreshingAll, $5b7018eaa860fc7e$var$_refreshID = 0, $5b7018eaa860fc7e$var$_queueRefreshID, $5b7018eaa860fc7e$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($5b7018eaa860fc7e$var$_queueRefreshID !== $5b7018eaa860fc7e$var$_refreshID) {
        var id = $5b7018eaa860fc7e$var$_queueRefreshID = $5b7018eaa860fc7e$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $5b7018eaa860fc7e$var$_refreshID && $5b7018eaa860fc7e$var$_refreshAll(true);
        });
    }
}, $5b7018eaa860fc7e$var$_refresh100vh = function _refresh100vh() {
    $5b7018eaa860fc7e$var$_body.appendChild($5b7018eaa860fc7e$var$_div100vh);
    $5b7018eaa860fc7e$var$_100vh = !$5b7018eaa860fc7e$var$_normalizer && $5b7018eaa860fc7e$var$_div100vh.offsetHeight || $5b7018eaa860fc7e$var$_win.innerHeight;
    $5b7018eaa860fc7e$var$_body.removeChild($5b7018eaa860fc7e$var$_div100vh);
}, $5b7018eaa860fc7e$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $5b7018eaa860fc7e$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $5b7018eaa860fc7e$var$_refreshAll = function _refreshAll(force, skipRevert) {
    $5b7018eaa860fc7e$var$_docEl = $5b7018eaa860fc7e$var$_doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
    $5b7018eaa860fc7e$var$_body = $5b7018eaa860fc7e$var$_doc.body;
    $5b7018eaa860fc7e$var$_root = [
        $5b7018eaa860fc7e$var$_win,
        $5b7018eaa860fc7e$var$_doc,
        $5b7018eaa860fc7e$var$_docEl,
        $5b7018eaa860fc7e$var$_body
    ];
    if ($5b7018eaa860fc7e$var$_lastScrollTime && !force && !$5b7018eaa860fc7e$var$_isReverted) {
        $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$export$875bcbe48555930, "scrollEnd", $5b7018eaa860fc7e$var$_softRefresh);
        return;
    }
    $5b7018eaa860fc7e$var$_refresh100vh();
    $5b7018eaa860fc7e$var$_refreshingAll = $5b7018eaa860fc7e$export$875bcbe48555930.isRefreshing = true;
    $5b7018eaa860fc7e$var$_isReverted || $5b7018eaa860fc7e$var$_recordScrollPositions();
    var refreshInits = $5b7018eaa860fc7e$var$_dispatch("refreshInit");
    $5b7018eaa860fc7e$var$_sort && $5b7018eaa860fc7e$export$875bcbe48555930.sort();
    skipRevert || $5b7018eaa860fc7e$var$_revertAll();
    (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($5b7018eaa860fc7e$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $5b7018eaa860fc7e$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $5b7018eaa860fc7e$var$_isReverted = false;
    $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $5b7018eaa860fc7e$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $5b7018eaa860fc7e$var$_hideAllMarkers(true);
    $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $5b7018eaa860fc7e$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $5b7018eaa860fc7e$var$_hideAllMarkers(false);
    $5b7018eaa860fc7e$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($5b7018eaa860fc7e$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $5b7018eaa860fc7e$var$_clearScrollMemory($5b7018eaa860fc7e$var$_scrollRestoration, 1);
    $5b7018eaa860fc7e$var$_resizeDelay.pause();
    $5b7018eaa860fc7e$var$_refreshID++;
    $5b7018eaa860fc7e$var$_refreshingAll = 2;
    $5b7018eaa860fc7e$var$_updateAll(2);
    $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
        return $5b7018eaa860fc7e$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $5b7018eaa860fc7e$var$_refreshingAll = $5b7018eaa860fc7e$export$875bcbe48555930.isRefreshing = false;
    $5b7018eaa860fc7e$var$_dispatch("refresh");
}, $5b7018eaa860fc7e$var$_lastScroll = 0, $5b7018eaa860fc7e$var$_direction = 1, $5b7018eaa860fc7e$var$_primary, $5b7018eaa860fc7e$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$5b7018eaa860fc7e$var$_refreshingAll && !$5b7018eaa860fc7e$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $5b7018eaa860fc7e$export$875bcbe48555930.isUpdating = true;
        $5b7018eaa860fc7e$var$_primary && $5b7018eaa860fc7e$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $5b7018eaa860fc7e$var$_triggers.length, time = $5b7018eaa860fc7e$var$_getTime(), recordVelocity = time - $5b7018eaa860fc7e$var$_time1 >= 50, scroll = l && $5b7018eaa860fc7e$var$_triggers[0].scroll();
        $5b7018eaa860fc7e$var$_direction = $5b7018eaa860fc7e$var$_lastScroll > scroll ? -1 : 1;
        $5b7018eaa860fc7e$var$_refreshingAll || ($5b7018eaa860fc7e$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($5b7018eaa860fc7e$var$_lastScrollTime && !$5b7018eaa860fc7e$var$_pointerIsDown && time - $5b7018eaa860fc7e$var$_lastScrollTime > 200) {
                $5b7018eaa860fc7e$var$_lastScrollTime = 0;
                $5b7018eaa860fc7e$var$_dispatch("scrollEnd");
            }
            $5b7018eaa860fc7e$var$_time2 = $5b7018eaa860fc7e$var$_time1;
            $5b7018eaa860fc7e$var$_time1 = time;
        }
        if ($5b7018eaa860fc7e$var$_direction < 0) {
            $5b7018eaa860fc7e$var$_i = l;
            while($5b7018eaa860fc7e$var$_i-- > 0)$5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_i] && $5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_i].update(0, recordVelocity);
            $5b7018eaa860fc7e$var$_direction = 1;
        } else for($5b7018eaa860fc7e$var$_i = 0; $5b7018eaa860fc7e$var$_i < l; $5b7018eaa860fc7e$var$_i++)$5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_i] && $5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_i].update(0, recordVelocity);
        $5b7018eaa860fc7e$export$875bcbe48555930.isUpdating = false;
    }
    $5b7018eaa860fc7e$var$_rafID = 0;
}, $5b7018eaa860fc7e$var$_propNamesToCopy = [
    $5b7018eaa860fc7e$var$_left,
    $5b7018eaa860fc7e$var$_top,
    $5b7018eaa860fc7e$var$_bottom,
    $5b7018eaa860fc7e$var$_right,
    $5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Bottom,
    $5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Right,
    $5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Top,
    $5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $5b7018eaa860fc7e$var$_stateProps = $5b7018eaa860fc7e$var$_propNamesToCopy.concat([
    $5b7018eaa860fc7e$var$_width,
    $5b7018eaa860fc7e$var$_height,
    "boxSizing",
    "max" + $5b7018eaa860fc7e$var$_Width,
    "max" + $5b7018eaa860fc7e$var$_Height,
    "position",
    $5b7018eaa860fc7e$var$_margin,
    $5b7018eaa860fc7e$var$_padding,
    $5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Top,
    $5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Right,
    $5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Bottom,
    $5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Left
]), $5b7018eaa860fc7e$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $5b7018eaa860fc7e$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $5b7018eaa860fc7e$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $5b7018eaa860fc7e$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $5b7018eaa860fc7e$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $5b7018eaa860fc7e$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$5b7018eaa860fc7e$var$_bottom] = pinStyle[$5b7018eaa860fc7e$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$5b7018eaa860fc7e$var$_width] = $5b7018eaa860fc7e$var$_getSize(pin, (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1)) + $5b7018eaa860fc7e$var$_px;
        spacerStyle[$5b7018eaa860fc7e$var$_height] = $5b7018eaa860fc7e$var$_getSize(pin, (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d)) + $5b7018eaa860fc7e$var$_px;
        spacerStyle[$5b7018eaa860fc7e$var$_padding] = pinStyle[$5b7018eaa860fc7e$var$_margin] = pinStyle[$5b7018eaa860fc7e$var$_top] = pinStyle[$5b7018eaa860fc7e$var$_left] = "0";
        $5b7018eaa860fc7e$var$_setState(spacerState);
        pinStyle[$5b7018eaa860fc7e$var$_width] = pinStyle["max" + $5b7018eaa860fc7e$var$_Width] = cs[$5b7018eaa860fc7e$var$_width];
        pinStyle[$5b7018eaa860fc7e$var$_height] = pinStyle["max" + $5b7018eaa860fc7e$var$_Height] = cs[$5b7018eaa860fc7e$var$_height];
        pinStyle[$5b7018eaa860fc7e$var$_padding] = cs[$5b7018eaa860fc7e$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $5b7018eaa860fc7e$var$_capsExp = /([A-Z])/g, $5b7018eaa860fc7e$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $5b7018eaa860fc7e$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($5b7018eaa860fc7e$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $5b7018eaa860fc7e$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $5b7018eaa860fc7e$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($5b7018eaa860fc7e$var$_stateProps[i], style[$5b7018eaa860fc7e$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $5b7018eaa860fc7e$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $5b7018eaa860fc7e$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$5b7018eaa860fc7e$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $5b7018eaa860fc7e$var$_isFunction(value) && (value = value(self));
    if ($5b7018eaa860fc7e$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $5b7018eaa860fc7e$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$5b7018eaa860fc7e$var$_isNumber(value)) {
        $5b7018eaa860fc7e$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $7951ad84588ee8e0$export$937374fea3f88711)(trigger, self) || $5b7018eaa860fc7e$var$_body;
        bounds = $5b7018eaa860fc7e$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $5b7018eaa860fc7e$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $5b7018eaa860fc7e$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $5b7018eaa860fc7e$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $5b7018eaa860fc7e$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $5b7018eaa860fc7e$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $5b7018eaa860fc7e$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $5b7018eaa860fc7e$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $5b7018eaa860fc7e$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($5b7018eaa860fc7e$var$_body[p1], $5b7018eaa860fc7e$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $5b7018eaa860fc7e$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $5b7018eaa860fc7e$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $5b7018eaa860fc7e$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $5b7018eaa860fc7e$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $5b7018eaa860fc7e$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $5b7018eaa860fc7e$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $5b7018eaa860fc7e$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $5b7018eaa860fc7e$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$5b7018eaa860fc7e$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $5b7018eaa860fc7e$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $5b7018eaa860fc7e$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
    };
}, $5b7018eaa860fc7e$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $5b7018eaa860fc7e$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$5b7018eaa860fc7e$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $7951ad84588ee8e0$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $5b7018eaa860fc7e$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache++;
            getTween.tween && $5b7018eaa860fc7e$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $5b7018eaa860fc7e$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $5b7018eaa860fc7e$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $5b7018eaa860fc7e$export$875bcbe48555930.isTouch && $5b7018eaa860fc7e$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $5b7018eaa860fc7e$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $5b7018eaa860fc7e$var$_coreInitted || ScrollTrigger.register($5b7018eaa860fc7e$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $5b7018eaa860fc7e$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$5b7018eaa860fc7e$var$_enabled) {
            this.update = this.refresh = this.kill = $5b7018eaa860fc7e$var$_passThrough;
            return;
        }
        vars = $5b7018eaa860fc7e$var$_setDefaults($5b7018eaa860fc7e$var$_isString(vars) || $5b7018eaa860fc7e$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $5b7018eaa860fc7e$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1) : (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $7951ad84588ee8e0$export$937374fea3f88711)(vars.scroller || $5b7018eaa860fc7e$var$_win), scrollerCache = $5b7018eaa860fc7e$var$gsap.core.getCache(scroller), isViewport = $5b7018eaa860fc7e$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $5b7018eaa860fc7e$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($5b7018eaa860fc7e$var$_getComputedStyle(scroller)["border" + direction.p2 + $5b7018eaa860fc7e$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $5b7018eaa860fc7e$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $5b7018eaa860fc7e$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $7951ad84588ee8e0$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $5b7018eaa860fc7e$var$_sort = 1;
            vars.refreshPriority === -9999 && ($5b7018eaa860fc7e$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $5b7018eaa860fc7e$var$_getTweenCreator(scroller, (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d)),
            left: $5b7018eaa860fc7e$var$_getTweenCreator(scroller, (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $5b7018eaa860fc7e$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $5b7018eaa860fc7e$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$5b7018eaa860fc7e$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $5b7018eaa860fc7e$var$_body.style && $5b7018eaa860fc7e$var$gsap.set(isViewport ? [
                $5b7018eaa860fc7e$var$_body,
                $5b7018eaa860fc7e$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).forEach(function(o) {
                return $5b7018eaa860fc7e$var$_isFunction(o) && o.target === (isViewport ? $5b7018eaa860fc7e$var$_doc.scrollingElement || $5b7018eaa860fc7e$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $5b7018eaa860fc7e$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $5b7018eaa860fc7e$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $5b7018eaa860fc7e$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $5b7018eaa860fc7e$var$_snapDirectional(snap.snapTo)(value, $5b7018eaa860fc7e$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $5b7018eaa860fc7e$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $5b7018eaa860fc7e$var$_isObject(snapDurClamp) ? $5b7018eaa860fc7e$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $5b7018eaa860fc7e$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $5b7018eaa860fc7e$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $5b7018eaa860fc7e$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$5b7018eaa860fc7e$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($5b7018eaa860fc7e$var$_getTime() - $5b7018eaa860fc7e$var$_time2) * 1000 || 0, change1 = $5b7018eaa860fc7e$var$gsap.utils.clamp(-progress, 1 - progress, $5b7018eaa860fc7e$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $5b7018eaa860fc7e$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.max(0, Math.round(start + endValue * change));
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $5b7018eaa860fc7e$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($5b7018eaa860fc7e$var$_abs(Math.max($5b7018eaa860fc7e$var$_abs(naturalEnd - totalProgress), $5b7018eaa860fc7e$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $5b7018eaa860fc7e$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && $5b7018eaa860fc7e$var$_callback(self, _onInterrupt);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation && !isToggle) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && $5b7018eaa860fc7e$var$_callback(self, _onComplete);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && $5b7018eaa860fc7e$var$_callback(self, onStart, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($5b7018eaa860fc7e$var$_ids[id] = self);
        trigger = self.trigger = (0, $7951ad84588ee8e0$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $7951ad84588ee8e0$export$937374fea3f88711)(pin);
        $5b7018eaa860fc7e$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $5b7018eaa860fc7e$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $5b7018eaa860fc7e$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $5b7018eaa860fc7e$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $5b7018eaa860fc7e$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $7951ad84588ee8e0$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $5b7018eaa860fc7e$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $5b7018eaa860fc7e$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $5b7018eaa860fc7e$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $5b7018eaa860fc7e$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $5b7018eaa860fc7e$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $5b7018eaa860fc7e$var$gsap.getProperty(pin);
            pinSetter = $5b7018eaa860fc7e$var$gsap.quickSetter(pin, direction.a, $5b7018eaa860fc7e$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $5b7018eaa860fc7e$var$_swapPinIn(pin, spacer, cs);
            pinState = $5b7018eaa860fc7e$var$_getState(pin);
        }
        if (markers) {
            markerVars = $5b7018eaa860fc7e$var$_isObject(markers) ? $5b7018eaa860fc7e$var$_setDefaults(markers, $5b7018eaa860fc7e$var$_markerDefaults) : $5b7018eaa860fc7e$var$_markerDefaults;
            markerStartTrigger = $5b7018eaa860fc7e$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $5b7018eaa860fc7e$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $7951ad84588ee8e0$export$937374fea3f88711)((0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $5b7018eaa860fc7e$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $5b7018eaa860fc7e$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $5b7018eaa860fc7e$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $5b7018eaa860fc7e$var$_px));
            if (!useFixedPosition && !((0, $7951ad84588ee8e0$export$d8e56d510a804d0a).length && (0, $7951ad84588ee8e0$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $5b7018eaa860fc7e$var$_makePositionable(isViewport ? $5b7018eaa860fc7e$var$_body : scroller);
                $5b7018eaa860fc7e$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $5b7018eaa860fc7e$var$gsap.quickSetter(markerStartTrigger, direction.a, $5b7018eaa860fc7e$var$_px);
                markerEndSetter = $5b7018eaa860fc7e$var$gsap.quickSetter(markerEndTrigger, direction.a, $5b7018eaa860fc7e$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $5b7018eaa860fc7e$var$_triggers[$5b7018eaa860fc7e$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $5b7018eaa860fc7e$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $5b7018eaa860fc7e$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $5b7018eaa860fc7e$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $5b7018eaa860fc7e$var$_swapPinIn(pin, spacer, $5b7018eaa860fc7e$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $5b7018eaa860fc7e$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($5b7018eaa860fc7e$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $5b7018eaa860fc7e$var$_lastScrollTime) {
                $5b7018eaa860fc7e$var$_addListener(ScrollTrigger, "scrollEnd", $5b7018eaa860fc7e$var$_softRefresh);
                return;
            }
            !$5b7018eaa860fc7e$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $5b7018eaa860fc7e$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            if (invalidateOnRefresh && animation) {
                animation.revert({
                    kill: false
                }).invalidate();
                animation.getChildren ? animation.getChildren(true, true, false).forEach(function(t) {
                    return t.vars.immediateRender && t.render(0, true, true);
                }) : animation.vars.immediateRender && animation.render(0, true, true); // any from() or fromTo() tweens should render immediately (well, unless they have immediateRender: false)
            }
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $5b7018eaa860fc7e$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01 || !change, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $5b7018eaa860fc7e$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $5b7018eaa860fc7e$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $7951ad84588ee8e0$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $5b7018eaa860fc7e$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $5b7018eaa860fc7e$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $5b7018eaa860fc7e$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $5b7018eaa860fc7e$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i-- > 0){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $5b7018eaa860fc7e$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($5b7018eaa860fc7e$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $5b7018eaa860fc7e$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $5b7018eaa860fc7e$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $5b7018eaa860fc7e$var$_parseClamp(parsedStart, "start", self);
            start = $5b7018eaa860fc7e$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $5b7018eaa860fc7e$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($5b7018eaa860fc7e$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($5b7018eaa860fc7e$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $5b7018eaa860fc7e$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $5b7018eaa860fc7e$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $5b7018eaa860fc7e$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $5b7018eaa860fc7e$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $5b7018eaa860fc7e$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $5b7018eaa860fc7e$var$_triggers[i] || {};
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$5b7018eaa860fc7e$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $5b7018eaa860fc7e$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $5b7018eaa860fc7e$var$gsap.utils.clamp(0, 1, $5b7018eaa860fc7e$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $5b7018eaa860fc7e$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($5b7018eaa860fc7e$var$_clampingMax && self.end >= $5b7018eaa860fc7e$var$_maxScroll(scroller, direction))) {
                cs = $5b7018eaa860fc7e$var$_getComputedStyle(pin);
                isVertical = direction === (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $5b7018eaa860fc7e$var$_doc.scrollingElement || $5b7018eaa860fc7e$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $5b7018eaa860fc7e$var$_getComputedStyle($5b7018eaa860fc7e$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $5b7018eaa860fc7e$var$_swapPinIn(pin, spacer, cs);
                pinState = $5b7018eaa860fc7e$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $5b7018eaa860fc7e$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $7951ad84588ee8e0$export$8665aac53dad5647)(scroller, isVertical ? (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1) : (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $5b7018eaa860fc7e$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $5b7018eaa860fc7e$var$_padding ? $5b7018eaa860fc7e$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $5b7018eaa860fc7e$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $5b7018eaa860fc7e$var$_px);
                    }
                    $5b7018eaa860fc7e$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $5b7018eaa860fc7e$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $5b7018eaa860fc7e$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $5b7018eaa860fc7e$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $5b7018eaa860fc7e$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$5b7018eaa860fc7e$var$_width] = override["max" + $5b7018eaa860fc7e$var$_Width] = Math.ceil(bounds.width) + $5b7018eaa860fc7e$var$_px;
                    override[$5b7018eaa860fc7e$var$_height] = override["max" + $5b7018eaa860fc7e$var$_Height] = Math.ceil(bounds.height) + $5b7018eaa860fc7e$var$_px;
                    override[$5b7018eaa860fc7e$var$_margin] = override[$5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Top] = override[$5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Right] = override[$5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Bottom] = override[$5b7018eaa860fc7e$var$_margin + $5b7018eaa860fc7e$var$_Left] = "0";
                    override[$5b7018eaa860fc7e$var$_padding] = cs[$5b7018eaa860fc7e$var$_padding];
                    override[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Top] = cs[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Top];
                    override[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Right] = cs[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Right];
                    override[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Bottom] = cs[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Bottom];
                    override[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Left] = cs[$5b7018eaa860fc7e$var$_padding + $5b7018eaa860fc7e$var$_Left];
                    pinActiveState = $5b7018eaa860fc7e$var$_copyState(pinOriginalState, override, pinReparent);
                    $5b7018eaa860fc7e$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $5b7018eaa860fc7e$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $5b7018eaa860fc7e$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $5b7018eaa860fc7e$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $5b7018eaa860fc7e$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$5b7018eaa860fc7e$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $5b7018eaa860fc7e$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $5b7018eaa860fc7e$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $5b7018eaa860fc7e$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $5b7018eaa860fc7e$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $5b7018eaa860fc7e$var$gsap.getProperty(markerEndTrigger, direction.p);
                $5b7018eaa860fc7e$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $5b7018eaa860fc7e$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $5b7018eaa860fc7e$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $5b7018eaa860fc7e$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$5b7018eaa860fc7e$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$5b7018eaa860fc7e$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($5b7018eaa860fc7e$var$_getTime() - $5b7018eaa860fc7e$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $5b7018eaa860fc7e$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $5b7018eaa860fc7e$var$_endAnimation(animation, animation.reversed()) : isToggle || $5b7018eaa860fc7e$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $5b7018eaa860fc7e$var$_triggers.indexOf(self), a = self.direction > 0 ? $5b7018eaa860fc7e$var$_triggers.slice(0, i).reverse() : $5b7018eaa860fc7e$var$_triggers.slice(i + 1);
            return ($5b7018eaa860fc7e$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $5b7018eaa860fc7e$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$5b7018eaa860fc7e$var$_refreshing && !$5b7018eaa860fc7e$var$_startup && $5b7018eaa860fc7e$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($5b7018eaa860fc7e$var$_getTime() - $5b7018eaa860fc7e$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($5b7018eaa860fc7e$var$_getTime() - $5b7018eaa860fc7e$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$5b7018eaa860fc7e$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($5b7018eaa860fc7e$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$5b7018eaa860fc7e$var$_refreshing && !$5b7018eaa860fc7e$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($5b7018eaa860fc7e$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($5b7018eaa860fc7e$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $5b7018eaa860fc7e$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $5b7018eaa860fc7e$var$_getBounds(pin, true), _offset = scroll - start;
                                $5b7018eaa860fc7e$var$_reparent(pin, $5b7018eaa860fc7e$var$_body, bounds.top + (direction === (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d) ? _offset : 0) + $5b7018eaa860fc7e$var$_px, bounds.left + (direction === (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d) ? 0 : _offset) + $5b7018eaa860fc7e$var$_px);
                            } else $5b7018eaa860fc7e$var$_reparent(pin, spacer);
                        }
                        $5b7018eaa860fc7e$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$5b7018eaa860fc7e$var$_refreshing && !$5b7018eaa860fc7e$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$5b7018eaa860fc7e$var$_limitCallbacks)) && $5b7018eaa860fc7e$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$5b7018eaa860fc7e$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$5b7018eaa860fc7e$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $5b7018eaa860fc7e$var$_callback(self, onToggle);
                        callbacks[toggleState] && $5b7018eaa860fc7e$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $5b7018eaa860fc7e$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($5b7018eaa860fc7e$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $5b7018eaa860fc7e$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $5b7018eaa860fc7e$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$5b7018eaa860fc7e$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $5b7018eaa860fc7e$var$_addListener(scroller, "resize", $5b7018eaa860fc7e$var$_onResize);
                isViewport || $5b7018eaa860fc7e$var$_addListener(scroller, "scroll", $5b7018eaa860fc7e$var$_onScroll);
                onRefreshInit && $5b7018eaa860fc7e$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $5b7018eaa860fc7e$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $5b7018eaa860fc7e$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $5b7018eaa860fc7e$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $5b7018eaa860fc7e$var$_px;
                $5b7018eaa860fc7e$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            reset !== false && self.revert(true, true);
            if (self.enabled) {
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $5b7018eaa860fc7e$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $5b7018eaa860fc7e$var$_triggers.length;
                    while(i--){
                        if ($5b7018eaa860fc7e$var$_triggers[i].scroller === scroller && $5b7018eaa860fc7e$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $5b7018eaa860fc7e$var$_removeListener(scroller, "resize", $5b7018eaa860fc7e$var$_onResize);
                    isViewport || $5b7018eaa860fc7e$var$_removeListener(scroller, "scroll", $5b7018eaa860fc7e$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $5b7018eaa860fc7e$var$_ids[id];
            var i = $5b7018eaa860fc7e$var$_triggers.indexOf(self);
            i >= 0 && $5b7018eaa860fc7e$var$_triggers.splice(i, 1);
            i === $5b7018eaa860fc7e$var$_i && $5b7018eaa860fc7e$var$_direction > 0 && $5b7018eaa860fc7e$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $5b7018eaa860fc7e$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $5b7018eaa860fc7e$var$_primary === self && ($5b7018eaa860fc7e$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $5b7018eaa860fc7e$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
                start || end || self.refresh();
            };
            $5b7018eaa860fc7e$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $5b7018eaa860fc7e$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$5b7018eaa860fc7e$var$_coreInitted) {
            $5b7018eaa860fc7e$var$gsap = core || $5b7018eaa860fc7e$var$_getGSAP();
            $5b7018eaa860fc7e$var$_windowExists() && window.document && ScrollTrigger.enable();
            $5b7018eaa860fc7e$var$_coreInitted = $5b7018eaa860fc7e$var$_enabled;
        }
        return $5b7018eaa860fc7e$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$5b7018eaa860fc7e$var$_defaults[p] = config[p];
        return $5b7018eaa860fc7e$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $5b7018eaa860fc7e$var$_enabled = 0;
        $5b7018eaa860fc7e$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$var$_win, "wheel", $5b7018eaa860fc7e$var$_onScroll);
        $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$var$_doc, "scroll", $5b7018eaa860fc7e$var$_onScroll);
        clearInterval($5b7018eaa860fc7e$var$_syncInterval);
        $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$var$_doc, "touchcancel", $5b7018eaa860fc7e$var$_passThrough);
        $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$var$_body, "touchstart", $5b7018eaa860fc7e$var$_passThrough);
        $5b7018eaa860fc7e$var$_multiListener($5b7018eaa860fc7e$var$_removeListener, $5b7018eaa860fc7e$var$_doc, "pointerdown,touchstart,mousedown", $5b7018eaa860fc7e$var$_pointerDownHandler);
        $5b7018eaa860fc7e$var$_multiListener($5b7018eaa860fc7e$var$_removeListener, $5b7018eaa860fc7e$var$_doc, "pointerup,touchend,mouseup", $5b7018eaa860fc7e$var$_pointerUpHandler);
        $5b7018eaa860fc7e$var$_resizeDelay.kill();
        $5b7018eaa860fc7e$var$_iterateAutoRefresh($5b7018eaa860fc7e$var$_removeListener);
        for(var i = 0; i < (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).length; i += 3){
            $5b7018eaa860fc7e$var$_wheelListener($5b7018eaa860fc7e$var$_removeListener, (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i], (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i + 1]);
            $5b7018eaa860fc7e$var$_wheelListener($5b7018eaa860fc7e$var$_removeListener, (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i], (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $5b7018eaa860fc7e$var$_win = window;
        $5b7018eaa860fc7e$var$_doc = document;
        $5b7018eaa860fc7e$var$_docEl = $5b7018eaa860fc7e$var$_doc.documentElement;
        $5b7018eaa860fc7e$var$_body = $5b7018eaa860fc7e$var$_doc.body;
        if ($5b7018eaa860fc7e$var$gsap) {
            $5b7018eaa860fc7e$var$_toArray = $5b7018eaa860fc7e$var$gsap.utils.toArray;
            $5b7018eaa860fc7e$var$_clamp = $5b7018eaa860fc7e$var$gsap.utils.clamp;
            $5b7018eaa860fc7e$var$_context = $5b7018eaa860fc7e$var$gsap.core.context || $5b7018eaa860fc7e$var$_passThrough;
            $5b7018eaa860fc7e$var$_suppressOverwrites = $5b7018eaa860fc7e$var$gsap.core.suppressOverwrites || $5b7018eaa860fc7e$var$_passThrough;
            $5b7018eaa860fc7e$var$_scrollRestoration = $5b7018eaa860fc7e$var$_win.history.scrollRestoration || "auto";
            $5b7018eaa860fc7e$var$_lastScroll = $5b7018eaa860fc7e$var$_win.pageYOffset || 0;
            $5b7018eaa860fc7e$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($5b7018eaa860fc7e$var$_body) {
                $5b7018eaa860fc7e$var$_enabled = 1;
                $5b7018eaa860fc7e$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $5b7018eaa860fc7e$var$_div100vh.style.height = "100vh";
                $5b7018eaa860fc7e$var$_div100vh.style.position = "absolute";
                $5b7018eaa860fc7e$var$_refresh100vh();
                $5b7018eaa860fc7e$var$_rafBugFix();
                (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).register($5b7018eaa860fc7e$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).isTouch;
                $5b7018eaa860fc7e$var$_fixIOSBug = (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $5b7018eaa860fc7e$var$_ignoreMobileResize = (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).isTouch === 1;
                $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$var$_win, "wheel", $5b7018eaa860fc7e$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $5b7018eaa860fc7e$var$_root = [
                    $5b7018eaa860fc7e$var$_win,
                    $5b7018eaa860fc7e$var$_doc,
                    $5b7018eaa860fc7e$var$_docEl,
                    $5b7018eaa860fc7e$var$_body
                ];
                if ($5b7018eaa860fc7e$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $5b7018eaa860fc7e$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $5b7018eaa860fc7e$var$gsap.addEventListener("matchMediaInit", function() {
                        $5b7018eaa860fc7e$var$_recordScrollPositions();
                        $5b7018eaa860fc7e$var$_revertAll();
                    });
                    $5b7018eaa860fc7e$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $5b7018eaa860fc7e$var$_revertRecorded();
                    });
                    $5b7018eaa860fc7e$var$gsap.addEventListener("matchMedia", function() {
                        $5b7018eaa860fc7e$var$_refreshAll(0, 1);
                        $5b7018eaa860fc7e$var$_dispatch("matchMedia");
                    });
                    $5b7018eaa860fc7e$var$gsap.matchMedia().add("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $5b7018eaa860fc7e$var$_setBaseDimensions();
                        return $5b7018eaa860fc7e$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $5b7018eaa860fc7e$var$_setBaseDimensions();
                $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$var$_doc, "scroll", $5b7018eaa860fc7e$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyHasStyle = $5b7018eaa860fc7e$var$_body.hasAttribute("style"), bodyStyle = $5b7018eaa860fc7e$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $5b7018eaa860fc7e$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $5b7018eaa860fc7e$var$_getBounds($5b7018eaa860fc7e$var$_body);
                (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
                if (!bodyHasStyle) {
                    // SSR frameworks like Next.js complain if this attribute gets added.
                    $5b7018eaa860fc7e$var$_body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
                    $5b7018eaa860fc7e$var$_body.removeAttribute("style");
                } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $5b7018eaa860fc7e$var$_syncInterval = setInterval($5b7018eaa860fc7e$var$_sync, 250);
                $5b7018eaa860fc7e$var$gsap.delayedCall(0.5, function() {
                    return $5b7018eaa860fc7e$var$_startup = 0;
                });
                $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$var$_doc, "touchcancel", $5b7018eaa860fc7e$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$var$_body, "touchstart", $5b7018eaa860fc7e$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $5b7018eaa860fc7e$var$_multiListener($5b7018eaa860fc7e$var$_addListener, $5b7018eaa860fc7e$var$_doc, "pointerdown,touchstart,mousedown", $5b7018eaa860fc7e$var$_pointerDownHandler);
                $5b7018eaa860fc7e$var$_multiListener($5b7018eaa860fc7e$var$_addListener, $5b7018eaa860fc7e$var$_doc, "pointerup,touchend,mouseup", $5b7018eaa860fc7e$var$_pointerUpHandler);
                $5b7018eaa860fc7e$var$_transformProp = $5b7018eaa860fc7e$var$gsap.utils.checkPrefix("transform");
                $5b7018eaa860fc7e$var$_stateProps.push($5b7018eaa860fc7e$var$_transformProp);
                $5b7018eaa860fc7e$var$_coreInitted = $5b7018eaa860fc7e$var$_getTime();
                $5b7018eaa860fc7e$var$_resizeDelay = $5b7018eaa860fc7e$var$gsap.delayedCall(0.2, $5b7018eaa860fc7e$var$_refreshAll).pause();
                $5b7018eaa860fc7e$var$_autoRefresh = [
                    $5b7018eaa860fc7e$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $5b7018eaa860fc7e$var$_win.innerWidth, h = $5b7018eaa860fc7e$var$_win.innerHeight;
                        if ($5b7018eaa860fc7e$var$_doc.hidden) {
                            $5b7018eaa860fc7e$var$_prevWidth = w;
                            $5b7018eaa860fc7e$var$_prevHeight = h;
                        } else if ($5b7018eaa860fc7e$var$_prevWidth !== w || $5b7018eaa860fc7e$var$_prevHeight !== h) $5b7018eaa860fc7e$var$_onResize();
                    },
                    $5b7018eaa860fc7e$var$_doc,
                    "DOMContentLoaded",
                    $5b7018eaa860fc7e$var$_refreshAll,
                    $5b7018eaa860fc7e$var$_win,
                    "load",
                    $5b7018eaa860fc7e$var$_refreshAll,
                    $5b7018eaa860fc7e$var$_win,
                    "resize",
                    $5b7018eaa860fc7e$var$_onResize
                ];
                $5b7018eaa860fc7e$var$_iterateAutoRefresh($5b7018eaa860fc7e$var$_addListener);
                $5b7018eaa860fc7e$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).length; i += 3){
                    $5b7018eaa860fc7e$var$_wheelListener($5b7018eaa860fc7e$var$_removeListener, (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i], (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i + 1]);
                    $5b7018eaa860fc7e$var$_wheelListener($5b7018eaa860fc7e$var$_removeListener, (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i], (0, $7951ad84588ee8e0$export$3cd1cee43d19b683)[i + 2]);
                }
            } else if ($5b7018eaa860fc7e$var$_doc) {
                var onLoad = function onLoad() {
                    ScrollTrigger.enable();
                    $5b7018eaa860fc7e$var$_doc.removeEventListener("DOMContentLoaded", onLoad);
                };
                $5b7018eaa860fc7e$var$_doc.addEventListener("DOMContentLoaded", onLoad);
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($5b7018eaa860fc7e$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($5b7018eaa860fc7e$var$_syncInterval) || ($5b7018eaa860fc7e$var$_syncInterval = ms) && setInterval($5b7018eaa860fc7e$var$_sync, ms);
        "ignoreMobileResize" in vars && ($5b7018eaa860fc7e$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $5b7018eaa860fc7e$var$_iterateAutoRefresh($5b7018eaa860fc7e$var$_removeListener) || $5b7018eaa860fc7e$var$_iterateAutoRefresh($5b7018eaa860fc7e$var$_addListener, vars.autoRefreshEvents || "none");
            $5b7018eaa860fc7e$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $7951ad84588ee8e0$export$937374fea3f88711)(target), i = (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).indexOf(t), isViewport = $5b7018eaa860fc7e$var$_isViewport(t);
        if (~i) (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $7951ad84588ee8e0$export$d8e56d510a804d0a).unshift($5b7018eaa860fc7e$var$_win, vars, $5b7018eaa860fc7e$var$_body, vars, $5b7018eaa860fc7e$var$_docEl, vars) : (0, $7951ad84588ee8e0$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $5b7018eaa860fc7e$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($5b7018eaa860fc7e$var$_isString(element) ? (0, $7951ad84588ee8e0$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $5b7018eaa860fc7e$var$_width : $5b7018eaa860fc7e$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $5b7018eaa860fc7e$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $5b7018eaa860fc7e$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $5b7018eaa860fc7e$var$_isString(element) && (element = (0, $7951ad84588ee8e0$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $5b7018eaa860fc7e$var$_width : $5b7018eaa860fc7e$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $5b7018eaa860fc7e$var$_keywords ? $5b7018eaa860fc7e$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $5b7018eaa860fc7e$var$_win.innerWidth : (bounds.top + offset) / $5b7018eaa860fc7e$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $5b7018eaa860fc7e$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $5b7018eaa860fc7e$var$_listeners.killAll || [];
            $5b7018eaa860fc7e$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$5b7018eaa860fc7e$export$875bcbe48555930.version = "3.15.0";
$5b7018eaa860fc7e$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $5b7018eaa860fc7e$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $5b7018eaa860fc7e$var$_savedStyles.indexOf(target);
            i >= 0 && $5b7018eaa860fc7e$var$_savedStyles.splice(i, 5);
            $5b7018eaa860fc7e$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $5b7018eaa860fc7e$var$gsap.core.getCache(target), $5b7018eaa860fc7e$var$_context());
        }
    }) : $5b7018eaa860fc7e$var$_savedStyles;
};
$5b7018eaa860fc7e$export$875bcbe48555930.revert = function(soft, media) {
    return $5b7018eaa860fc7e$var$_revertAll(!soft, media);
};
$5b7018eaa860fc7e$export$875bcbe48555930.create = function(vars, animation) {
    return new $5b7018eaa860fc7e$export$875bcbe48555930(vars, animation);
};
$5b7018eaa860fc7e$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $5b7018eaa860fc7e$var$_onResize(true) : ($5b7018eaa860fc7e$var$_coreInitted || $5b7018eaa860fc7e$export$875bcbe48555930.register()) && $5b7018eaa860fc7e$var$_refreshAll(true);
};
$5b7018eaa860fc7e$export$875bcbe48555930.update = function(force) {
    return ++(0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache && $5b7018eaa860fc7e$var$_updateAll(force === true ? 2 : 0);
};
$5b7018eaa860fc7e$export$875bcbe48555930.clearScrollMemory = $5b7018eaa860fc7e$var$_clearScrollMemory;
$5b7018eaa860fc7e$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $5b7018eaa860fc7e$var$_maxScroll(element, horizontal ? (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1) : (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d));
};
$5b7018eaa860fc7e$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $7951ad84588ee8e0$export$8665aac53dad5647)((0, $7951ad84588ee8e0$export$937374fea3f88711)(element), horizontal ? (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1) : (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d));
};
$5b7018eaa860fc7e$export$875bcbe48555930.getById = function(id) {
    return $5b7018eaa860fc7e$var$_ids[id];
};
$5b7018eaa860fc7e$export$875bcbe48555930.getAll = function() {
    return $5b7018eaa860fc7e$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$5b7018eaa860fc7e$export$875bcbe48555930.isScrolling = function() {
    return !!$5b7018eaa860fc7e$var$_lastScrollTime;
};
$5b7018eaa860fc7e$export$875bcbe48555930.snapDirectional = $5b7018eaa860fc7e$var$_snapDirectional;
$5b7018eaa860fc7e$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $5b7018eaa860fc7e$var$_listeners[type] || ($5b7018eaa860fc7e$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$5b7018eaa860fc7e$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $5b7018eaa860fc7e$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$5b7018eaa860fc7e$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $5b7018eaa860fc7e$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $5b7018eaa860fc7e$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($5b7018eaa860fc7e$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $5b7018eaa860fc7e$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($5b7018eaa860fc7e$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $5b7018eaa860fc7e$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $5b7018eaa860fc7e$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $5b7018eaa860fc7e$var$_docEl && _allowNativePanning($5b7018eaa860fc7e$var$_body, direction);
}, $5b7018eaa860fc7e$var$_overflow = {
    auto: 1,
    scroll: 1
}, $5b7018eaa860fc7e$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $5b7018eaa860fc7e$var$gsap.core.getCache(node), time = $5b7018eaa860fc7e$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $5b7018eaa860fc7e$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($5b7018eaa860fc7e$var$_overflow[(cs = $5b7018eaa860fc7e$var$_getComputedStyle(node)).overflowY] || $5b7018eaa860fc7e$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$5b7018eaa860fc7e$var$_isViewport(node) && ($5b7018eaa860fc7e$var$_overflow[(cs = $5b7018eaa860fc7e$var$_getComputedStyle(node)).overflowY] || $5b7018eaa860fc7e$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$5b7018eaa860fc7e$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $5b7018eaa860fc7e$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$var$_doc, (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).eventTypes[0], $5b7018eaa860fc7e$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$var$_doc, (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).eventTypes[0], $5b7018eaa860fc7e$var$_captureInputs, true);
        }
    });
}, $5b7018eaa860fc7e$var$_inputExp = /(input|label|select|textarea)/i, $5b7018eaa860fc7e$var$_inputIsFocused, $5b7018eaa860fc7e$var$_captureInputs = function _captureInputs(e) {
    var isInput = $5b7018eaa860fc7e$var$_inputExp.test(e.target.tagName);
    if (isInput || $5b7018eaa860fc7e$var$_inputIsFocused) {
        e._gsapAllow = true;
        $5b7018eaa860fc7e$var$_inputIsFocused = isInput;
    }
}, $5b7018eaa860fc7e$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $5b7018eaa860fc7e$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $7951ad84588ee8e0$export$937374fea3f88711)(vars.target) || $5b7018eaa860fc7e$var$_docEl, smoother = $5b7018eaa860fc7e$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $5b7018eaa860fc7e$var$_fixIOSBug && (vars.content && (0, $7951ad84588ee8e0$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $7951ad84588ee8e0$export$8665aac53dad5647)(target, (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d)), scrollFuncX = (0, $7951ad84588ee8e0$export$8665aac53dad5647)(target, (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b).isTouch && $5b7018eaa860fc7e$var$_win.visualViewport ? $5b7018eaa860fc7e$var$_win.visualViewport.scale * $5b7018eaa860fc7e$var$_win.visualViewport.width : $5b7018eaa860fc7e$var$_win.outerWidth) / $5b7018eaa860fc7e$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $5b7018eaa860fc7e$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $5b7018eaa860fc7e$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $5b7018eaa860fc7e$var$_passThrough, scrollClampY = $5b7018eaa860fc7e$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $5b7018eaa860fc7e$var$_maxScroll(target, (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d));
        scrollClampY = $5b7018eaa860fc7e$var$_clamp($5b7018eaa860fc7e$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $5b7018eaa860fc7e$var$_clamp(0, $5b7018eaa860fc7e$var$_maxScroll(target, (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1))));
        lastRefreshID = $5b7018eaa860fc7e$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $5b7018eaa860fc7e$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $5b7018eaa860fc7e$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $5b7018eaa860fc7e$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache;
                $5b7018eaa860fc7e$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $5b7018eaa860fc7e$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $5b7018eaa860fc7e$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $5b7018eaa860fc7e$var$_round(($5b7018eaa860fc7e$var$_win.visualViewport && $5b7018eaa860fc7e$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $5b7018eaa860fc7e$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $5b7018eaa860fc7e$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $7951ad84588ee8e0$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $5b7018eaa860fc7e$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $5b7018eaa860fc7e$var$_maxScroll(target, (0, $7951ad84588ee8e0$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $5b7018eaa860fc7e$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $5b7018eaa860fc7e$var$_maxScroll(target, (0, $7951ad84588ee8e0$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($5b7018eaa860fc7e$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $5b7018eaa860fc7e$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($5b7018eaa860fc7e$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $5b7018eaa860fc7e$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $5b7018eaa860fc7e$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $5b7018eaa860fc7e$var$_updateAll();
    };
    vars.onEnable = function() {
        $5b7018eaa860fc7e$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $5b7018eaa860fc7e$export$875bcbe48555930.addEventListener("refresh", onResize);
        $5b7018eaa860fc7e$var$_addListener($5b7018eaa860fc7e$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $5b7018eaa860fc7e$var$_allowNativePanning(target, true);
        $5b7018eaa860fc7e$var$_removeListener($5b7018eaa860fc7e$var$_win, "resize", onResize);
        $5b7018eaa860fc7e$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $5b7018eaa860fc7e$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $5b7018eaa860fc7e$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $5b7018eaa860fc7e$var$_fixIOSBug && $5b7018eaa860fc7e$var$gsap.ticker.add($5b7018eaa860fc7e$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $5b7018eaa860fc7e$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $5b7018eaa860fc7e$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $5b7018eaa860fc7e$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$5b7018eaa860fc7e$export$875bcbe48555930.sort = function(func) {
    if ($5b7018eaa860fc7e$var$_isFunction(func)) return $5b7018eaa860fc7e$var$_triggers.sort(func);
    var scroll = $5b7018eaa860fc7e$var$_win.pageYOffset || 0;
    $5b7018eaa860fc7e$export$875bcbe48555930.getAll().forEach(function(t) {
        return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + $5b7018eaa860fc7e$var$_win.innerHeight;
    });
    return $5b7018eaa860fc7e$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1000000);
    }); // anything with a containerAnimation should refresh last.
};
$5b7018eaa860fc7e$export$875bcbe48555930.observe = function(vars) {
    return new (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b)(vars);
};
$5b7018eaa860fc7e$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $5b7018eaa860fc7e$var$_normalizer;
    if (vars === true && $5b7018eaa860fc7e$var$_normalizer) return $5b7018eaa860fc7e$var$_normalizer.enable();
    if (vars === false) {
        $5b7018eaa860fc7e$var$_normalizer && $5b7018eaa860fc7e$var$_normalizer.kill();
        $5b7018eaa860fc7e$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $7951ad84588ee8e0$export$c1cbdee04e18ea8b) ? vars : $5b7018eaa860fc7e$var$_getScrollNormalizer(vars);
    $5b7018eaa860fc7e$var$_normalizer && $5b7018eaa860fc7e$var$_normalizer.target === normalizer.target && $5b7018eaa860fc7e$var$_normalizer.kill();
    $5b7018eaa860fc7e$var$_isViewport(normalizer.target) && ($5b7018eaa860fc7e$var$_normalizer = normalizer);
    return normalizer;
};
$5b7018eaa860fc7e$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $7951ad84588ee8e0$export$5de019f4480f0f8d),
    _inputObserver: $5b7018eaa860fc7e$var$_inputObserver,
    _scrollers: (0, $7951ad84588ee8e0$export$3cd1cee43d19b683),
    _proxies: (0, $7951ad84588ee8e0$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $5b7018eaa860fc7e$var$_lastScrollTime || $5b7018eaa860fc7e$var$_dispatch("scrollStart");
            $5b7018eaa860fc7e$var$_lastScrollTime = $5b7018eaa860fc7e$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $5b7018eaa860fc7e$var$_refreshing;
        }
    }
};
$5b7018eaa860fc7e$var$_getGSAP() && $5b7018eaa860fc7e$var$gsap.registerPlugin($5b7018eaa860fc7e$export$875bcbe48555930);


(0, $e96f038975c5d4d2$export$99ee26438460406a).registerPlugin((0, $5b7018eaa860fc7e$export$875bcbe48555930));
document.querySelectorAll("[data-gsap]").forEach((el)=>{
    const animationType = el.dataset.gsap;
    const start = el.dataset.gsapStart || "top bottom";
    const end = el.dataset.gsapEnd || "top top";
    const trigger = el.dataset.gsapTrigger || el;
    const duration = el.dataset.gsapDuration || 0.5;
    const scrub = el.dataset.gsapScrub != null;
    const offsetYTo = el.dataset.gsapOffsetYTo || 0;
    if (animationType === "fade-in") {
        const fromProperties = {
            opacity: 0
        };
        const toProperties = {
            opacity: 1
        };
        if (offsetYTo) {
            // Check if the value is a percentage or pixel value
            const isPercent = typeof offsetYTo === 'string' && offsetYTo.includes('%');
            const propertyName = isPercent ? 'yPercent' : 'y';
            const value = isPercent ? parseFloat(offsetYTo) : offsetYTo;
            fromProperties[propertyName] = 0;
            toProperties[propertyName] = value;
        }
        (0, $e96f038975c5d4d2$export$99ee26438460406a).fromTo(el, {
            ...fromProperties
        }, {
            ...toProperties,
            ease: "power2.out",
            scrollTrigger: {
                trigger: trigger,
                start: start,
                end: end,
                scrub: scrub,
                toggleActions: "play none none reverse"
            },
            duration: duration,
            immediateRender: false // important!
        });
    }
    if (animationType === "fade-out") {
        const fromProperties = {
            opacity: 1
        };
        const toProperties = {
            opacity: 0
        };
        if (offsetYTo) {
            // Check if the value is a percentage or pixel value
            const isPercent = typeof offsetYTo === 'string' && offsetYTo.includes('%');
            const propertyName = isPercent ? 'yPercent' : 'y';
            const value = isPercent ? parseFloat(offsetYTo) : offsetYTo;
            fromProperties[propertyName] = 0;
            toProperties[propertyName] = value;
        }
        (0, $e96f038975c5d4d2$export$99ee26438460406a).fromTo(el, {
            ...fromProperties
        }, {
            ...toProperties,
            scrollTrigger: {
                trigger: trigger,
                start: start,
                end: end,
                scrub: scrub,
                toggleActions: "play none none reverse"
            },
            duration: duration,
            immediateRender: false // important!
        });
    }
    if (animationType === "fade-in-out") {
        // Create a timeline for fade in and fade out
        const timeline = (0, $e96f038975c5d4d2$export$99ee26438460406a).timeline({
            scrollTrigger: {
                trigger: trigger,
                start: start,
                end: end,
                scrub: scrub
            }
        });
        // Fade in from 0 to 1 in the first half
        timeline.fromTo(el, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.5,
            ease: "power2.out"
        });
        // Fade out from 1 to 0 in the second half
        timeline.to(el, {
            opacity: 0,
            duration: 0.5,
            ease: "power2.in"
        });
    }
    if (animationType === "slide-in-left" || animationType === "slide-in-right") {
        // Distance is a percentage of the element's own width (xPercent).
        const distance = Math.abs(parseFloat(String(el.dataset.gsapDistance || 100)));
        const fromXPercent = animationType === "slide-in-left" ? -distance : distance;
        // Tie progress to scroll position. Start once the element enters,
        // finish when it is ~50% visible (its center reaches viewport center).
        const slideStart = el.dataset.gsapStart || "top 90%";
        const slideEnd = el.dataset.gsapEnd || "center 65%";
        const slideScrub = el.dataset.gsapScrub != null ? scrub : true;
        // Desktop only: the comparison image wrappers are hidden below 1023px,
        // so there is no slide animation on mobile. matchMedia reverts cleanly.
        (0, $e96f038975c5d4d2$export$99ee26438460406a).matchMedia().add("(min-width: 1023px)", ()=>{
            (0, $e96f038975c5d4d2$export$99ee26438460406a).fromTo(el, {
                opacity: 0,
                xPercent: fromXPercent
            }, {
                opacity: 1,
                xPercent: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: trigger,
                    start: slideStart,
                    end: slideEnd,
                    scrub: slideScrub
                },
                immediateRender: false
            });
        });
    }
    if (animationType === "reveal-up") {
        // Rises from an offset to its natural position (y:0) while fading in.
        // Only y/opacity are tweened so any CSS transform (e.g. rotate) is preserved.
        const offset = parseFloat(String(el.dataset.gsapOffsetY || 60));
        const revealStart = el.dataset.gsapStart || "top 75%";
        (0, $e96f038975c5d4d2$export$99ee26438460406a).fromTo(el, {
            opacity: 0,
            y: offset
        }, {
            opacity: 1,
            y: 0,
            ease: "power2.out",
            scrollTrigger: {
                trigger: trigger,
                start: revealStart,
                end: end,
                scrub: scrub,
                toggleActions: "play none none reverse"
            },
            duration: duration,
            // Apply the hidden from-state on load so it doesn't flash the
            // element in its natural position before the reveal triggers.
            immediateRender: true
        });
    }
    if (animationType === "fly-in") {
        // Flies in from an x/y offset (px) while fading in, with a slight
        // overshoot for a playful "drop into place" feel. Only x/y/opacity are
        // tweened so a CSS float/transform on a child element is unaffected.
        const flyX = parseFloat(String(el.dataset.gsapFlyX || 0));
        const flyY = parseFloat(String(el.dataset.gsapFlyY || 60));
        const flyStart = el.dataset.gsapStart || "top 85%";
        const flyDuration = parseFloat(String(el.dataset.gsapDuration || 0.8));
        (0, $e96f038975c5d4d2$export$99ee26438460406a).fromTo(el, {
            opacity: 0,
            x: flyX,
            y: flyY
        }, {
            opacity: 1,
            x: 0,
            y: 0,
            ease: "back.out(1.4)",
            scrollTrigger: {
                trigger: trigger,
                start: flyStart,
                end: end,
                scrub: scrub,
                toggleActions: "play none none reverse"
            },
            duration: flyDuration,
            // Apply the hidden from-state on load so it doesn't flash in its
            // natural position before the fly-in triggers.
            immediateRender: true
        });
    }
    if (animationType === "color-transition") {
        const colorFrom = el.dataset.gsapColorFrom || "red";
        const colorTo = el.dataset.gsapColorTo || "blue";
        const cssVar = el.dataset.gsapCssVar;
        console.log(trigger);
        if (cssVar) (0, $e96f038975c5d4d2$export$99ee26438460406a).fromTo(el, {
            [cssVar]: colorFrom
        }, {
            [cssVar]: colorTo,
            ease: "power2.in",
            scrollTrigger: {
                trigger: '.qr-intro',
                start: 'bottom 80%',
                end: 'bottom 15%',
                scrub: scrub,
                toggleActions: "play none none reverse"
            },
            duration: duration,
            immediateRender: false
        });
    }
// You can extend this to support more animation types
});
window.addEventListener('load', ()=>{
    (0, $5b7018eaa860fc7e$export$875bcbe48555930).refresh(); // recalculate trigger positions after everything is loaded
});


(0, (/*@__PURE__*/$parcel$interopDefault($a6e6748126aae905$exports))).init({
    disable: 'mobile'
});

})();
//# sourceMappingURL=main.js.map
